﻿// ------------------------------------------------------------------------------------------------
// -- Class: Occurrences   ------------------------------------------------------------------------
// -- File : occurrence.js ------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------

import { Utility } from "./Utility";
import { Upload } from "./upload";
import Overlay from 'ol/Overlay.js';
import Feature from 'ol/Feature.js';
import Circle from 'ol/geom/Circle.js';
import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
import { Email } from "./email";
export { Occurrences };

/**
 * Class Occurrence
 */
const Occurrences = function () {

    //Define this
    var myOccurrences = this;

    var Layeinterventionzone = "";

    // -- begin public variable -------------------------------------------------------------------

    // Upload object
    this.UploadAttachtment = new Upload();

    // -- end public variable ---------------------------------------------------------------------

    // -- begin private variable ------------------------------------------------------------------

    //Set zoom on search occurrence 
    this.ZoomSearch = 10;

    // Hash that contains all reference 
    this._hashReference = {};

    // All event found in search
    this._eventsOccurrenceDetail = {};

    // Utility
    this._utility = new Utility();

    // Array all id occurrence search result
    this._arrayIdOccurrence = [];

    // Array all id occurrence search result
    this._arrayIdEventOccurrence = [];

    //Object to save all teams selected
    this._arrayTeamsSelected = [];

    // Map
    this._mapSgs = null;

    // Feature search active
    this._arraySearchFeatureActive = null;

    // Chekbox occurrence active visible occurrence search obj
    this._searchCheckbox = null;

    // Collapse occurence Register
    this._detailRegisterCollapse = false;

    // Collapse occurrence historic state
    this._detailRegisterDate = false;

    // Collapse occurence Team add 
    this._detailTeamRegister = false;

    // Key separator for comment
    this._keySeparator = '|';

    // Table event occurrence
    this._tableDetailEventOccurrence = null;

    // Table event relation with occurrence
    this._datatableDetailOccurrenceRelationEvent = null;

    // Table event with all neighbor occurrence
    this._datatableDetailNeighborOccurrenceToEvent = null;

    // Table of occurrence event from occurrence
    this._datatableOccurrenceEventFromOccurrence = null;

    // Table occurrence report event
    this._datatableOccurrenceReportEvent = null;

    // Table occurrence report timeline
    this._datatableOccurrenceReportTimeline = null

    // Table occurence report global event
    this._datatableOccurrenceReportGlobalEvent = null;

    // Table occurence report global
    this._datatableOccurrenceReportGlobal = null;

    // Layer name key freguesia
    this._layerNameKeyFreguesia = "";

    // Layer event occurrence information
    this._layerInfoEventOccurrence = null;

    // Layer info occurrence information array
    this._layerInfoOccurrenceArray = [];

    // Layer event occurrence information array
    this._layerInfoEventOccurrenceArray = null;

    // Datatable search result
    this._datatableSearchResult = null;

    // Datatable search result expand
    this._datatableSearchResultExpand = null;

    // Workspace occurrence
    this._workspace = "";

    // Layer name occurrence
    this._layerNameOccurrence = "occurrence";

    // Layer name occurrence event
    this._layerNameOccurrenceEvent = "occurrence_event";

    // Layer name source occurrence
    this._layerSourceNameOccurrence = "vw_occurrence";

    // Layer name source occurrence event
    this._layerSourceNameOccurrenceEvent = "vw_occurrence_event";

    // Buffer style
    this._bufferstyle = null;

    // Buffer layer
    this._layerDrawPoint = null;

    // Buffer slide
    this._bufferSlide = null;

    // Occurrence event selected
    this._occurrenceEventFeatureSelected = null;

    // Datatable occurrence state hist
    this._datatableDetailOccurrenceStateHist = null;

    // Datatable occurrence event state hist
    this._datatableDetailOccurrenceEventStateHist = null;

    // Datatable definition department team name
    this._datatableDetailOccurrenceTeam = null;

    // Datable definition department team name checked
    this._datatableDetailOccurrenceTeamCheck = null;

    // User information for Notification
    this._occurrenceEventEmailNotificationInfo = null;

    // Email class
    this._email = new Email();

    // Last form save from occurrence event state
    this._occurrenceEventFormState = "";

    //array e-mails state
    this._emailsArraytooltip = null;

    //data occurrence interventio zone
    var occurrenceinterventiozoneData = "";
    
    // Default highlight style
    this._eventOccurrenceHighlighStyles = [
        new Style({
            image: new CircleStyle({
                radius: 8,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 0, 0.7)',
                    width: 5
                }),
                fill: new Fill({
                    color: 'rgba(0, 0, 255, 0.2)'
                })
            }),
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 0.2)',
                width: 14
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 255, 0.2)'
            })
        })
    ];

    // Default highlight style
    this._occurrenceHighlighStyles = [
        new Style({
            image: new CircleStyle({
                radius: 16,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 0, 0.7)',
                    width: 5
                }),
                fill: new Fill({
                    color: 'rgba(0, 0, 255, 0.2)'
                })
            }),
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 0.2)',
                width: 14
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 255, 0.2)'
            })
        })
    ];

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Search occurrence
     */
    this.SearchOccurrence = function () {

        // Start wait
        myOccurrences._utility.ShowWait('offcanvas-map-spinner', true);

        // Split date begin to convert to int
        var searchDateBeginInt = $('#occurrence-search-date-begin').val().split('-').join('');
        var searchDateEndInt = $('#occurrence-search-date-end').val().split('-').join('');
        var searchStateDateBeginInt = $('#occurrence-search-state-date-begin').val().split('-').join('');
        var searchStateDateEndInt = $('#occurrence-search-state-date-end').val().split('-').join('');

        // Data estimada e efetiva
        var searchStateDateEstimatedBeginInt = ($('#occurrence-search-date-estimated-start').val() === undefined)?"":$('#occurrence-search-date-estimated-start').val().split('-').join('');
        var searchStateDateEstimatedEndInt = ($('#occurrence-search-date-estimated-end').val() === undefined)?"":$('#occurrence-search-date-estimated-end').val().split('-').join('');

        var searchStateDateEffectiveBeginInt = ($('#occurrence-search-date-effective-start').val() === undefined)?"":$('#occurrence-search-date-effective-start').val().split('-').join('');
        var searchStateDateEffectiveEndInt = ($('#occurrence-search-date-effective-end').val() === undefined)?"":$('#occurrence-search-date-effective-end').val().split('-').join('');
        // FIm data estimada e efetiva

        var _occurrenceSearchForm = $('#form-search-occurrence').serializeJSON();

        // Convert date to int
        _occurrenceSearchForm.date_creation_begin = parseInt(searchDateBeginInt);
        _occurrenceSearchForm.date_creation_end = parseInt(searchDateEndInt);
        _occurrenceSearchForm.date_state_begin = parseInt(searchStateDateBeginInt);
        _occurrenceSearchForm.date_state_end = parseInt(searchStateDateEndInt);

        _occurrenceSearchForm.date_estimated_begin = parseInt(searchStateDateEstimatedBeginInt);
        _occurrenceSearchForm.date_estimated_end = parseInt(searchStateDateEstimatedEndInt);
        _occurrenceSearchForm.date_effective_begin = parseInt(searchStateDateEffectiveBeginInt);
        _occurrenceSearchForm.date_effective_end = parseInt(searchStateDateEffectiveEndInt);

        // Check to list last
        _occurrenceSearchForm.last_event = $('#id-occurrence-search-last-event')[0].checked;
        _occurrenceSearchForm.number_last_event = 20;
        if (_occurrenceSearchForm.last_event)
            _occurrenceSearchForm.cod_state = 'ABERTA';

        $.ajax({
            type: 'POST',
            url: '/rest/app/Occurrence/SearchOccurrence',
            data: JSON.stringify(_occurrenceSearchForm),
            dataType: 'json',
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na pesquisa de ocorrências");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            if (data.result.list_occurrence.length > 0) {
                                var countElement = data.result.list_occurrence.length;
                                // Clear array ids occurrence
                                myOccurrences._arrayIdOccurrence = [];
                                // Build column value
                                var columnValueArray = [];
                                for (var i = 0; i < countElement; i++) {
                                    var objEvent = data.result.list_occurrence[i];
                                    objEvent.date_creation = myOccurrences._utility.TransformDateServerInDateII(objEvent.date_creation);
                                    objEvent.date_state = myOccurrences._utility.TransformDateServerInDateII(objEvent.date_state);
                                    myOccurrences._arrayIdOccurrence.push(objEvent.id);

                                    var objRow = {};
                                    for (var j = 0; j < Object.keys(objEvent).length; j++) {
                                        var columnName = Object.keys(objEvent)[j];
                                        objRow[columnName] = objEvent[columnName];
                                    }
                                    // Add primary key value
                                    objRow["id_primary_key"] = objEvent.id;
                                    columnValueArray.push(objRow);
                                }

                                // Get layer search occurrence information
                                var workspaceOccurrenceConfig = myOccurrences._utility.GetPropertyInfoInConfigArray(myOccurrences._mapSgs.getSettings().configurationInfo.propertyInfo, "OCCURRENCE", "SEARCH_OCCURRENCE", "WORKSPACE");
                                var workspaceOccurrence = (workspaceOccurrenceConfig === undefined)?myOccurrences._workspace:workspaceOccurrenceConfig.value;
                                var layerOccurrenceConfig = myOccurrences._utility.GetPropertyInfoInConfigArray(myOccurrences._mapSgs.getSettings().configurationInfo.propertyInfo, "OCCURRENCE", "SEARCH_OCCURRENCE", "LAYER");
                                var layerOccurrence = (layerOccurrenceConfig === undefined)?myOccurrences._layerSourceNameOccurrence:layerOccurrenceConfig.value;
                                var layerTableName = (layerOccurrenceConfig === undefined)?myOccurrences._layerNameOccurrence:layerOccurrenceConfig.value;
                                var geoserverOccurrenceConfig = myOccurrences._utility.GetPropertyInfoInConfigArray(myOccurrences._mapSgs.getSettings().configurationInfo.propertyInfo, "OCCURRENCE", "SEARCH_OCCURRENCE", "GEOSERVER");
                                var geoserverOccurrence = "";
                                if(geoserverOccurrenceConfig === undefined)
                                {
                                    var layerInfoOccurrence  = myOccurrences._mapSgs.layerTree.FindLayerInfo(layerOccurrence);
                                    geoserverOccurrence = layerInfoOccurrence.geoserver;
                                }
                                else
                                    geoserverOccurrence = geoserverOccurrenceConfig.value;

                                // Build datatable
                                var hashColumDefinition = myOccurrences._GetOccurrenceColumnDefinitionSearchResult();
                                myOccurrences._BuildSearhResultInDatatable(layerTableName, hashColumDefinition.column_definition, hashColumDefinition.column_definition_expand, columnValueArray, myOccurrences._DetailOccurrence);

                                // Highlight all occurrence
                                myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear();
                                myOccurrences._mapSgs.SetFeaturesHighlightByArray2(workspaceOccurrence, layerOccurrence, geoserverOccurrence, false, myOccurrences._arrayIdOccurrence, myOccurrences._occurrenceHighlighStyles, "geom", true, true);

                                // Go to Feature
                                myOccurrences._mapSgs.map.getView().fit(myOccurrences._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myOccurrences._mapSgs.map.getSize() });
                                if (myOccurrences._arrayIdOccurrence.length == 1)
                                    if (myOccurrences._arrayIdOccurrence.length == 1) {
                                        myOccurrences._mapSgs.map.getView({
                                            center: [myOccurrences._mapSgs.layerHighlightOverlay.getSource().getExtent()[0], myOccurrences._mapSgs.layerHighlightOverlay.getSource().getExtent()[1]]
                                        });
                                        myOccurrences._mapSgs.map.getView().setZoom(myOccurrences.ZoomSearch)
                                    }
                                    //myOccurrences._mapSgs.map.getView().setResolution("2.8");

                                // Save feature Search
                                myOccurrences._arraySearchFeatureActive = [];
                                for (var j = 0; j < myOccurrences._mapSgs.featureToHighLight.getArray().length; j++) {
                                    myOccurrences._arraySearchFeatureActive.push(myOccurrences._mapSgs.featureToHighLight.getArray()[j]);
                                }

                                // Remove hide in offcanvas search result information
                                $('#id-offcanvas-search-result-zone').removeClass('ol-hidden');
                                $('#id-offcanvas-search-result-body').removeClass('ol-hidden');

                                // Show canvas search result
                                myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-search-result'], true);

                                // Ajust table
                                $($.fn.dataTable.tables(true)).DataTable().columns.adjust();

                                // Set mode search
                                $('#id-search-result-detail-info-number-result').attr('mode', 'vw_occurrence');
                                $('#id-offcanvas-search-result-goto').attr('mode', 'vw_occurrence');

                                // Set subtitle
                                $('#id-occurrence-search-header-subtitle').html("Ocorrência");
                                $('#id-offcanvas-map-list-subtitle').html(" - Ocorrência");

                                if (countElement === 1)
                                    toastr["success"]("Encontrado " + countElement + " ocorrência");
                                else
                                    toastr["success"]("Encontrados " + countElement + " ocorrências");

                                $('#id-search-result-detail-info-number-result').removeClass('hide-highlight');

                            } else {
                                toastr["warning"]("Nenhuma ocorrência encontrada"); 
                            }                               
                            break;
                        case 'NOT_FOUND':
                            toastr["warning"]("Nenhuma ocorrência encontrada");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na pesquisa de ocorrências");
                            break;
                        default:
                    }
                }
                // Stop wait
                myOccurrences._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na pesquisa de ocorrências");
                // Stop wait
                myOccurrences._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    };

    /**
     * Event occurrence
     * Search Event occurrence
     */
    this.SearchOccurrenceEvent = function () {

        // Start wait
        myOccurrences._utility.ShowWait('offcanvas-map-spinner', true);

        // Split date begin to convert to int
        var searchDateBeginInt = $('#id-event-occurrence-search-date-begin').val().split('-').join('');
        var searchDateEndInt = $('#id-event-occurrence-search-date-end').val().split('-').join('');

        // Id User to get all Events
        var iduser = myOccurrences._mapSgs._settings.userInfo.userId;

        var _occurrenceEventSearchForm = $('#id-form-search-occurrence-event').serializeJSON();

        // Convert date to int
        _occurrenceEventSearchForm.date_creation_begin = parseInt(searchDateBeginInt);
        _occurrenceEventSearchForm.date_creation_end = parseInt(searchDateEndInt);
        _occurrenceEventSearchForm.id_user = parseInt(iduser);

        // Check to list last
         _occurrenceEventSearchForm.last_event = $('#id-event-occurrence-search-last-event')[0].checked;
        _occurrenceEventSearchForm.number_last_event = 20;
        if (_occurrenceEventSearchForm.last_event)
            _occurrenceEventSearchForm.cod_state = 'EM_ANALISE';

        $.ajax({
            type: 'POST',
            url: '/rest/app/Occurrence/SearchOccurrenceEvent',
            data: JSON.stringify(_occurrenceEventSearchForm),
            dataType: 'json',
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na pesquisa de eventos de ocorrência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            var countElement = data.result.list_occurrence_event.length;
                            // Clear datatable
                            if (myOccurrences._datatableSearchResult)
                                myOccurrences._datatableSearchResult.clear().draw();
                            if (myOccurrences._datatableSearchResultExpand)
                                myOccurrences._datatableSearchResultExpand.clear().draw();
                            // Clear array ids occurrence
                            myOccurrences._arrayIdOccurrence = [];
                            var columnValueArray = [];
                            // Build column value
                            for (var i = 0; i < countElement; i++) {
                                var objEvent = data.result.list_occurrence_event[i];
                                objEvent.date_creation = myOccurrences._utility.TransformDateServerInDateII(objEvent.date_creation);
                                objEvent.date_state = myOccurrences._utility.TransformDateServerInDateII(objEvent.date_state);
                                myOccurrences._arrayIdOccurrence.push(objEvent.id);

                                var objRow = {};
                                for (var j = 0; j < Object.keys(objEvent).length; j++) {
                                    var columnName = Object.keys(objEvent)[j];
                                    objRow[columnName] = objEvent[columnName];
                                }
                                // Add primary key value
                                objRow["id_primary_key"] = objEvent.id;
                                columnValueArray.push(objRow);
                            }

                            // Get layer search occurrence event information
                            var workspaceOccurrenceEventConfig = myOccurrences._utility.GetPropertyInfoInConfigArray(myOccurrences._mapSgs.getSettings().configurationInfo.propertyInfo, "OCCURRENCE", "SEARCH_OCCURRENCE_EVENT", "WORKSPACE");
                            var workspaceOccurrenceEvent = (workspaceOccurrenceEventConfig === undefined)?myOccurrences._workspace:workspaceOccurrenceEventConfig.value;
                            var layerOccurrenceEventConfig = myOccurrences._utility.GetPropertyInfoInConfigArray(myOccurrences._mapSgs.getSettings().configurationInfo.propertyInfo, "OCCURRENCE", "SEARCH_OCCURRENCE_EVENT", "LAYER");
                            var layerOccurrenceEvent = (layerOccurrenceEventConfig === undefined)?myOccurrences._layerSourceNameOccurrenceEvent:layerOccurrenceEventConfig.value;
                            var layerTableNameEvent = (layerOccurrenceEventConfig === undefined)?myOccurrences._layerSourceNameOccurrenceEvent:layerOccurrenceEventConfig.value;
                            var geoserverOccurrenceEventConfig = myOccurrences._utility.GetPropertyInfoInConfigArray(myOccurrences._mapSgs.getSettings().configurationInfo.propertyInfo, "OCCURRENCE", "SEARCH_OCCURRENCE_EVENT", "GEOSERVER");
                            var geoserverOccurrenceEvent = "";
                            if(geoserverOccurrenceEventConfig === undefined)
                            {
                                var layerInfoOccurrenceEvent  = myOccurrences._mapSgs.layerTree.FindLayerInfo(layerOccurrenceEvent);
                                geoserverOccurrenceEvent = layerInfoOccurrenceEvent.geoserver;
                            }
                            else
                                geoserverOccurrenceEvent = geoserverOccurrenceEventConfig.value;

                            // Build datatable
                            var hashColumDefinition = myOccurrences._GetOccurrenceEventColumnDefinitionSearchResult();
                            myOccurrences._BuildSearhResultInDatatable(layerTableNameEvent, hashColumDefinition.column_definition, hashColumDefinition.column_definition_expand, columnValueArray, myOccurrences._DetailOccurrence);

                            // Highlight all occurrence event
                            myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear();
                            myOccurrences._mapSgs.SetFeaturesHighlightByArray2(workspaceOccurrenceEvent, layerOccurrenceEvent, geoserverOccurrenceEvent, false, myOccurrences._arrayIdOccurrence, myOccurrences._eventOccurrenceHighlighStyles, "geom", true, true);

                            // Go to Feature
                            myOccurrences._mapSgs.map.getView().fit(myOccurrences._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myOccurrences._mapSgs.map.getSize() });

                            if (myOccurrences._arrayIdOccurrence.length == 1) {
                                myOccurrences._mapSgs.map.getView({
                                    center: [myOccurrences._mapSgs.layerHighlightOverlay.getSource().getExtent()[0], myOccurrences._mapSgs.layerHighlightOverlay.getSource().getExtent()[1]]
                                });
                                myOccurrences._mapSgs.map.getView().setZoom(myOccurrences.ZoomSearch)
                            }

                                //myOccurrences._mapSgs.map.getView().setResolution("2.8");

                            // Save feature Search
                            myOccurrences._arraySearchFeatureActive = [];
                            for (var j = 0; j < myOccurrences._mapSgs.featureToHighLight.getArray().length; j++) {
                                myOccurrences._arraySearchFeatureActive.push(myOccurrences._mapSgs.featureToHighLight.getArray()[j]);
                            }

                            // Remove hide in offcanvas search result information
                            $('#id-offcanvas-search-result-zone').removeClass('ol-hidden');
                            $('#id-offcanvas-search-result-body').removeClass('ol-hidden');

                            // Show canvas search result
                            myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-search-result'], true);

                            // Ajust table
                            $($.fn.dataTable.tables(true)).DataTable().columns.adjust();

                            // Set mode search
                            $('#id-search-result-detail-info-number-result').attr('mode', 'vw_occurrence_event');
                            $('#id-offcanvas-search-result-goto').attr('mode', 'vw_occurrence_event');

                            $('#id-search-result-detail-info-number-result').removeClass('hide-highlight');

                            // Set subtitle
                            $('#id-occurrence-search-header-subtitle').html("Evento de ocorrência");
                            $('#id-offcanvas-map-list-subtitle').html(" - Evento de ocorrência");

                            if (countElement === 1)
                                toastr["success"]("Encontrado " + countElement + " evento de ocorrência");
                            else
                                toastr["success"]("Encontrados " + countElement + " eventos de ocorrência");
                            break;
                        case 'NOT_FOUND':
                            toastr["warning"]("Nenhum evento de ocorrência encontrado");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na pesquisa de eventos de ocorrências");
                            break;
                        default:
                    }
                }
                // Stop wait
                myOccurrences._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na pesquisa de eventos de ocorrências");
                // Stop wait
                myOccurrences._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    };

    /**
     * Init Occurrence
     * @param {MapSgs} mapSgs, Map sgs class
     */
    this.InitOccurrences = function (mapSgs) {

        // Get Map
        myOccurrences._mapSgs = mapSgs;

        // -- Init email --
        myOccurrences._email.InitEmail();

        // -- Workspace default -- TODO: Alterar isto no futuro pq não podemos continuar a usar o mesmo workspace da toponímia
        this._workspace = myOccurrences._mapSgs._settings.searchToponymy.workspaceSearchToponymy;

        // -- Set class in search canvas ----------------------------------------------------------
        $('#id-offcanvas-search-result-goto').addClass('occurrence-search');
        $('#id-search-result-detail-info-number-result').addClass('occurrence-search');

        // Add subtitle to search
        $('#offcanvas-search-result header').addClass('occurrence-search-header');
        $('#offcanvas-search-result header').append($('<span id="id-occurrence-search-header-subtitle" class="occurrence-search-header-subtitle"></span>'))

        var tabs = $('#map-search .nav-tabs a');
        tabs.each(function (el) {
            var tab = $(tabs[el]);
            var tabFor = tab.attr('href');

            if (tabFor === '#occurrence-search') {

                tab.on('click', function ()
                {
                    var toggleHighlightBtn = $('#id-search-result-detail-info-number-result');
                    var searchGoTo = $('#id-offcanvas-search-result-goto');
                    if (!toggleHighlightBtn.hasClass('occurrence-search')) {
                        toggleHighlightBtn.addClass('occurrence-search');
                    }
                    if (!searchGoTo.hasClass('occurrence-search')) {
                        searchGoTo.addClass('occurrence-search');
                    }
                });

            } else {
                tab.on('click', function () {
                    $('#id-search-result-detail-info-number-result').removeClass('occurrence-search');
                    $('#id-offcanvas-search-result-goto').removeClass('occurrence-search');
                });
            }
        });

        // Event search result show/hide highlight
        $('#id-search-result-detail-info-number-result.occurrence-search').on('click', function ()
        {
            var mode = $(this).attr('mode');

            if ($(this).hasClass('hide-highlight')) {
                $(this).removeClass('hide-highlight');

                var styleHighLight = null;

                // set Info
                switch (mode) {
                    case "vw_occurrence_event":
                        styleHighLight = myOccurrences._eventOccurrenceHighlighStyles;
                        break;
                    case "vw_occurrence":
                        styleHighLight = myOccurrences._occurrenceHighlighStyles;
                        break;
                };

                myOccurrences._mapSgs.SetFeaturesHighlightByFeatureCol(myOccurrences._arraySearchFeatureActive, false, styleHighLight);
            }
            else {
                $(this).addClass('hide-highlight');
                myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear(mode);
            }
        });

        // Event search result go to extent
        $('#id-offcanvas-search-result-goto.occurrence-search').on('click', function ()
        {
            if (myOccurrences._arraySearchFeatureActive.length > 0)
            {
                var mode = $(this).attr('mode');

                // Highlight all occurrence
                myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear();

                switch (mode) {
                    case "vw_occurrence_event":
                        myOccurrences._mapSgs.SetFeaturesHighlightByFeatureCol(myOccurrences._arraySearchFeatureActive, true);
                        break;
                    case "vw_occurrence":
                        // Get layer search occurrence information
                        var workspaceOccurrenceConfig = myOccurrences._utility.GetPropertyInfoInConfigArray(myOccurrences._mapSgs.getSettings().configurationInfo.propertyInfo, "OCCURRENCE", "SEARCH_OCCURRENCE", "WORKSPACE");
                        var workspaceOccurrence = (workspaceOccurrenceConfig === undefined)?myOccurrences._workspace:workspaceOccurrenceConfig.value;
                        var layerOccurrenceConfig = myOccurrences._utility.GetPropertyInfoInConfigArray(myOccurrences._mapSgs.getSettings().configurationInfo.propertyInfo, "OCCURRENCE", "SEARCH_OCCURRENCE", "LAYER");
                        var layerOccurrence = (layerOccurrenceConfig === undefined)?myOccurrences._layerSourceNameOccurrence:layerOccurrenceConfig.value;
                        var geoserverOccurrenceConfig = myOccurrences._utility.GetPropertyInfoInConfigArray(myOccurrences._mapSgs.getSettings().configurationInfo.propertyInfo, "OCCURRENCE", "SEARCH_OCCURRENCE", "GEOSERVER");
                        var geoserverOccurrence = "";
                        if(geoserverOccurrenceConfig === undefined)
                        {
                            var layerInfoOccurrence  = myOccurrences._mapSgs.layerTree.FindLayerInfo(layerOccurrence);
                            geoserverOccurrence = layerInfoOccurrence.geoserver;
                        }
                        else
                            geoserverOccurrence = geoserverOccurrenceConfig.value;

                        myOccurrences._mapSgs.SetFeaturesHighlightByArray2(workspaceOccurrence, layerOccurrence, geoserverOccurrence, false, myOccurrences._arrayIdOccurrence, myOccurrences._occurrenceHighlighStyles, "geom", true, true);
                        break;
                };
                                
                // Fit to occurrence or event occurrence
                myOccurrences._mapSgs.map.getView().fit(myOccurrences._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myOccurrences._mapSgs.map.getSize() });
                if (myOccurrences._arraySearchFeatureActive.length === 1) {
                    myOccurrences._mapSgs.map.getView({
                        center: [myOccurrences._mapSgs.layerHighlightOverlay.getSource().getExtent()[0], myOccurrences._mapSgs.layerHighlightOverlay.getSource().getExtent()[1]]
                    });
                    myOccurrences._mapSgs.map.getView().setZoom(myOccurrences.ZoomSearch)
                }

                // Reset info number btn
                if ($('#id-search-result-detail-info-number-result').hasClass('hide-highlight'))
                    $('#id-search-result-detail-info-number-result').removeClass('hide-highlight');
            }
        });

        // -- Init checkbox search occurrence -----------------------------------------------------
        //this._searchCheckbox = $('#offcanvas-search-event-layer-visible').checkbox().state('checked');

        // -- Init occurence data begin -----------------------------------------------------------
        $('#occurrence-search-date-begin').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Init occurence data end -------------------------------------------------------------
        $('#occurrence-search-date-end').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Init state occurence data begin -----------------------------------------------------
        $('#occurrence-search-state-date-begin').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Init state occurence data end -------------------------------------------------------
        $('#occurrence-search-state-date-end').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Init state occurence evet data begin ------------------------------------------------
        $('#id-event-occurrence-search-date-begin').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Init state occurence event data end -------------------------------------------------
        $('#id-event-occurrence-search-date-end').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        //START Date occurrence without event occurrence

        // -- Init planned occurence data start -------------------------------------------------
        $('#occurrence-date-planned-start').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Init planned occurence data end -------------------------------------------------
        $('#occurrence-date-planned-end').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Init planned occurence estimated data start -------------------------------------------------
        $('#occurrence-search-date-estimated-start').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Init planned occurence estimated data end -------------------------------------------------
        $('#occurrence-search-date-estimated-end').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Init planned occurence effective data start -------------------------------------------------
        $('#occurrence-search-date-effective-start').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Init planned occurence effective data end -------------------------------------------------
        $('#occurrence-search-date-effective-end').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        //END occurrence without event occurrence

        // -- Get layer info occurrence -----------------------------------------------------------
        myOccurrences._layerInfoOccurrenceArray = myOccurrences._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(myOccurrences._layerSourceNameOccurrence);

        // -- Get layer info event occurrence -----------------------------------------------------
        myOccurrences._layerInfoEventOccurrenceArray = myOccurrences._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(myOccurrences._layerSourceNameOccurrenceEvent);

        // -- Init buffer -------------------------------------------------------------------------
        myOccurrences._InitBuffer();

        // -- Init occurence report data begin -----------------------------------------------------------
        $('#occurrence-report-date-begin').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Init occurence report data end -------------------------------------------------------------
        $('#occurrence-report-date-end').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Datatable Event Occurrence On Map Occurrence ----------------------------------------

        // -- init column def --
        this._columnDefEventOccurrence = [];
        // Goto button
        this._objDef =
            {
                'name': 'button_config_element',
                'data': null,
                'orderable': false,
                'className': 'dt-body-center',
                'defaultContent': '<a class="button-goto-occurrence" title="Ir para a posição da ocorrência"><i class="zmdi zmdi-gps-dot" style="color: #ff3d00"></i></a>',
                'width': '3%'
            };
        this._columnDefEventOccurrence.push(this._objDef);
        //record button
        this._objDef =
            {
                'name': 'button_config_element',
                'data': null,
                'orderable': false,
                'className': 'dt-body-center',
                'defaultContent': '<a class="button_detail_occurrence" title="Ir para o detalhe da ocorrência"><i class="gpi gpi-info" style="color: #ff3d00"></i></a>',
                'width': '3%'
            };
        this._columnDefEventOccurrence.push(this._objDef);
        // id
        this._objDef = {
            'data': 'id',
            'title': 'Id',
            'name': 'Id',
            'label': 'Id',
            'type': 'readonly',
            'visible': false
        };
        this._columnDefEventOccurrence.push(this._objDef);
        // Tipo
        this._objDef = {
            'data': 'cod_type',
            'className': 'datatable-width-event-occurrence',
            'title': 'Tipo',
            'name': 'Tipo',
            'label': 'Tipo',
            'type': 'readonly',
            'width': '16%'
        };
        this._columnDefEventOccurrence.push(this._objDef);
        // Subtipo
        this._objDef = {
            'data': 'cod_subtype',
            'className': 'datatable-width-event-occurrence',
            'title': 'Subtipo',
            'name': 'Subtipo',
            'label': 'Subtipo',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    if (data.length > 20)
                        return row.cod_subtype.substring(0, 20) + "..."
                    else
                        return row.cod_subtype
                } else {
                    return row.cod_subtype = '';
                }
            },
            'width': '16%'
        };
        this._columnDefEventOccurrence.push(this._objDef);
        // Descrição
        this._objDef = {
            'data': 'description',
            'className': 'datatable-description-width',
            'title': 'Descrição',
            'name': 'Descrição',
            'label': 'Descrição',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    if (data.length > 20)
                        return row.description.substring(0, 20) + "..."
                    else
                        return row.description
                } else {
                    return row.description = 'Sem descrição';
                }
            },
            'width': '26%'
        };
        this._columnDefEventOccurrence.push(this._objDef);
        // Data criação
        this._objDef = {
            'data': 'date_creation',
            'className': 'datatable-width-event-occurrence',
            'title': 'Data criação',
            'name': 'Data criação',
            'label': 'Data criação',
            'type': 'readonly',
            'width': '16%'
        };
        this._columnDefEventOccurrence.push(this._objDef);
        // Estado
        this._objDef = {
            'data': 'cod_state',
            'className': 'datatable-width-event-occurrence',
            'title': 'Estado',
            'name': 'Estado',
            'label': 'Estado',
            'type': 'readonly',
            'width': '16%'
        };
        this._columnDefEventOccurrence.push(this._objDef);
        // Data estado
        this._objDef = {
            'data': 'date_state',
            'className': 'datatable-width-event-occurrence',
            'title': 'Data estado',
            'name': 'Data estado',
            'label': 'Data estado',
            'type': 'readonly',
            'width': '16%'

        };
        this._columnDefEventOccurrence.push(this._objDef);

        // -- Table definition --
        this.datatableSearchEventOccurrenceResult = $('#offcanvas-map-list-search-result-ii-table').DataTable({
            "dom": '<"top"ifp>rt',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum elemento'
            },
            //"fixedHeader": false,
            "info": false,
            "scrollY": $('#offcanvas-map-list-search-result-table-zone').height() - 80,
            "scrollX": true,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": true,
            "ordering": false,
            "columns": this._columnDefEventOccurrence,
            "select": false,
            "name": "search_occurrence_event_result",
            "rowId": 'id',
            "iDisplayLength": 8
        });

        // -- Init datatable occurrence state hist ------------------------------------------------

        // -- init column def --
        var columnDefArrayOccurrenceStateHist = [];

        // Start data table for details occurrence
        columnDefArrayOccurrenceStateHist.push({
            'data': 'id',
            'type': 'readonly',
            'visible': false
        });
        // cod_state
        columnDefArrayOccurrenceStateHist.push({
            'data': 'cod_state',
            'title': 'Tipo',
            'name': 'Tipo',
            'label': 'Tipo',
            'type': 'readonly',
            'className': 'dt-body-center dt-font',
            'orderable': false,
            'width': '30%'
        });
        // data_estado
        columnDefArrayOccurrenceStateHist.push({
            'data': 'date_state',
            'className': 'dt-body-center dt-font',
            'title': 'Data',
            'name': 'Data',
            'label': 'Data',
            'type': 'readonly',
            'orderable': false,
            'width': '43%'
        });
        // Description
        columnDefArrayOccurrenceStateHist.push({
            'id': 'description_detail_occurrence',
            'data': 'description',
            'type': 'readonly',
            'visible': false
        });
        // description button
        columnDefArrayOccurrenceStateHist.push({
            'name': 'button_config_element',
            'className': 'dt-body-center dt-font',
            'title': 'Descrição',
            'data': null,
            'orderable': false,
            'defaultContent': '<a class="button-config-element modal-description-occurrence on-button"><i class="gpi gpi-servicos" style="color: #ff3d00"></i></a>'
        });

        // -- Table definition occurrence detail --
        myOccurrences._datatableDetailOccurrenceStateHist = $('#occurrence-detail-state-hist-table').DataTable({
            "dom": '<rtip',
            "autoWidth": false,
            "destroy": true,
            "language": {
                "emptyTable": 'Sem histórico de estados',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                },
            },
            "fixedHeader": true,
            "info": false,
            "scrollY": $('#occurrence-detail-state-hist-table-zone').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": true,
            "ordering": false,
            "columns": columnDefArrayOccurrenceStateHist,
            "select": false,
            "name": "occurrence_detail_state_hist",
            "rowId": 'id',
            "iDisplayLength": 4
        });

        // Event draw table search occurrence
        myOccurrences._datatableDetailOccurrenceStateHist.on('draw', function () {

            //Evento goto occurrence description detail
            $('.modal-description-occurrence').on('click', function () {
                var id = $(this).parent().parent()[0].id;
                myOccurrences._GetDescriptionDetail(id);
            });
        });

        // -- Init datatable occurrence event state hist ------------------------------------------

        // -- init column def --
        var columnDefArrayOccurrenceEventStateHist = [];

        // Start data table for details occurrence
        columnDefArrayOccurrenceEventStateHist.push({
            'data': 'id',
            'type': 'readonly',
            'visible': false
        });
        // cod_state
        columnDefArrayOccurrenceEventStateHist.push({
            'data': 'cod_state',
            'title': 'Tipo',
            'name': 'Tipo',
            'label': 'Tipo',
            'type': 'readonly',
            'className': 'dt-body-left dt-font',
            'orderable': false,
            'width': '30%'
        });
        // data_estado
        columnDefArrayOccurrenceEventStateHist.push({
            'data': 'date_state',
            'title': 'Data',
            'name': 'Data',
            'label': 'Data',
            'type': 'readonly',
            'className': 'dt-body-center dt-font',
            'orderable': false,
            'width': '43%'
        });
        // Description
        columnDefArrayOccurrenceEventStateHist.push({
            'id': 'description_detail_occurrence',
            'data': 'description',
            'type': 'readonly',
            'visible': false
        });
        // description button
        columnDefArrayOccurrenceEventStateHist.push({
            'name': 'button_config_element',
            'className': 'dt-body-center dt-font',
            'title': 'Descrição',
            'data': null,
            'orderable': false,
            'defaultContent': '<a class="button-config-element modal-description-occurrence-event on-button"><i class="gpi gpi-servicos" style="color: #ff3d00"></i></a>'
        });

        // -- Table definition occurrence detail --
        myOccurrences._datatableDetailOccurrenceEventStateHist = $('#occurrence-event-detail-state-hist-table').DataTable({
            "dom": '<rtip',
            "autoWidth": false,
            "destroy": true,
            "language": {
                "emptyTable": 'Sem histórico de estados',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                },
            },
            "fixedHeader": true,
            "info": false,
            "scrollY": $('#occurrence-event-detail-state-hist-table-zone').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": true,
            "ordering": false,
            "columns": columnDefArrayOccurrenceEventStateHist,
            "select": false,
            "name": "occurrence_event_detail_state_hist",
            "rowId": 'id',
            "iDisplayLength": 4
        });

        // Event draw table search occurrence
        myOccurrences._datatableDetailOccurrenceEventStateHist.on('draw', function () {

            //Evento goto occurrence description detail
            $('.modal-description-occurrence-event').on('click', function () {
                var id = $(this).parent().parent()[0].id;
                myOccurrences._GetDescriptionEventStateDetail(id);
            });

        });

        // -- Init datatable occurrence team select -----------------------------------------------

        // -- init column def --
        var columnDefArrayDetailTeam = [];

        // DataTable for team Modal
        // id
        columnDefArrayDetailTeam.push({
            'data': 'id',
            'type': 'readonly',
            'visible': false
        });
        //record button
        columnDefArrayDetailTeam.push({
            'name': 'margin',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center',
            'defaultContent': '<a style ="margin-left: 19px"><i></i></a>'
        });
        //name
        columnDefArrayDetailTeam.push({
            'data': 'name',
            'className': 'datatable-team-occurrence-width',
            'title': 'Nome Equipa',
            'name': 'name_team',
            'label': 'name_team',
            'type': 'readonly',
            'orderable': false
        });
        //name leader team
        columnDefArrayDetailTeam.push({
            'data': 'name_team_leader',
            'className': 'datatable-team-occurrence-width',
            'title': 'Lider',
            'name': 'name_team',
            'label': 'name_team',
            'type': 'readonly',
            'orderable': false
        });
        //cod department
        columnDefArrayDetailTeam.push({
            'data': 'cod_department',
            'className': 'datatable-team-occurrence-width',
            'title': 'Departamento',
            'name': 'name_team',
            'label': 'name_team',
            'type': 'readonly',
            'orderable': false
        });
        // description off team
        columnDefArrayDetailTeam.push({
            'data': 'description',
            'className': 'datatable-team-occurrence-width',
            'title': 'Descrição',
            'name': 'name_team',
            'label': 'name_team',
            'type': 'readonly',
            'orderable': false
        });

        // -- Table definition occurrence team name --
        myOccurrences._datatableDetailOccurrenceTeam = $('#offcanvas-detail-team-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum departamento encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "info": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": true,
            "ordering": false,
            "columns": columnDefArrayDetailTeam,
            "select": false,
            "name": "occurrence_detail",
            "rowId": 'id',
            "iDisplayLength": 5
        });

        // Event on click to select team occurrence
        $('#offcanvas-detail-team-table tbody').on('click', 'tr', function () {
            $(this).toggleClass('selected');
        });

        //Evento to send selected teams to datatable check
        $('#occurrence-detail-team-arrow').click(function () {
            var dataDetailTeam = myOccurrences._datatableDetailOccurrenceTeam.rows('.selected').data();

            // Fill datatable
            for (var i = 0; i < dataDetailTeam.length; i++) {
                var index = myOccurrences._datatableDetailOccurrenceTeamCheck.column(0).data().indexOf(dataDetailTeam[i].id);

                if (index === -1) {
                    var objEvent = dataDetailTeam[i];
                    myOccurrences._datatableDetailOccurrenceTeamCheck.row.add({
                        id: objEvent.id,
                        name: objEvent.name,
                        name_team_leader: objEvent.name_team_leader,
                        cod_department: objEvent.cod_department,
                        description: objEvent.description,
                        cod_post: objEvent.cod_post
                    });
                    myOccurrences._datatableDetailOccurrenceTeamCheck.draw();
                }
            }
        });

        // -- Init dataTable for team check Modal -------------------------------------------------

        // -- init column def --
        var columnDefArrayDetailTeamcheck = [];

        // id
        columnDefArrayDetailTeamcheck.push({
            'data': 'id',
            'type': 'readonly',
            'visible': false
        });
        //record button
        columnDefArrayDetailTeamcheck.push({
            'name': 'remove-Button',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center',
            'render': function (data, type, row) {
                var TeamNotRemove;
                if (myOccurrences._arrayTeamsSelected.length === 0) {
                    return TeamNotRemove = '<a class="remove-team-datatable-id"><i class="fa fa-times" style="color: #ff3d00"></i></a>';
                }
                else {
                    for (var i = 0; i < myOccurrences._arrayTeamsSelected.length; i++) {
                        if (data.id !== myOccurrences._arrayTeamsSelected[i].id_team)
                            TeamNotRemove = '<a class="remove-team-datatable-id"><i class="fa fa-times" style="color: #ff3d00"></i></a>';
                        else
                            return TeamNotRemove = '<a style ="margin-left: 14px"><i></i></a>';
                    }
                    return TeamNotRemove;
                }
            },
            'width': '14px'
        });
        //name
        columnDefArrayDetailTeamcheck.push({
            'data': 'name',
            'className': 'datatable-teamcheck-occurrence-width',
            'title': 'Nome Equipa',
            'name': 'name_team',
            'label': 'name_team',
            'type': 'readonly',
            'orderable': false
        });
        //name leader team
        columnDefArrayDetailTeamcheck.push({
            'data': 'name_team_leader',
            'className': 'datatable-team-occurrence-width',
            'title': 'Lider',
            'name': 'name_team',
            'label': 'name_team',
            'type': 'readonly',
            'orderable': false
        });
        //cod department
        columnDefArrayDetailTeamcheck.push({
            'data': 'cod_department',
            'className': 'datatable-team-occurrence-width',
            'title': 'Departamento',
            'name': 'name_team',
            'label': 'name_team',
            'type': 'readonly',
            'orderable': false
        });
        // description off team
        columnDefArrayDetailTeamcheck.push({
            'data': 'description',
            'className': 'datatable-team-occurrence-width',
            'title': 'Descrição',
            'name': 'name_team',
            'label': 'name_team',
            'type': 'readonly',
            'orderable': false
        });
        // -- Table definition occurrence team name --
        myOccurrences._datatableDetailOccurrenceTeamCheck = $('#offcanvas-detail-team-check-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhuma equipa registada',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "info": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": true,
            "ordering": false,
            "columns": columnDefArrayDetailTeamcheck,
            "select": false,
            "name": "occurrence_detail",
            "rowId": 'id',
            "iDisplayLength": 5
        });

        // Event on click to remove data from datatable
        myOccurrences._datatableDetailOccurrenceTeamCheck.on('draw', function () {
            $('#offcanvas-detail-team-table').addClass('gp-overflow-datatable');
            $('.remove-team-datatable-id').on('click', function () {
                var id = $(this).parent().parent()[0].id;
                var idInt = parseInt(id);
                var index = myOccurrences._datatableDetailOccurrenceTeamCheck.column(0).data().indexOf(idInt);
                var rows = myOccurrences._datatableDetailOccurrenceTeamCheck.rows(index).remove().draw();
            });
        });

        // Get all reference
        myOccurrences._GetAllReferences();

        // -- Init datatable list occurrence relation to event ------------------------------------

        // -- init column def --
        var columnDefArray = [];


        // All button action
        var objDef =
        {
            'name': 'button_config_element',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center',
            'defaultContent': '<a class="show-button on-button show-button-bar-relation" title="Visualizar todas sa opções"><i class="fa  fa-reorder"></i></a>' +
                '<div style="position:relative;top: -24px;">' +
                '<div class="zone-occurrence-table-button-bar ol-hidden">' +
                '<a class="on-rel-remove-asssociation-occurrence on-button" title="Remover associação à ocorrência"><i class="fa fa-times"></i></a>' +
                '<a class="on-rel-button-goto-occurrence on-button" title="Ir para a posição da ocorrência"><i class="zmdi zmdi-gps-dot"></i></a>' +
                '<a class="on-rel-button-goto-detail-occurrence on-button ajust" title="Ir para o detalhe da ocorrência"><i class="gpi gpi-info"></i></a>' +
                '</div>' +
                '</div>',
            'width': '20px'
        };
        columnDefArray.push(objDef);
        // id
        objDef = {
            'data': 'id',
            'title': 'Nº',
            'name': 'Nº',
            'label': 'Nº',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-relation',
            'width': '10px'
        };
        columnDefArray.push(objDef);
        // workspace
        objDef = {
            'data': 'workspace',
            'type': 'readonly',
            'visible': false
        };
        columnDefArray.push(objDef);
        // layer name
        objDef = {
            'data': 'layer_name',
            'type': 'readonly',
            'visible': false
        };
        columnDefArray.push(objDef);
        // Description
        objDef = {
            'data': 'description',
            'type': 'readonly',
            'visible': false
        };
        columnDefArray.push(objDef);
        // estado_descrição
        objDef = {
            'data': 'state_description',
            'title': 'Estado',
            'name': 'Estado',
            'label': 'Estado',
            'type': 'readonly',
            'className': 'dt-body-center dt-occurrence-relation',
            'orderable': false,
            'width': '30px'
        };
        columnDefArray.push(objDef);
        // Description
        objDef = {
            'data': 'description_preview',
            'title': 'Descrição',
            'name': 'Descrição',
            'label': 'Descrição',
            'type': 'readonly',
            'className': 'dt-body-left dt-occurrence-rel dt-occurrence-rel-description',
            'render': function (data, type, row) {
                if (data) {
                    if (data.length > 20)
                        return row.description_preview.substring(0, 20) + "..."
                    else
                        return row.description_preview
                } else {
                    return 'Sem descrição';
                }
            },
            'width': '100px'
        };
        columnDefArray.push(objDef);
        // View description
        objDef = {
            'name': 'button_config_element',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center',
            'render': function (data, type, row) {
                if (data) {
                    if (data.description.length > 20)
                        return '<a class="on-datatable-occurrence-rel-description on-button" title="Mostrar a descrição completa"><i class="fa fa-eye"></i></a>';
                    else
                        return '';
                } else {
                    return '';
                }
            },
            'width': '20px'
        };
        columnDefArray.push(objDef);

        // -- Table definition --
        myOccurrences._datatableDetailOccurrenceRelationEvent = $('#id-occurrence-event-detail-relation-occurrence-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhuma ocorrência associada'
            },
            "fixedHeader": true,
            "info": false,
            "scrollY": $('#id-occurrence-event-detail-relation-occurrence-table-zone').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": false,
            "columns": columnDefArray,
            "select": false,
            "name": "event_relation_occurrence",
            "rowId": 'id'
        });

        // Event draw table occurrence relation event
        myOccurrences._datatableDetailOccurrenceRelationEvent.on('draw', function () {

            // Show button option
            $('.show-button-bar-relation').on('click', function () {
                if ($(this).parent().find('.zone-occurrence-table-button-bar').hasClass('ol-hidden'))
                    $(this).parent().find('.zone-occurrence-table-button-bar').removeClass('ol-hidden');
                else
                    $(this).parent().find('.zone-occurrence-table-button-bar').addClass('ol-hidden');
            });

            // Remove association occurrence to event
            $('.on-rel-remove-asssociation-occurrence').on('click', function () {

                var idOccurrenceEvent

                var idOccurrence = $(this).parent().parent().parent().parent()[0].id;

                if (myOccurrences._occurrenceEventFeatureSelected.getProperties().id)
                    idOccurrenceEvent = myOccurrences._occurrenceEventFeatureSelected.getProperties().id;
                else
                    idOccurrenceEvent = myOccurrences._occurrenceEventFeatureSelected.getId().split('.')[1];

                 //= myOccurrences._occurrenceEventFeatureSelected.getProperties().id;

                var idUser = myOccurrences._mapSgs._settings.userInfo.userId;

                // Close button bar
                $(this).parent().addClass('ol-hidden');

                // Start wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', true);

                $.ajax({
                    type: 'DELETE',
                    url: '/rest/app/Occurrence/RemoveEventOccurrenceToOccurrence?idUser=' + idUser + '&idOccurrenceEvent=' + idOccurrenceEvent + '&idOccurrence=' + idOccurrence,
                    contentType: "application/json",
                    async: true,
                    success: function (data) {
                        if (data.error) {
                            toastr["error"]("Erro na remoção da associação do evento à ocorrência");
                        }
                        else {
                            switch (data.result.status) {
                                case 'SUCCESS':
                                    // Show & hide
                                    $('#id-occurrence-event-detail-create-occurrence-zone').removeClass('ol-hidden');
                                    $('#id-occurrence-event-detail-relation-occurrence-zone-msg').removeClass('ol-hidden');
                                    $('#id-occurrence-event-detail-relation-occurrence-table-zone').addClass('ol-hidden');

                                    // Put occurrence in table
                                    myOccurrences._datatableDetailOccurrenceRelationEvent.clear().draw();

                                    // Update state occurrence event
                                    var value = data.result.occurrence_event.cod_state;
                                    $('#occurrence-event-detail-state-form [name=cod_state]').val(value);
                                    $('#occurrence-event-detail-state-form [name=cod_state]').selectpicker("refresh");
                                    $('#occurrence-event-detail-info-box-state')[0].className = "occurrence-event-detail-info-box state " + value.toLowerCase();
                                    $('#occurrence-event-detail-info-box-state')[0].setAttribute('title', data.result.occurrence_event.state_description);

                                    //  Refresh layer occurrence event
                                    myOccurrences._RefreshOccurrenceEventLayer();

                                    toastr["success"]("Remoção da associação do evento à ocorrência efectuada com sucesso");
                                    break;
                                default:
                                    toastr["error"]("Erro na remoção da associação do evento à ocorrência");
                            }
                        }

                        // Stop wait
                        myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
                    },
                    error: function (request, status, error) {
                        toastr["error"]("Erro na remoção da associação do evento à ocorrência");
                        // Stop wait
                        myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
                    }
                });
            })

            // Event goto occurrence detail
            $('.on-rel-button-goto-detail-occurrence').on('click', function () {
                // Get info element element
                var featureInfo = { id: $(this).parent().parent().parent().parent()[0].id, layer_name: myOccurrences._layerSourceNameOccurrence , from_event_occurrence: true };

                // Set Detail occurrence
                myOccurrences._DetailOccurrence(featureInfo);

                // Close button bar
                $(this).parent().addClass('ol-hidden');
            });

            // Event goto occurrence map 
            $('.on-rel-button-goto-occurrence').on('click', function () {
                // Get id element
                var id = $(this).parent().parent().parent().parent()[0].id;

                // Remove highlight
                myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear();

                // Get info layer occurrence
                var workspaceOccurrenceConfig = myOccurrences._utility.GetPropertyInfoInConfigArray(myOccurrences._mapSgs.getSettings().configurationInfo.propertyInfo, "OCCURRENCE", "SEARCH_OCCURRENCE", "WORKSPACE");
                var workspaceOccurrence = (workspaceOccurrenceConfig === undefined)?myOccurrences._workspace:workspaceOccurrenceConfig.value;
                var layerOccurrenceConfig = myOccurrences._utility.GetPropertyInfoInConfigArray(myOccurrences._mapSgs.getSettings().configurationInfo.propertyInfo, "OCCURRENCE", "SEARCH_OCCURRENCE", "LAYER");
                var layerOccurrence = (layerOccurrenceConfig === undefined)?myOccurrences._layerSourceNameOccurrence:layerOccurrenceConfig.value;
                var idFeature = layerOccurrence + '.' + id;

                // Go to occurrence
                myOccurrences._mapSgs.SetFeaturesHighlightByArray(workspaceOccurrence, layerOccurrence, false, [idFeature], myOccurrences._occurrenceHighlighStyles);

                // Close button bar
                $(this).parent().addClass('ol-hidden');
            });

            // Show description
            $('.on-datatable-occurrence-rel-description').on('click', function () {
                // Get Id occurrence
                var idOccurrence = this.parentElement.parentElement.id;
                var idElement = 'id-datatable-occurrence-rel-description-' + idOccurrence;

                // If show description active then remove Element
                if ($('#' + idElement).attr('aria-describedby')) {
                    $('#' + idElement).popover('destroy');
                }
                else {
                    // Get description
                    var description = myOccurrences._datatableDetailNeighborOccurrenceToEvent.row('#' + idOccurrence).data().description;
                    $(this).parent().parent().find('.dt-occurrence-rel-description')[0].id = idElement;

                    $('#' + idElement).popover({
                        'placement': 'top',
                        'animation': false,
                        'content': description,
                        'container': 'body'
                    });
                    $('#' + idElement).popover('show');
                }

                $('.on-datatable-occurrence-rel-description i').toggleClass('fa-fa-eye fa-eye-slash');
            });
        });

        // -- Init datatable list occurrence neighbor to event ------------------------------------

        // -- init column def --
        var columnDefArray = [];

        // All button action
        var objDef =
        {
            'name': 'button_config_element',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center',
            'defaultContent': '<a class="show-button on-button show-button-bar-neighbor" title="Visualizar todas as opções"><i class="fa  fa-reorder"></i></a>' +
                '<div style="position:relative;top: -24px;">' +
                '<div class="zone-occurrence-table-button-bar ol-hidden">' +
                '<a class="on-asssociate-occurrence on-button" title="Associar o evento à ocorrência"><i class="fa fa-check"></i></a>' +
                '<a class="on-button-goto-occurrence on-button" title="Ir para a posição da ocorrência"><i class="zmdi zmdi-gps-dot"></i></a>' +
                '<a class="on-button-goto-detail-occurrence on-button ajust" title="Ir para o detalhe da ocorrência"><i class="gpi gpi-info"></i></a>' +
                '</div>' +
                '</div>',
            'width': '20px'
        };
        columnDefArray.push(objDef);
        // id
        objDef = {
            'data': 'id',
            'title': 'Nº',
            'name': 'Nº',
            'label': 'Nº',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '10px'
        };
        columnDefArray.push(objDef);
        // workspace
        objDef = {
            'data': 'workspace',
            'type': 'readonly',
            'visible': false
        };
        columnDefArray.push(objDef);
        // layer name
        objDef = {
            'data': 'layer_name',
            'type': 'readonly',
            'visible': false
        };
        columnDefArray.push(objDef);
        // Description
        objDef = {
            'data': 'description',
            'type': 'readonly',
            'visible': false
        };
        columnDefArray.push(objDef);
        // estado_descrição
        objDef = {
            'data': 'state_description',
            'title': 'Estado',
            'name': 'Estado',
            'label': 'Estado',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // Description
        objDef = {
            'data': 'description_preview',
            'title': 'Descrição',
            'name': 'Descrição',
            'label': 'Descrição',
            'type': 'readonly',
            'className': 'dt-body-left dt-occurrence-neighbor dt-occurrence-neighbor-description',
            'render': function (data, type, row) {
                if (data) {
                    if (data.length > 20)
                        return row.description_preview.substring(0, 20) + '...';
                    else
                        return row.description_preview;
                } else {
                    return 'Sem descrição';
                }
            },
            'width': '100px'
        };
        columnDefArray.push(objDef);
        // View description
        objDef = {
            'name': 'button_config_element',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center',
            'render': function (data, type, row) {
                if (data) {
                    if (data.description.length > 20)
                        return '<a class="on-datatable-occurrence-neighbor-description on-button" title="Mostrar a descrição completa"><i class="fa fa-eye"></i></a>';
                    else
                        return '';
                } else {
                    return '';
                }
            },
            'width': '20px'
        };
        columnDefArray.push(objDef);

        // -- Table definition --
        myOccurrences._datatableDetailNeighborOccurrenceToEvent = $('#id-occurrence-event-detail-relation-occurrence-neighbor-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhuma ocorrência no raio definido',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": true,
            "info": false,
            "autoWidth": false,
            "scrollY": $('#id-occurrence-event-detail-relation-occurrence-neighbor-table-zone').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": true,
            "ordering": false,
            "columns": columnDefArray,
            "select": false,
            "name": "event_relation_occurrence",
            "rowId": 'id'
        });

        // Event draw table occurrence relation event
        myOccurrences._datatableDetailNeighborOccurrenceToEvent.on('draw', function () {

            // Show button option
            $('.show-button-bar-neighbor').on('click', function () {
                if ($(this).parent().find('.zone-occurrence-table-button-bar').hasClass('ol-hidden')) {
                    // First hide all button bar on the table
                    $('#id-occurrence-event-detail-relation-occurrence-neighbor-table-zone .zone-occurrence-table-button-bar').addClass('ol-hidden');
                    // Show button bar of the record
                    $(this).parent().find('.zone-occurrence-table-button-bar').removeClass('ol-hidden');
                }
                else
                    $(this).parent().find('.zone-occurrence-table-button-bar').addClass('ol-hidden');
            });

            // Associate occurrence to event
            $('.on-asssociate-occurrence').on('click', function () {
                var idOccurrenceEvent;
                var idOccurrence = $(this).parent().parent().parent().parent()[0].id;

                if (myOccurrences._occurrenceEventFeatureSelected.getProperties().id)
                    idOccurrenceEvent = myOccurrences._occurrenceEventFeatureSelected.getProperties().id;
                else
                    idOccurrenceEvent = myOccurrences._occurrenceEventFeatureSelected.getId().split('.')[1];

                var idUser = myOccurrences._mapSgs._settings.userInfo.userId;

                // Close button bar
                $(this).parent().addClass('ol-hidden');

                // Start wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', true);

                $.ajax({
                    type: 'POST',
                    url: '/rest/app/Occurrence/AddEventOccurrenceToOccurrence?idUSer=' + idUser+ '&idOccurrenceEvent=' + idOccurrenceEvent + '&idOccurrence=' + idOccurrence,
                    contentType: "application/json",
                    async: true,
                    success: function (data) {
                        if (data.error) {
                            toastr["error"]("Erro na associação do evento à ocorrência");
                        }
                        else {
                            switch (data.result.status) {
                                case 'SUCCESS':
                                    // Show & hide node
                                    $('#id-occurrence-event-detail-create-occurrence-zone').addClass('ol-hidden');
                                    $('#id-occurrence-event-detail-relation-occurrence-zone-msg').addClass('ol-hidden');
                                    $('#id-occurrence-event-detail-relation-occurrence-table-zone').removeClass('ol-hidden');

                                    // Put occurrence in table
                                    var occurrenceObj = data.result.occurrence;
                                    myOccurrences._datatableDetailOccurrenceRelationEvent.clear().draw();
                                    myOccurrences._datatableDetailOccurrenceRelationEvent.row.add({
                                        id: occurrenceObj.id,
                                        workspace: occurrenceObj.workspace,
                                        layer_name: occurrenceObj.layer_name,
                                        description: occurrenceObj.description,
                                        description_preview: occurrenceObj.description,
                                        state_description: occurrenceObj.state_description
                                    });
                                    myOccurrences._datatableDetailOccurrenceRelationEvent.draw();

                                    // Update state occurrence event
                                    var value = data.result.occurrence_event.cod_state;
                                    $('#occurrence-event-detail-state-form [name=cod_state]').val(value);
                                    $('#occurrence-event-detail-state-form [name=cod_state]').selectpicker("refresh");
                                    $('#occurrence-event-detail-info-box-state')[0].className = "occurrence-event-detail-info-box state " + value.toLowerCase();
                                    $('#occurrence-event-detail-info-box-state')[0].setAttribute('title', data.result.occurrence_event.state_description);

                                    //  Refresh layer occurrence event
                                    myOccurrences._RefreshOccurrenceEventLayer();

                                    toastr["success"]("Ocorrência associada com sucesso");
                                    break;
                                case "EVENT_OCCURRENCE_ALREADY_REL":
                                    toastr["warning"]("Evento de ocorrência já associado a uma ocorrência");
                                    break;
                                default:
                                    toastr["error"]("Erro na associação do evento à ocorrência");
                            }
                        }
                        // Stop wait
                        myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
                    },
                    error: function (request, status, error) {
                        toastr["error"]("Erro na associação do evento à ocorrência");
                        // Stop wait
                        myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
                    }
                });
            })

            // Event goto occurrence in map
            $('.on-button-goto-detail-occurrence').on('click', function () {
                // Get info element element
                var featureInfo = { id: $(this).parent().parent().parent().parent()[0].id, layer_name: myOccurrences._layerSourceNameOccurrence, from_event_occurrence: true};

                // Set Detail occurrence
                myOccurrences._DetailOccurrence(featureInfo);

                // Close button bar
                $(this).parent().addClass('ol-hidden');
            });

            // Event goto occurrence detail
            $('.on-button-goto-occurrence').on('click', function () {
                // Get id element
                var id = $(this).parent().parent().parent().parent()[0].id;
                var idFeature = "occurrence." + id;

                // Remove highlight
                myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear();

                //Go to occurrence
                myOccurrences._mapSgs.SetFeaturesHighlightByArray(myOccurrences._workspace, 'occurrence', false, [idFeature], myOccurrences._occurrenceHighlighStyles);

                // Close button bar
                $(this).parent().addClass('ol-hidden');
            });

            // Show description
            $('.on-datatable-occurrence-neighbor-description').on('click', function () {
                // Get Id occurrence
                var idOccurrence = this.parentElement.parentElement.id;
                var idElement = 'id-datatable-occurrence-neighbor-description-' + idOccurrence;

                // If show description active then remove Element
                if ($('#' + idElement).attr('aria-describedby') ) {
                    $('#' + idElement).popover('destroy');
                }
                else {
                    // Get description
                    var description = myOccurrences._datatableDetailNeighborOccurrenceToEvent.row('#' + idOccurrence).data().description;
                    $(this).parent().parent().find('.dt-occurrence-neighbor-description')[0].id = idElement;

                    $('#' + idElement).popover({
                        'placement': 'top',
                        'animation': false,
                        'content': description,
                        'container': 'body'
                    });
                    $('#' + idElement).popover('show');
                }

                $('.on-datatable-occurrence-neighbor-description i').toggleClass('fa-fa-eye fa-eye-slash');
            });
        });

        // -- Init datatable list event occurrence from occurrence --------------------------------

        // -- init column def --
        var columnDefOccurrenceEventFromOccurrenceArray = [];

        // All button action
        columnDefOccurrenceEventFromOccurrenceArray.push({
            'name': 'button_config_element',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center',
            'defaultContent': '<a class="show-button on-button show-button-bar-occurrence_event_from_occurrrence" title="Visualizar todas as opções"><i class="fa  fa-reorder"></i></a>' +
                '<div style="position:relative;top: -24px;">' +
                '<div class="zone-occurrence-table-button-bar two_button ol-hidden">' +
                '<a class="on-button-goto-occurrence-event on-button" title="Ir para a posição do evento da ocorrência"><i class="zmdi zmdi-gps-dot"></i></a>' +
                '<a class="on-button-goto-detail-occurrence-event on-button ajust" title="Ir para o detalhe do evento da ocorrência"><i class="gpi gpi-info"></i></a>' +
                '</div>' +
                '</div>',
            'width': '20px'
        });
        // id
        columnDefOccurrenceEventFromOccurrenceArray.push({
            'data': 'id',
            'type': 'readonly',
            'visible': false
        });
        // workspace
        columnDefOccurrenceEventFromOccurrenceArray.push({
            'data': 'workspace',
            'type': 'readonly',
            'visible': false
        });
        // layer name
        columnDefOccurrenceEventFromOccurrenceArray.push({
            'data': 'layer_name',
            'type': 'readonly',
            'visible': false
        });
        // Description
        columnDefOccurrenceEventFromOccurrenceArray.push({
            'data': 'description',
            'type': 'readonly',
            'visible': false
        });
        // estado_descrição
        columnDefOccurrenceEventFromOccurrenceArray.push({
            'data': 'state_description',
            'title': 'Estado',
            'name': 'Estado',
            'label': 'Estado',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-event',
            'width': '60px'
        });
        // Description
        columnDefOccurrenceEventFromOccurrenceArray.push({
            'data': 'description_preview',
            'title': 'Descrição',
            'name': 'Descrição',
            'label': 'Descrição',
            'type': 'readonly',
            'className': 'dt-body-left dt-occurrence-event dt-occurrence-event-description',
            'render': function (data, type, row) {
                if (data) {
                    if (data.length > 20)
                        return row.description_preview.substring(0, 20) + '...';
                    else
                        return row.description_preview;
                } else {
                    return 'Sem descrição';
                }
            },
            'width': '100px'
        });
        // View description
        columnDefOccurrenceEventFromOccurrenceArray.push({
            'name': 'button_config_element',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center',
            'render': function (data, type, row) {
                if (data) {
                    if (data.description) {
                        if (data.description.length > 20)
                            return '<a class="on-datatable-occurrence-event-description on-button" title="Mostrar a descrição completa"><i class="fa fa-eye"></i></a>';
                        else
                            return '';
                    } else {
                        return '';
                    }
                } else {
                    return '';
                }
            },
            'width': '20px'
        });
        // -- Table definition --
        myOccurrences._datatableOccurrenceEventFromOccurrence = $('#id-offcanvas-occurrence-detail-event-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum evento de ocorrência',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": true,
            "info": false,
            "autoWidth": false,
            "scrollY": $('#id-offcanvas-occurrence-detail-event-table-zone').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": true,
            "ordering": false,
            "columns": columnDefOccurrenceEventFromOccurrenceArray,
            "select": false,
            "name": "occurrence_event_relation_occurrence",
            "rowId": 'id'
        });

        // Event draw table occurrence relation event
        myOccurrences._datatableOccurrenceEventFromOccurrence.on('draw', function () {

            // Show button option
            $('#id-offcanvas-occurrence-detail-event-table-zone .show-button-bar-occurrence_event_from_occurrrence').on('click', function () {
                if ($(this).parent().find('.zone-occurrence-table-button-bar').hasClass('ol-hidden')) {
                    // First hide all button bar on the table
                    $('#id-offcanvas-occurrence-detail-event-table-zone .zone-occurrence-table-button-bar').addClass('ol-hidden');
                    // Show button bar of the record
                    $(this).parent().find('.zone-occurrence-table-button-bar').removeClass('ol-hidden');
                }
                else
                    $(this).parent().find('.zone-occurrence-table-button-bar').addClass('ol-hidden');
            });

            // Event goto occurrence detail
            $('#id-offcanvas-occurrence-detail-event-table-zone .on-button-goto-detail-occurrence-event').on('click', function () {
                // id occurrence event
                var idOccurrenceEvent = $(this).parent().parent().parent().parent()[0].id;

                // Get feature occurrence event
                var featureOccurrenceEvent = myOccurrences._mapSgs.GetFeatureByIdSync(myOccurrences._workspace, myOccurrences._layerSourceNameOccurrenceEvent, idOccurrenceEvent);

                // Get info element element
                var featureInfo = { id: idOccurrenceEvent, layer_name: myOccurrences._layerSourceNameOccurrenceEvent, feature: featureOccurrenceEvent, from_occurrence: true };

                // Set Detail occurrence
                myOccurrences._DetailOccurrence(featureInfo);

                // Close button bar
                $(this).parent().addClass('ol-hidden');
            });

            // Event goto event occurrence on map
            $('#id-offcanvas-occurrence-detail-event-table-zone .on-button-goto-occurrence-event').on('click', function () {
                // Get id element
                var id = $(this).parent().parent().parent().parent()[0].id;
                var idFeature = myOccurrences._layerSourceNameOccurrenceEvent + "." + id;

                // Remove highlight
                myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear();

                //Go to event occurrence
                myOccurrences._mapSgs.SetFeaturesHighlightByArray(myOccurrences._workspace, myOccurrences._layerSourceNameOccurrenceEvent, false, [idFeature], myOccurrences._eventOccurrenceHighlighStyles);

                // Close button bar
                $(this).parent().addClass('ol-hidden');
            });

            // Show description
            $('#id-offcanvas-occurrence-detail-event-table-zone .on-datatable-occurrence-event-description').on('click', function () {
                // Get Id occurrence
                var idOccurrenceEvent = this.parentElement.parentElement.id;
                var idElement = 'id-datatable-occurrence-event-description-' + idOccurrenceEvent;

                // If show description active then remove Element
                if ($('#' + idElement).attr('aria-describedby')) {
                    $('#' + idElement).popover('destroy');
                }
                else {
                    // Get description
                    var description = myOccurrences._datatableOccurrenceEventFromOccurrence.row('#' + idOccurrenceEvent).data().description;
                    $(this).parent().parent().find('.dt-occurrence-event-description')[0].id = idElement;

                    $('#' + idElement).popover({
                        'placement': 'top',
                        'animation': false,
                        'content': description,
                        'container': 'body'
                    });
                    $('#' + idElement).popover('show');
                }

                $('.on-datatable-occurrence-neighbor-description i').toggleClass('fa-fa-eye fa-eye-slash');
            });
        });

    };

    /**
     * Event occurrence
     * Init Event occurrence
     * @param {any} mapSgs, map
     */
    this.InitEventOccurrence = function (mapSgs) {

        //Change location buttons 
        $('#buttonsMap').addClass('buttonsEventOccurrence');
        $('#buttonsMap a').addClass('buttonsMarginTop');

        // Get Map
        myOccurrences._mapSgs = mapSgs;

        // Get layer name key freguesia
        myOccurrences._layerNameKeyFreguesia = myOccurrences._mapSgs.layerTree.FindLayerNameKey("freguesia_cont");

        // Get layer info event occurrence
        myOccurrences._layerInfoEventOccurrence = myOccurrences._mapSgs.layerTree.FindLayerInfo("vw_occurrence_event");

        // -- Init search Event occurence data begin -----------------------------------------------------------
        $('#Event-occurrence-search-date-begin').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Init search Event occurence data end -------------------------------------------------------------
        $('#Event-occurrence-search-date-end').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // Get all subtype reference
        $.ajax({
            type: 'GET',
            url: '/rest/app/Occurrence/GetAllReference',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro de carregamento da informação de referência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Fill type
                            myOccurrences._hashReference['occurrence_type'] = data.result.list_occurrence_type;
                            myOccurrences._utility.FillSelect('Event-occurrence-search-select-type', data.result.list_occurrence_type, 'description', 'cod_type');
                            myOccurrences._utility.FillSelect('Event-occurrence-creation-type', data.result.list_occurrence_type, 'description', 'cod_type');

                            // Fill subtype
                            myOccurrences._hashReference['occurrence_subtype'] = {};
                            for (var i = 0; i < data.result.list_occurrence_subtype.length; i++) {
                                var subTypeObj = data.result.list_occurrence_subtype[i];
                                if (myOccurrences._hashReference['occurrence_subtype'][subTypeObj.cod_type])
                                    myOccurrences._hashReference['occurrence_subtype'][subTypeObj.cod_type].push(subTypeObj);
                                else
                                    myOccurrences._hashReference['occurrence_subtype'][subTypeObj.cod_type] = [subTypeObj];
                            }
                            //myOccurrences._utility.FillSelect('Event-occurrence-creation-subtype', data.result.list_occurrence_subtype, 'description', 'cod_subtype');
                            //myOccurrences._utility.FillSelect('search-occurrence-event-subtype', data.result.list_occurrence_subtype, 'description', 'cod_subtype');

                            // Fill state
                            myOccurrences._hashReference['occurrence_event_state'] = data.result.list_state_event;
                            myOccurrences._utility.FillSelect('search-occurrence-event-state', data.result.list_state_event, 'description', 'cod_ref');
                            // Fill description state in detail event occurrence
                            for (let i = 0; i < myOccurrences._hashReference.occurrence_event_state.length; i++) {
                                var stateRefInfoObj = myOccurrences._hashReference.occurrence_event_state[i];
                                $('.occurrence-detail-info-state-box-title.' + stateRefInfoObj.cod_ref.replace('_', '-').toLowerCase())[0].innerHTML = stateRefInfoObj.description;
                                $('#id-occurrence-event-detail-info-state-' + stateRefInfoObj.cod_ref.replace('_', '-').toLowerCase())[0].setAttribute('title', stateRefInfoObj.description);
                                $('#id-occurrence-event-detail-info-state-' + stateRefInfoObj.cod_ref.replace('_', '-').toLowerCase())[0].setAttribute('cod_state', stateRefInfoObj.cod_ref)
                            };

                            break;
                        case 'ERROR':
                            toastr["error"]("Erro de carregamento da informação de referência");
                            break;
                        default:
                    }
                }

            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referência");
            }
        });

        $('#id-creation-event-occurrence-submit').on('click', function () {
            myOccurrences._CreateEventOccurrence();
        });

        //Event to search when values change
        $('#button-submite-filter-search').on('click', function () {
            myOccurrences._SearchOccurrenceEvent();
        });

        //Event to change all SubType when user select one type
        $('#Event-occurrence-creation-type').on('change.bs.select', function () {
            var codType = $('#Event-occurrence-creation-type').val();
            var arraySubtype = myOccurrences._hashReference['occurrence_subtype'][codType];
            myOccurrences._utility.FillSelect('Event-occurrence-creation-subtype', arraySubtype, 'description', 'cod_subtype');
        });

        //Event to change all SubType when user select one type
        $('#Event-occurrence-search-select-type').on('change.bs.select', function () {
            var codType = $('#Event-occurrence-search-select-type').val();
            var arraySubtype = myOccurrences._hashReference['occurrence_subtype'][codType];
            myOccurrences._utility.FillSelect('search-occurrence-event-subtype', arraySubtype, 'description', 'cod_subtype');
        });

        //Collapse/open info in occurrence detail
        $('.event-occurrence-search-collapse').on('click', function () {
            var idNodeToCollapse = this.getAttribute('target-id');
            $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
            $('#' + idNodeToCollapse).toggle('ol-hidden');
        });

        // Collapse/open layer tree in MapOccurrence
        $('.occurrence-event-collapse').on('click', function () {
            var idNodeToCollapse = this.getAttribute('target-id');
            $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
            $('#' + idNodeToCollapse).toggle('ol-hidden');
        });

        $('#buttonEventMapSearch').on('click', function () {
            // if (!$('#offcanvas-detail-event-occurrence').hasClass('active'))
            myOccurrences._SearchOccurrenceEvent();
        });

        // Event submit event creation from map
        $('#id-submit-btn-create-event-occurrence-map').on('click', function () {

            // Hide state
            $('#id-occurrence-event-detail-info-state').addClass('ol-hidden');

            if (myOccurrences._utility.mobilecheck()) {
                $('#creation-occurrence-event-X').val(mapSgs.map.getView().getCenter()[0]);

                $('#creation-occurrence-event-Y').val(mapSgs.map.getView().getCenter()[1]);
            }

            // Clean dropdown Type
            $('#Event-occurrence-creation-type, #Event-occurrence-creation-subtype').val('').change();

            // Clean dropdown Keyword
            $('#Event-occurrence-description').val('');

            // show button 
            $('#id-creation-event-occurrence-attachment-add').removeClass('ol-hidden');
            $('#id-creation-event-occurrence-submit').removeClass('ol-hidden');
            if (myOccurrences._utility.mobilecheck()) {
                $('#id-creation-event-occurrence-attachment-add i')[0].className = 'gpi gpi-snapshot';
            }
            else {
                $('#id-creation-event-occurrence-attachment-add i')[0].className = 'fa fa-plus';
            }

            // Put cursor like original
            if (!myOccurrences._mapSgs._utility.mobilecheck()) {
                document.body.style.cursor = 'default';
            }

            // Init Upload for entity
            if (myOccurrences._mapSgs._uploadAttachtment) {
                // Layer info
                var layerName = myOccurrences._layerInfoEventOccurrence.layerName;

                myOccurrences._mapSgs._uploadAttachtment.LoadAttachment(myOccurrences._mapSgs._uploadAttachtment.fakeIdEntity, layerName, 'id-offcanvas-body-layer-detail-attachment-zone', 'id-offcanvas-body-layer-detail-attachment-form', 'id-creation-event-occurrence-attachment-add', 'offcanvas-body-layer-detail-attachment-info-td', 'id-offcanvas-creation-event-attachment-spinner');
            }

            // Open detail event occurrence
            myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-creation-event-occurrence'], true);
        })

        // Event cancel event creation from map
        $('#id-cancel-btn-create-event-occurrence-map').on('click', function () {
            myOccurrences._mapSgs.map.on('singleclick', async (e) => { await myOccurrences._mapSgs.tooltips.BuildInfoTooltips(e); });
            myOccurrences._mapSgs.map.un('click', myOccurrences._CreationEventOccurrenceMakeClickEvent);
            $('#ButtonStartCreationEvent').html('Criar Ocorrência');
            $('#pinCreateEventOccurrence, #pinOnMove').css({ 'display': 'none' });
            $('#buttonsMap a[href="#offcanvas-theme"').removeClass('active');
            myOccurrences._mapSgs.StartCreationEvent = true;
            if (!myOccurrences._mapSgs._utility.mobilecheck()) {
                document.body.style.cursor = 'default';
            }
        })

        //Evento to clean filter event occurrence
        $('#button-remove-filter-search').on('click', function () {

            //Clean dropdown Type
            $('#Event-occurrence-search-select-type, #search-occurrence-event-subtype, #search-occurrence-event-state').val('').change();

            //Clean dropdown Keyword
            $('#event-occurrence-search-input-keyword, #Event-occurrence-search-date-begin, #Event-occurrence-search-date-end').val('');

            //Call function Search Occurrence
            myOccurrences._SearchOccurrenceEvent();

        })

        //close ficha de ocorrência and open search canvas
        $('#offcanvas-close-event-occurrence').on('click', function () {
            if ($('#creation-occurrence-event-button').hasClass('ol-hidden'))
                myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-detail-event-occurrence'], true);
            else
                myOccurrences._utility.ShowOpenCanvas(['offcanvas-detail-event-occurrence'], true);
        });

        //Detect when the map is moving only on mobile mode
        if (myOccurrences._utility.mobilecheck()) {
            $(mapSgs.map).on('movestart', function () {
                if ($('#ButtonStartCreationEvent').html() !== 'Criar Ocorrência')
                    $('#pinCreateEventOccurrence').css({ 'display': 'none' });
            });

            $(mapSgs.map).on('moveend', function () {
                if ($('#ButtonStartCreationEvent').html() !== 'Criar Ocorrência')
                    $('#pinCreateEventOccurrence').css({ 'display': 'initial' });
            });
        }

        // Trigger resize to start responsive on the map Occurrence
        $(window).trigger('resize');

        // -- Start data table for detail event occurrence ----------------------------------------

        // -- init column def --
        var columnDefArrayDetailEvent = [];

        // id
        var objDef = {
            'data': 'id',
            'title': 'Id',
            'name': 'Id',
            'label': 'Id',
            'type': 'readonly',
            'visible': false
        };
        columnDefArrayDetailEvent.push(objDef);
        // cod_state
        objDef = {
            'data': 'cod_state',
            'type': 'readonly',
            'visible': false
        };
        columnDefArrayDetailEvent.push(objDef);
        // state_description
        objDef = {
            'data': 'state_description',
            'type': 'readonly',
            'visible': false
        };
        columnDefArrayDetailEvent.push(objDef);
        // description event
        objDef = {
            'data': 'description_event',
            'type': 'readonly',
            'visible': false
        };
        columnDefArrayDetailEvent.push(objDef);
        // Go to location
        objDef = {
            'name': 'button_goto_location',
            'className': 'datatable-responsive-buttons',
            'data': null,
            'orderable': false,
            'defaultContent': '<a class="button-goto-event-occurrence" title="Ir para a posição da ocorrência"><i class="zmdi zmdi-gps-dot" style="color: #000000"></i></a>',
            'width': '15%'
        };
        columnDefArrayDetailEvent.push(objDef);
        // Go to detail event
        objDef = {
            'name': 'button_goto_detail',
            'className': 'datatable-responsive-buttons',
            'data': null,
            'orderable': false,
            'defaultContent': '<a class="button-detail-event-occurrence" title="Ir para o detalhe da ocorrência"><i class="gpi gpi-info" style="color: #000000"></i></a>',
            'width': '15%'
        };
        columnDefArrayDetailEvent.push(objDef);
        // Event occurrence
        objDef = {
            'name': 'button_config_element',
            'data': null,
            'orderable': false,
            //'defaultContent': '<a><i class="fa fa-circle"></i></a>',
            'render': function (data, type, row) {
                return '<a title="' + row.state_description + '"><i class="fa fa-circle datatable-color-state-' + row.cod_state + '"></i></a>';
            },
            'width': '10%'
        };
        columnDefArrayDetailEvent.push(objDef);
        // Description
        objDef = {
            'id': 'description',
            'className': 'datatable-event-occurrence-description dataTable-event-occurrence-height-line',
            'data': 'description',
            'name': 'descrição',
            'label': 'description',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    if (data.length > 20)
                        return row.description.substring(0, 20) + "..."
                    else
                        return row.description
                } else {
                    return row.description = 'Sem descrição';
                }
            },
            'width': '60%'
        };
        columnDefArrayDetailEvent.push(objDef);

        // -- Table definition occurrence team name --
        this._tableDetailEventOccurrence = $('#event-occurrence-detail-hist-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhuma ocorrência registada'
            },
            "targets": '_all',
            "fixedHeader": false,
            "info": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": false,
            "columns": columnDefArrayDetailEvent,
            "select": false,
            "name": "event_detail",
            "rowId": 'id',
            "iDisplayLength": false
        });

        // Event on draw table
        this._tableDetailEventOccurrence.on('draw', function () {
            $('.datatable-responsive-buttons i').addClass('buttons-search-event-datatable');

            // Show description
            $('.datatable-event-occurrence-description').on('click', function () {
                var verifyClass = $(this)[0].children[0];
                if ($(verifyClass).hasClass('EventOccurrenceStyle')) {
                    $('.EventOccurrenceStyle').css({ 'display': 'none' });
                    $('#event-occurrence-detail-hist-table').append($('#EventOccurrenceTextArea'));
                } else {
                    $('.EventOccurrenceStyle').css({ 'display': 'initial' });
                    var idEventOccurrence = parseInt(this.parentElement.id);
                    var objDatatable = myOccurrences._tableDetailEventOccurrence.row('#' + idEventOccurrence).data();
                    $('#TextAreaEventOccurrenceDetail').html(objDatatable.description_event);
                    $(this).append($('#EventOccurrenceTextArea'));
                    // Ajust last element
                    var countElement = myOccurrences._eventsOccurrenceDetail.length;
                    for (let i = 0; i < countElement; i++) {
                        if (parseInt(this.parentElement.id) === myOccurrences._eventsOccurrenceDetail[myOccurrences._eventsOccurrenceDetail.length - 1].id)
                            for (let i = 0; i < this.parentElement.childElementCount; i++) {
                                $(this.parentElement.children[i]).css({ 'padding-bottom': '100px' })
                                $(this.parentElement.children[i]).css({ 'border-bottom': 'none' })
                            }
                    }
                }
            });

            // Open detail event occurrence
            $('.button-detail-event-occurrence').on('click', function () {
                $('#creation-occurrence-event-button').addClass('ol-hidden');
                var idEventOccurrence = parseInt(this.parentElement.parentElement.id);
                var objDatatable = myOccurrences._tableDetailEventOccurrence.row('#' + idEventOccurrence).data();
                // Fill detail event occurrence
                $('#Event-occurrence-description').val(objDatatable.description_event).change();
                $('#Event-occurrence-creation-type').val(objDatatable.cod_type).change();
                $('#Event-occurrence-creation-subtype').val(objDatatable.cod_subtype).change();
                // Fill state event occurrence
                $('.occurrence-detail-info-state-box-col').removeClass('current-state');
                $('#id-occurrence-event-detail-info-state-' + objDatatable.cod_state.replace('_', '-').toLowerCase()).parent().addClass('current-state');
                $('#id-occurrence-event-detail-info-state').removeClass('ol-hidden');
                if (myOccurrences._utility.mobilecheck())
                    $('.occurrence-detail-info-state-box').addClass('mobile');
                else
                    $('.occurrence-detail-info-state-box').removeClass('mobile');
                // Show canvas event occurrence detail
                myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-creation-event-occurrence'], true);
                $('#buttonEventMapSearch').removeClass('active');
            });

            // Event goto occurrence event search in map 
            $('.button-goto-event-occurrence').on('click', function () {
                // Get id element
                var id = $(this).parent().parent()[0].id;
                var idFeature = "vw_occurrence_event." + id;

                // if mobile leave canvas to show event occurrence in map
                if (myOccurrences._utility.mobilecheck())
                    myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-creation-event-occurrence'], false);

                // Remove highlight
                myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear();

                //Go to event occurrence
                myOccurrences._mapSgs.SetFeaturesHighlightByArray(myOccurrences._workspace, 'vw_occurrence_event', false, [idFeature], myOccurrences._eventOccurrenceHighlighStyles);
            });

            if (myOccurrences._utility.mobilecheck()) {
                $('.EventOccurrenceStyle').css({ 'margin-top': '50px' });
            }
        });
    }

	/**
	 * Occurrence report
     * @param {int} idOccurrence, occurrence id
	 */
    this.ReportOccurrence = function (idOccurrence) {
        $('#occurrence-report-page').removeClass('ol-hidden');
        $('#occurrence-report-global-page').addClass('ol-hidden');

        $.ajax({
            type: 'GET',
            url: '/rest/app/Occurrence/GetReportOccurrence?idOccurrence=' + idOccurrence,
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na criação do relatório");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            var vw_occurrence = data.result.vw_occurrence;
                            var list_vw_occurrence_event = data.result.list_vw_occurrence_event;
                            var listTimeline = data.result.timeline;

                            // Fill occurrence number
                            $('#header-occurrence-report-title-number')[0].innerHTML = vw_occurrence.id;

                            // Fill occurrence information
                            for (var j = 0; j < Object.keys(vw_occurrence).length; j++) {
                                var key = Object.keys(vw_occurrence)[j];
                                var value = vw_occurrence[key];

                                switch (key) {
                                    case "date_creation":
                                        value = app._utility.TransformDateServerInDateII(value);
                                        break;
                                    default:
                                        // do nothing
                                }

                                if ($("#occurrence-report-page-form [name='" + key + "'").length > 0)
                                    $("#occurrence-report-page-form [name='" + key + "'")[0].innerHTML = value;
                            }

                            if (list_vw_occurrence_event.length > 0) {
                                // Fill table with occurrence event
                                myOccurrences._datatableOccurrenceReportEvent.clear().draw();
                                if (list_vw_occurrence_event.length > 0) {
                                    for (let i = 0; i < list_vw_occurrence_event.length; i++) {
                                        var vw_occurrence_event = list_vw_occurrence_event[i];
                                        myOccurrences._datatableOccurrenceReportEvent.row.add({
                                            id: vw_occurrence_event.id,
                                            description: vw_occurrence_event.description,
                                            state_description: vw_occurrence_event.state_description,
                                            user_name: vw_occurrence_event.user_name,
                                            date_creation: app._utility.TransformDateServerInDateII(vw_occurrence_event.date_creation)
                                        });
                                    }
                                    myOccurrences._datatableOccurrenceReportEvent.draw();
                                }
                                $($.fn.dataTable.tables(true)).DataTable().columns.adjust();

                                // Fill table with timeline
                                myOccurrences._datatableOccurrenceReportTimeline.clear().draw();
                                if (listTimeline.length > 0) {
                                    for (let i = 0; i < listTimeline.length; i++) {
                                        var timeline = listTimeline[i];
                                        myOccurrences._datatableOccurrenceReportTimeline.row.add({
                                            date: app._utility.TransformDateServerInDateII(timeline.date),
                                            type_description: timeline.type_description,
                                            user_name: timeline.user_name,
                                            state_description: vw_occurrence_event.state_description,
                                            description: vw_occurrence_event.description,
                                            name_department: timeline.name_department
                                        });
                                    }
                                    myOccurrences._datatableOccurrenceReportTimeline.draw();
                                }

                            } else {

                                myOccurrences._datatableOccurrenceReportTimeline.clear().draw();
                                if (listTimeline.length > 0) {
                                    for (let i = 0; i < listTimeline.length; i++) {
                                        var timeline = listTimeline[i];
                                        myOccurrences._datatableOccurrenceReportTimeline.row.add({
                                            date: app._utility.TransformDateServerInDateII(timeline.date),
                                            type_description: timeline.type_description,
                                            user_name: timeline.user_name,
                                            state_description: timeline.cod_state,
                                            description: timeline.type_description,
                                            name_department: timeline.name_department
                                        });
                                    }
                                    myOccurrences._datatableOccurrenceReportTimeline.draw();
                                }

                                $($.fn.dataTable.tables(true)).DataTable().columns.adjust();

                                $('#list-occurrence-event').css({ 'display': 'none' });

                                $('#id-occurrence-report-global-bar').closest('page').css({ 'display': 'none' })
                            }

                            toastr["success"]("Relatório criado com sucesso");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na criação do relatório");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na criação do relatório");
            }
        });
    };

	/**
	 * Occurrence report global
     * @param {string} dateBegin, date begin
     * @param {string} dateEnd, date end
	 */
    this.ReportOccurrenceGlobal = function (dateBegin, dateEnd) {

        $('#occurrence-report-page').addClass('ol-hidden');
        $('#occurrence-report-global-page').removeClass('ol-hidden');

        $('#header-occurrence-report-title-date-begin')[0].innerHTML = dateBegin;
        $('#header-occurrence-report-title-date-end')[0].innerHTML = dateEnd;

        $.ajax({
            type: 'GET',
            url: '/rest/app/Occurrence/GetReportOccurrenceGlobal?beginDate=' + dateBegin + "&endDate=" + dateEnd,
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na criação do relatório");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            var occurrence_event_report = data.result.occurrence_event_report;
                            var occurrence_report = data.result.occurrenceReport;

                            // -- Statistic Occurrence event --------------------------------------

                            // Event statistics state
                            myOccurrences._datatableOccurrenceReportGlobalEvent.clear().draw();
                            if (occurrence_event_report.total_occurrence_event > 0 || occurrence_report.total_occurrence > 0) {

                                if (occurrence_event_report.total_occurrence_event > 0) {
                                    var hashColumn = {
                                        "EM_ANALISE": 0,
                                        "CANCELADO": 0,
                                        "EM_RESOLUCAO": 0,
                                        "FECHADO": 0
                                    };
                                    var dataPieEvent = [];
                                    var dataBarEvent = [];
                                    var tickBarEvent = [];
                                    for (let i = 0; i < occurrence_event_report.list_occurrence_event_state.length; i++) {
                                        var eventState = occurrence_event_report.list_occurrence_event_state[i];
                                        hashColumn[eventState.cod_state] = eventState.count_state;
                                        var color = "";
                                        var pos = -1;
                                        switch (eventState.cod_state) {
                                            case "EM_ANALISE":
                                                color = "#FF8000";
                                                pos = 1;
                                                break;
                                            case "CANCELADO":
                                                color = "#808080";
                                                pos = 2;
                                                break;
                                            case "EM_RESOLUCAO":
                                                color = "#FFFF33";
                                                pos = 3;
                                                break;
                                            case "FECHADO":
                                                color = "#00FF00";
                                                pos = 4;
                                                break;
                                            default:
                                            // do nothing
                                        }

                                        dataPieEvent.push({
                                            label: eventState.state_description,
                                            data: eventState.count_state,
                                            color: color
                                        });

                                        dataBarEvent.push({
                                            data: [[pos, eventState.count_state]],
                                            color: color
                                        });

                                        tickBarEvent.push([pos, eventState.state_description]);

                                    }
                                    hashColumn["total_occurrence_event"] = occurrence_event_report.total_occurrence_event;
                                    myOccurrences._datatableOccurrenceReportGlobalEvent.row.add(hashColumn);
                                    myOccurrences._datatableOccurrenceReportGlobalEvent.draw();

                                    // Pie
                                    $.plot('#id-occurrence-report-global-event-pie', dataPieEvent, {
                                        series: {
                                            pie: {
                                                show: true,
                                                innerRadius: 0.5,
                                                label: {
                                                    show: true,
                                                    radius: 0.9,
                                                    formatter: function (label, series) {
                                                        return '<div style="border:1px solid grey;font-size:8pt;text-align:center;padding:5px;color:white;">' +
                                                            Math.round(series.percent) +
                                                            '%</div>';
                                                    },
                                                    background: {
                                                        opacity: 0.4,
                                                        color: '#000'
                                                    }
                                                }
                                            }
                                        },
                                        legend: {
                                            show: true
                                        }
                                    });

                                    // bar
                                    $.plot('#id-occurrence-report-global-event-bar', dataBarEvent, {
                                        series: {
                                            bars: {
                                                show: true,
                                                barWidth: 0.3,
                                                align: "center",
                                                lineWidth: 1,
                                                fill: .75
                                            }
                                        },
                                        xaxis: {
                                            autoscaleMargin: 0.1,
                                            ticks: tickBarEvent
                                        }
                                    });
                                }
                                else {
                                    $($('#occurrence-report-global-page .info')[0]).remove();
                                    $($('#occurrence-report-global-page .info')[0]).appendTo($('#occurrence-report-global-page .occurrence-report-margin')[0])
                                    $('#occurrence-report-global-page')[0].nextElementSibling.remove()
                                    $('#occurrence-report-global-page p ').remove()
                                    $('#occurrence-report-global-page .occurrence-report-global-bar-zone').css({ 'margin-top': '-35px' });
                                }
                                // -- Statistic Occurrence --------------------------------------------

                                // Occurrence statistics state
                                myOccurrences._datatableOccurrenceReportGlobal.clear().draw();
                                if (occurrence_report.total_occurrence > 0) {
                                    var hashColumnList = [];
                                    var hashColumn = {
                                        "type_column": "Total",
                                        "total_occurrence": "",
                                        "ABERTA": 0,
                                        "ATRIBUIDA": 0,
                                        "EM_RESOLUCAO": 0,
                                        "CONCLUIDA": 0,
                                        "FECHADA": 0
                                    };
                                    var dataPie = [];
                                    var dataBar = [];
                                    var tickBar = [];
                                    for (let i = 0; i < occurrence_report.list_occurrence_state.length; i++) {
                                        var occurrenceState = occurrence_report.list_occurrence_state[i];
                                        hashColumn[occurrenceState.cod_state] = occurrenceState.count_state;
                                        var color = "";
                                        var pos = -1;
                                        switch (occurrenceState.cod_state) {
                                            case "ABERTA":
                                                color = "#fbb200";
                                                pos = 1;
                                                break;
                                            case "ATRIBUIDA":
                                                color = "#cccc00";
                                                pos = 2;
                                                break;
                                            case "EM_RESOLUCAO":
                                                color = "#073A42";
                                                pos = 3;
                                                break;
                                            case "CONCLUIDA":
                                                color = "#CCFFCC";
                                                pos = 4;
                                                break;
                                            case "FECHADA":
                                                color = "#46782D";
                                                pos = 5;
                                                break;
                                            default:
                                            // do nothing
                                        }

                                        dataPie.push({
                                            label: occurrenceState.state_description,
                                            data: occurrenceState.count_state,
                                            color: color
                                        });

                                        dataBar.push({
                                            data: [[pos, occurrenceState.count_state]],
                                            color: color
                                        });

                                        tickBar.push([pos, occurrenceState.state_description]);

                                    }
                                    hashColumn["total_occurrence"] = occurrence_report.total_occurrence;
                                    hashColumnList.push(hashColumn);

                                    // Critical
                                    var hashColumnCriticalTitle = {
                                        "type_column": "Criticidade",
                                        "total_occurrence": "",
                                        "ABERTA": "",
                                        "ATRIBUIDA": "",
                                        "EM_RESOLUCAO": "",
                                        "CONCLUIDA": "",
                                        "FECHADA": ""
                                    };
                                    hashColumnList.push(hashColumnCriticalTitle);
                                    var hashCritical = {};
                                    for (var t = 0; t < occurrence_report.list_occurrence_critical_state.length; t++) {
                                        var occurrenceCriticalState = occurrence_report.list_occurrence_critical_state[t];
                                        if (hashCritical[occurrenceCriticalState.type_column]) {
                                            hashCritical[occurrenceCriticalState.type_column][occurrenceCriticalState.cod_state] = occurrenceCriticalState.count_state;
                                        }
                                        else {
                                            var hashColumnCritical = {
                                                "type_column": occurrenceCriticalState.type_column,
                                                "total_occurrence": "",
                                                "ABERTA": 0,
                                                "ATRIBUIDA": 0,
                                                "EM_RESOLUCAO": 0,
                                                "CONCLUIDA": 0,
                                                "FECHADA": 0
                                            };
                                            hashColumnCritical[occurrenceCriticalState.cod_state] = occurrenceCriticalState.count_state;
                                            hashCritical[occurrenceCriticalState.type_column] = hashColumnCritical;
                                        }
                                    }

                                    for (var key in hashCritical) {
                                        hashCritical[key]["total_occurrence"] = hashCritical[key]["ABERTA"] +
                                            hashCritical[key]["ATRIBUIDA"] +
                                            hashCritical[key]["EM_RESOLUCAO"] +
                                            hashCritical[key]["CONCLUIDA"] +
                                            hashCritical[key]["FECHADA"];
                                        hashColumnList.push(hashCritical[key]);
                                    }

                                    for (var r = 0; r < hashColumnList.length; r++) {
                                        myOccurrences._datatableOccurrenceReportGlobal.row.add(hashColumnList[r]);
                                    }

                                    // Department
                                    var hashColumnDepartmentTitle = {
                                        "type_column": "Departamento",
                                        "total_occurrence": "",
                                        "ABERTA": "",
                                        "ATRIBUIDA": "",
                                        "EM_RESOLUCAO": "",
                                        "CONCLUIDA": "",
                                        "FECHADA": ""
                                    };
                                    hashColumnList.push(hashColumnDepartmentTitle);
                                    var hashDepartment = {};
                                    for (var q = 0; q < occurrence_report.list_occurrence_department_state.length; q++) {
                                        var occurrenceDepartmentState = occurrence_report.list_occurrence_department_state[q];
                                        if (hashDepartment[occurrenceDepartmentState.type_column]) {
                                            hashDepartment[occurrenceDepartmentState.type_column][occurrenceDepartmentState.cod_state] = occurrenceDepartmentState.count_state;
                                        }
                                        else {
                                            var hashColumnDepartment = {
                                                "type_column": occurrenceDepartmentState.type_column,
                                                "total_occurrence": "",
                                                "ABERTA": 0,
                                                "ATRIBUIDA": 0,
                                                "EM_RESOLUCAO": 0,
                                                "CONCLUIDA": 0,
                                                "FECHADA": 0
                                            };
                                            hashColumnDepartment[occurrenceDepartmentState.cod_state] = occurrenceDepartmentState.count_state;
                                            hashDepartment[occurrenceDepartmentState.type_column] = hashColumnDepartment;
                                        }
                                    }

                                    for (var key in hashDepartment) {
                                        hashDepartment[key]["total_occurrence"] = hashDepartment[key]["ABERTA"] +
                                            hashDepartment[key]["ATRIBUIDA"] +
                                            hashDepartment[key]["EM_RESOLUCAO"] +
                                            hashDepartment[key]["CONCLUIDA"] +
                                            hashDepartment[key]["FECHADA"];
                                        hashColumnList.push(hashDepartment[key]);
                                    }

                                    // Fill table
                                    for (var r = 0; r < hashColumnList.length; r++) {
                                        myOccurrences._datatableOccurrenceReportGlobal.row.add(hashColumnList[r]);
                                    }
                                    myOccurrences._datatableOccurrenceReportGlobal.draw();

                                    // Pie
                                    $.plot('#id-occurrence-report-global-pie', dataPie, {
                                        series: {
                                            pie: {
                                                show: true,
                                                innerRadius: 0.5,
                                                label: {
                                                    show: true,
                                                    radius: 0.9,
                                                    formatter: function (label, series) {
                                                        return '<div style="border:1px solid grey;font-size:8pt;text-align:center;padding:5px;color:white;">' +
                                                            Math.round(series.percent) +
                                                            '%</div>';
                                                    },
                                                    background: {
                                                        opacity: 0.4,
                                                        color: '#000'
                                                    }
                                                }
                                            }
                                        },
                                        legend: {
                                            show: true
                                        }
                                    });

                                    // bar
                                    $.plot('#id-occurrence-report-global-bar', dataBar, {
                                        series: {
                                            bars: {
                                                show: true,
                                                barWidth: 0.3,
                                                align: "center",
                                                lineWidth: 1,
                                                fill: .75
                                            }
                                        },
                                        xaxis: {
                                            autoscaleMargin: 0.1,
                                            ticks: tickBar
                                        }
                                    });
                                }
                                $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
                            }

                            toastr["success"]("Relatório criado com sucesso");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na criação do relatório");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na criação do relatório");
            }
        });

    };

    /**
     * Init Occurrence report
     */
    this.InitOccurrenceReport = function () {
        // -- Init datatable list occurrence event ------------------------------------------------

        // -- init column def --
        var columnDefArray = [];

        // id
        var objDef = {
            'data': 'id',
            'title': 'Nº',
            'name': 'Nº',
            'label': 'Nº',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '10px'
        };
        columnDefArray.push(objDef);
        // Description
        objDef = {
            'data': 'description',
            'title': 'Descrição',
            'name': 'Descrição',
            'label': 'Descrição',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // estado_descrição
        objDef = {
            'data': 'state_description',
            'title': 'Estado',
            'name': 'Estado',
            'label': 'Estado',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // user_name
        objDef = {
            'data': 'user_name',
            'title': 'Utilizador',
            'name': 'Utilizador',
            'label': 'Utilizador',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // date_creation
        objDef = {
            'data': 'date_creation',
            'title': 'Data',
            'name': 'Data',
            'label': 'Data',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);

        // -- Table definition --
        myOccurrences._datatableOccurrenceReportEvent = $('#id-occurrence-report-event-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhuma evento de ocorrência associado',
            },
            "fixedHeader": true,
            "info": false,
            "autoWidth": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": false,
            "columns": columnDefArray,
            "select": false,
            "name": "occurrence_report_event",
            "rowId": 'id'
        });

        // -- Init datatable timeline -------------------------------------------------------------

        // -- init column def --
        columnDefArray = [];

        // date
        objDef = {
            'data': 'date',
            'title': 'Data',
            'name': 'Data',
            'label': 'Data',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // id
        objDef = {
            'data': 'type_description',
            'title': 'Tipo',
            'name': 'Tipo',
            'label': 'Tipo',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '10px'
        };
        columnDefArray.push(objDef);
        // user_name
        objDef = {
            'data': 'user_name',
            'title': 'Utilizador',
            'name': 'Utilizador',
            'label': 'Utilizador',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // estado_descrição
        objDef = {
            'data': 'state_description',
            'title': 'Estado',
            'name': 'Estado',
            'label': 'Estado',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // Description
        objDef = {
            'data': 'description',
            'title': 'Descrição',
            'name': 'Descrição',
            'label': 'Descrição',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // Description
        objDef = {
            'data': 'name_department',
            'title': 'Departamento',
            'name': 'Departamento',
            'label': 'Departamento',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);

        // -- Table definition --
        myOccurrences._datatableOccurrenceReportTimeline = $('#id-occurrence-report-timeline-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum evento',
            },
            "fixedHeader": true,
            "info": false,
            "autoWidth": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": false,
            "columns": columnDefArray,
            "select": false,
            "name": "occurrence_report_timeline"
        });

        // -- Init datatable list occurrence event global -----------------------------------------

        // -- init column def --
        columnDefArray = [];

        // Occurrence event total
        objDef = {
            'data': 'total_occurrence_event',
            'title': 'Total eventos',
            'name': 'Total eventos',
            'label': 'Total eventos',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // state "em Análise"
        objDef = {
            'data': 'EM_ANALISE',
            'title': 'Em analise',
            'name': 'Em analise',
            'label': 'Em analise',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // state "Em resolução"
        objDef = {
            'data': 'EM_RESOLUCAO',
            'title': 'Em resolução',
            'name': 'Em resolução',
            'label': 'Em resolução',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // state "Fechado"
        objDef = {
            'data': 'FECHADO',
            'title': 'Fechado',
            'name': 'Fechado',
            'label': 'Fechado',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // state "Cancelado"
        objDef = {
            'data': 'CANCELADO',
            'title': 'Cancelado',
            'name': 'Cancelado',
            'label': 'Cancelado',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);

        // -- Table definition --
        myOccurrences._datatableOccurrenceReportGlobalEvent = $('#id-occurrence-report-global-event-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhuma evento de ocorrência',
            },
            "fixedHeader": true,
            "info": false,
            "autoWidth": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": false,
            "columns": columnDefArray,
            "select": false,
            "name": "occurrence_report_global_event"
        });

        // -- Init datatable list occurrence global -----------------------------------------------

        // -- init column def --
        var columnDefArrayGlobal = [];

        // Occurrence total
        objDef = {
            'data': 'type_column',
            'title': 'Ocorrência por',
            'name': 'Ocorrência por',
            'label': 'Ocorrência por',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArrayGlobal.push(objDef);
        // Occurrence total
        objDef = {
            'data': 'total_occurrence',
            'title': 'Total',
            'name': 'Total',
            'label': 'Total',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArrayGlobal.push(objDef);
        // state "Aberta"
        objDef = {
            'data': 'ABERTA',
            'title': 'Aberta',
            'name': 'Aberta',
            'label': 'Aberta',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArrayGlobal.push(objDef);
        // state "Atribuída"
        objDef = {
            'data': 'ATRIBUIDA',
            'title': 'Atribuída',
            'name': 'Atribuída',
            'label': 'Atribuída',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArrayGlobal.push(objDef);
        // state "Em resolução"
        objDef = {
            'data': 'EM_RESOLUCAO',
            'title': 'Em resolução',
            'name': 'Em resolução',
            'label': 'Em resolução',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArrayGlobal.push(objDef);
        // state "Concluida"
        objDef = {
            'data': 'CONCLUIDA',
            'title': 'Concluida',
            'name': 'Concluida',
            'label': 'Concluida',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArrayGlobal.push(objDef);
        // state "Concluida"
        objDef = {
            'data': 'FECHADA',
            'title': 'Fechada',
            'name': 'Fechada',
            'label': 'Fechada',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArrayGlobal.push(objDef);

        // -- Table definition --
        myOccurrences._datatableOccurrenceReportGlobal = $('#id-occurrence-report-global-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhuma ocorrência',
            },
            "fixedHeader": true,
            "info": false,
            "autoWidth": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": false,
            "columns": columnDefArrayGlobal,
            "select": false,
            "name": "occurrence_report_global"
        });
    }


    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Init buffer
     */
    this._InitBuffer = function () {

        // Style
        myOccurrences._bufferstyle =
            new Style({
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 4
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.4)'
                }),
                image: new CircleStyle({
                    radius: 5,
                    stroke: new Stroke({
                        color: 'rgba(255, 255, 0, 1)',
                        width: 2
                    }),
                    fill: new Fill({
                        color: 'rgba(255, 255, 0, 0.2)'
                    })
                })
            });

        // Layer
        myOccurrences._layerBuffer = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: [
                myOccurrences._bufferstyle
            ],
            name: 'occurrence_layer_buffer'
        });

        // Add layer to map
        myOccurrences._mapSgs.map.addLayer(myOccurrences._layerBuffer);
    };

    /**
     * Set Slide
     * @param {ol.coordinate} coordinate, coordinate of the buffer
     * @param {int} radius, radius of the buffer
     */
    this._SetBufferOccurrenceNeighbor  = function (coordinate, radius) {

        // -- Set feature buffer ------------------------------------------------------------------
        var bufferFeature = new Feature({ geometry: new Circle(coordinate, radius) });
        myOccurrences._layerBuffer.getSource().clear();
        myOccurrences._layerBuffer.getSource().addFeature(bufferFeature);

        // -- Set Slider --------------------------------------------------------------------------

        // Destroy if exists
        if (myOccurrences._bufferSlide) {
            myOccurrences._bufferSlide.destroy()
        }

        // Set radius value;
        $('#id-occurrence-event-detail-relation-occurrence-neighbor-radius-buffer')[0].innerHTML = radius + " m";

        // Set slide
        myOccurrences._bufferSlide = new Slider( "#id-occurrence-event-detail-relation-occurrence-neighbor-slider-buffer", {
            step: 10,
            min: 0,
            max: 500,
            value: radius,
            tooltip: 'hide'
        });

        // Update radius value
        myOccurrences._bufferSlide.on("slide", function (sliderValue) {
            $('#id-occurrence-event-detail-relation-occurrence-neighbor-radius-buffer')[0].innerHTML = sliderValue + " m";
        });

        // On Update 
        myOccurrences._bufferSlide.on("change", function (obj) {
            $('#id-occurrence-event-detail-relation-occurrence-neighbor-radius-buffer')[0].innerHTML = obj.newValue + " m";

            // Redraw buffer
            var bufferFeature = new Feature({ geometry: new Circle(coordinate, obj.newValue) });
            myOccurrences._layerBuffer.getSource().clear();
            myOccurrences._layerBuffer.getSource().addFeature(bufferFeature);

            // Get Occurrence in buffer
            var occurrencePropertiesArray = [];
            for (var j = 0; j < myOccurrences._layerInfoOccurrenceArray.length; j++) {
                var layerInfoObj = myOccurrences._layerInfoOccurrenceArray[j];
                var layerOccurrence = myOccurrences._utility.GetLayerByName(myOccurrences._mapSgs.map, layerInfoObj.layerNameKey);
                for (let i = 0; i < layerOccurrence.getSource().getFeatures().length; i++) {
                    var occurrenceFeature = layerOccurrence.getSource().getFeatures()[i];
                    if (bufferFeature.getGeometry().intersectsCoordinate(occurrenceFeature.getGeometry().getCoordinates())) {
                        occurrencePropertiesArray.push(occurrenceFeature.getProperties());
                    }
                }
            }

            // Fill table with occurrence information
            myOccurrences._datatableDetailNeighborOccurrenceToEvent.clear().draw();
            if (occurrencePropertiesArray.length > 0) {
                for (let i = 0; i < occurrencePropertiesArray.length; i++) {
                    var occurrenceFeatureProperties = occurrencePropertiesArray[i];
                    myOccurrences._datatableDetailNeighborOccurrenceToEvent.row.add({
                        id: occurrenceFeatureProperties.occurrence_id,
                        workspace: occurrenceFeatureProperties.workspace,
                        layer_name: occurrenceFeatureProperties.layer_name,
                        description: occurrenceFeatureProperties.description,
                        description_preview: occurrenceFeatureProperties.description,
                        state_description: occurrenceFeatureProperties.state_description
                    });
                }
                myOccurrences._datatableDetailNeighborOccurrenceToEvent.draw();
            }
            $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
        });
    };

    /**
    * Get all references for occorrence
    */
    this._GetAllReferences = function () {

        // Get all occorrances reference
        $.ajax({
            type: 'GET',
            url: '/rest/app/Occurrence/GetAllReference',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro de carregamento da informação de referência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Fill Freguesia
                            myOccurrences._hashReference['freguesia_cont'] = data.result.list_occurrence_freguesia;
                            myOccurrences._utility.FillSelect('occurrence-search-select-freguesia', data.result.list_occurrence_freguesia, 'freguesia', 'ddccff');
                            //myOccurrences._utility.FillSelect('creation-occurrence-freguesia-select', data.result.list_occurrence_freguesia, 'freguesia', 'ddccff');

                            // Fill occurrence_department
                            myOccurrences._hashReference['occurrence_department'] = data.result.list_occurrence_department;
                            myOccurrences._utility.FillSelect('occurrence-search-select-department', data.result.list_occurrence_department, 'name', 'cod_department');
                            myOccurrences._utility.FillSelect('name-select-occurrence-team', data.result.list_occurrence_department, 'name', 'cod_department');
                            myOccurrences._utility.FillSelect('occurrence-detail-department-select', data.result.list_occurrence_department, 'name', 'cod_department');

                            // Fill type
                            myOccurrences._hashReference['occurrence_type'] = data.result.list_occurrence_type;
                            myOccurrences._utility.FillSelect('occurrence-search-select-type', data.result.list_occurrence_type, 'description', 'cod_type');
                            myOccurrences._utility.FillSelect('creation-occurrence-type-select', data.result.list_occurrence_type, 'description', 'cod_type');
                            myOccurrences._utility.FillSelect('occurrence-detail-type-select', data.result.list_occurrence_type, 'description', 'cod_type');
                            myOccurrences._utility.FillSelect('occurrence-event-detail-type-select', data.result.list_occurrence_type, 'description', 'cod_type');
                            myOccurrences._utility.FillSelect('id-event-occurrence-search-select-type', data.result.list_occurrence_type, 'description', 'cod_type');


                            // Fill subtype
                            myOccurrences._hashReference['occurrence_subtype'] = {};
                            for (var i = 0; i < data.result.list_occurrence_subtype.length; i++) {
                                var subTypeObj = data.result.list_occurrence_subtype[i];
                                if (myOccurrences._hashReference['occurrence_subtype'][subTypeObj.cod_type])
                                    myOccurrences._hashReference['occurrence_subtype'][subTypeObj.cod_type].push(subTypeObj);
                                else
                                    myOccurrences._hashReference['occurrence_subtype'][subTypeObj.cod_type] = [subTypeObj];
                            }

                            // Fill state
                            myOccurrences._hashReference['occurrence_state'] = data.result.list_occurrence_state;
                            myOccurrences._utility.FillSelect('occurrence-search-select-state', data.result.list_occurrence_state, 'description', 'cod_ref');

                            // Fill occurrence state
                            myOccurrences._hashReference['occurrence_state'] = data.result.list_occurrence_state;
                            myOccurrences._utility.FillSelect('occurrence-detail-state-select', data.result.list_occurrence_state, 'description', 'cod_ref');

                            // Fill occurrence event state
                            myOccurrences._hashReference['occurrence_event_state'] = data.result.list_state_event;
                            myOccurrences._utility.FillSelect('occurrence-event-detail-state-select', data.result.list_state_event, 'description', 'cod_ref');
                            myOccurrences._utility.FillSelect('id-search-occurrence-event-state', data.result.list_state_event, 'description', 'cod_ref');

                            // Fill occurrence critical
                            myOccurrences._hashReference['occurrence_critical'] = data.result.list_occurrence_critical;
                            myOccurrences._utility.FillSelect('occurrence-detail-critical-select', data.result.list_occurrence_critical, 'description', 'cod_ref');

                            // Fill occurrence resolution state
                            myOccurrences._hashReference['occurrence_resolution_state'] = data.result.list_occurrence_resolution_state;

                            //Fill Critical Occurrence
                            myOccurrences._utility.FillSelect('occurrence-search-select-codCritical', data.result.list_occurrence_critical, 'description', 'cod_ref');

                            //Fill Critical Occurrence without event
                            myOccurrences._utility.FillSelect('creation-occurrence-withoutevent-critical-select', data.result.list_occurrence_critical, 'description', 'cod_ref');

                            //Fill team Occurrence
                            myOccurrences._utility.FillSelect('occurrence-search-select-TeamOccurrence', data.result.list_occurrence_team, 'name', 'id');

                            //Fill team leader Occurrence
                            myOccurrences._utility.FillSelect('occurrence-search-select-teamleaderOccurrence', data.result.list_occurrence_team, 'name_team_leader', 'id_team');

                            //Fill team name Occurrence
                            myOccurrences._utility.FillSelect('occurrence-search-select-NameTeamOccurrence', data.result.list_occurrence_team, 'name', 'id');

                            break;
                        case 'ERROR':
                            toastr["error"]("Erro de carregamento da informação de referência");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referência");
            }
        });
    };

    /**
     * Get search result search result
     */
    this._GetOccurrenceColumnDefinitionSearchResult = function () {
        var hashColumDefinition = {
            column_definition: [],
            column_definition_expand: []
        };

        // -- Init column definition ---------------------------------------------------------------

        // Add primary key to array
        hashColumDefinition.column_definition.push({
            'data': "id_primary_key",
            'type': 'readonly',
            'visible': false
        });
        // id
        hashColumDefinition.column_definition.push({
            'data': 'id',
            'title': 'Número',
            'name': 'Número',
            'label': 'Número',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center',
            'width': '50px'
        });
        // cod_state
        hashColumDefinition.column_definition.push({
            'data': 'state_description',
            'title': 'Estado',
            'name': 'Estado',
            'label': 'Estado',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center',
            'width': '250px'
        });
        //// description
        //hashColumDefinition.column_definition.push({
        //    'data': 'description',
        //    'title': 'Descrição',
        //    'name': 'Descrição',
        //    'label': 'Descrição',
        //    'type': 'readonly',
        //    'orderable': false,
        //    'width': '15%'
        //});
        // date_creation
        hashColumDefinition.column_definition.push({
            'data': 'date_creation',
            'title': 'Data',
            'name': 'Data',
            'label': 'Data',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center',
            'width': '200px'
        });

        // -- Init column definition expand -------------------------------------------------------

        // Add primary key to array
        hashColumDefinition.column_definition_expand.push({
            'data': "id_primary_key",
            'type': 'readonly',
            'visible': false
        });
        // id
        hashColumDefinition.column_definition_expand.push({
            'data': 'id',
            'title': 'Id',
            'name': 'Id',
            'label': 'Id',
            'type': 'readonly',
            'visible': false
        });
        // workspace
        hashColumDefinition.column_definition_expand.push({
            'data': 'workspace',
            'title': 'workspace',
            'name': 'workspace',
            'label': 'workspace',
            'type': 'readonly',
            'visible': false
        });
        // layer name
        hashColumDefinition.column_definition_expand.push({
            'data': 'layer_name',
            'title': 'layer_name',
            'name': 'layer_name',
            'label': 'layer_name',
            'type': 'readonly',
            'visible': false
        });
        // tipo_descrição
        hashColumDefinition.column_definition_expand.push({
            'data': 'type_description',
            'title': 'Tipo',
            'name': 'Tipo',
            'label': 'Tipo',
            'type': 'readonly',
            'orderable': false,
            'width': '15%'
        });
        // Sub_tipo_descrição
        hashColumDefinition.column_definition_expand.push({
            'data': 'subtype_description',
            'title': 'Subtipo',
            'name': 'Subtipo',
            'label': 'Subtipo',
            'type': 'readonly',
            'orderable': false,
            'width': '26%'
        });
        // Data_criação
        hashColumDefinition.column_definition_expand.push({
            'data': 'date_creation',
            'title': 'Data criação',
            'name': 'Data criação',
            'label': 'Data criação',
            'type': 'readonly',
            'orderable': false,
            'width': '10%'
        });
        // estado_descrição
        hashColumDefinition.column_definition_expand.push({
            'data': 'state_description',
            'title': 'Estado',
            'name': 'Estado',
            'label': 'Estado',
            'type': 'readonly',
            'orderable': false,
            'width': '6%'
        });
        // data_estado
        hashColumDefinition.column_definition_expand.push({
            'data': 'date_state',
            'title': 'Data estado',
            'name': 'Data estado',
            'label': 'Data estado',
            'type': 'readonly',
            'orderable': false,
            'width': '12%'
        });

        return hashColumDefinition;
    };

    /**
     * Get search result search result
     */
    this._GetOccurrenceEventColumnDefinitionSearchResult = function () {
        var hashColumDefinition = {
            column_definition: [],
            column_definition_expand: []
        };

        // -- Init column definition ---------------------------------------------------------------

        // Add primary key to array
        hashColumDefinition.column_definition.push({
            'data': "id_primary_key",
            'type': 'readonly',
            'visible': false
        });
        // id
        hashColumDefinition.column_definition.push({
            'data': 'id',
            'title': 'Número',
            'name': 'Número',
            'label': 'Número',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center',
            'width': '50px'
        });
        // cod_state
        hashColumDefinition.column_definition.push({
            'data': 'state_description',
            'title': 'Estado',
            'name': 'Estado',
            'label': 'Estado',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center',
            'width': '250px'
        });
        //// description
        //hashColumDefinition.column_definition.push({
        //    'data': 'description',
        //    'title': 'Descrição',
        //    'name': 'Descrição',
        //    'label': 'Descrição',
        //    'type': 'readonly',
        //    'orderable': false,
        //    'width': '15%'
        //});
        // date_creation
        hashColumDefinition.column_definition.push({
            'data': 'date_creation',
            'title': 'Data',
            'name': 'Data',
            'label': 'Data',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center',
            'width': '200px'
        });

        // -- Init column definition expand -------------------------------------------------------

        // Add primary key to array
        hashColumDefinition.column_definition_expand.push({
            'data': "id_primary_key",
            'type': 'readonly',
            'visible': false
        });
        // id
        hashColumDefinition.column_definition_expand.push({
            'data': 'id',
            'title': 'Number',
            'name': 'Number',
            'label': 'Number',
            'orderable': false,
            'className': 'dt-body-center',
            'width': '50px'
        });
        // workspace
        hashColumDefinition.column_definition_expand.push({
            'data': 'workspace',
            'title': 'workspace',
            'name': 'workspace',
            'label': 'workspace',
            'type': 'readonly',
            'visible': false
        });
        // layer name
        hashColumDefinition.column_definition_expand.push({
            'data': 'layer_name',
            'title': 'layer_name',
            'name': 'layer_name',
            'label': 'layer_name',
            'type': 'readonly',
            'visible': false
        });
        // tipo_descrição
        hashColumDefinition.column_definition_expand.push({
            'data': 'type_description',
            'title': 'Tipo',
            'name': 'Tipo',
            'label': 'Tipo',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center',
            'width': '150px'
        });
        // Sub_tipo_descrição
        hashColumDefinition.column_definition_expand.push({
            'data': 'subtype_description',
            'title': 'Subtipo',
            'name': 'Subtipo',
            'label': 'Subtipo',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center',
            'width': '150px'
        });
        // Description
        hashColumDefinition.column_definition_expand.push({
            'data': 'description',
            'title': 'Descrição',
            'name': 'Descrição',
            'label': 'Descrição',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center word-wrap',
            'width': '200px'
        });
        // Data_criação
        hashColumDefinition.column_definition_expand.push({
            'data': 'date_creation',
            'title': 'Data criação',
            'name': 'Data criação',
            'label': 'Data criação',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center',
            'width': '70px'
        });
        // estado_descrição
        hashColumDefinition.column_definition_expand.push({
            'data': 'state_description',
            'title': 'Estado',
            'name': 'Estado',
            'label': 'Estado',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center',
            'width': '100px'
        });
        // data_estado
        hashColumDefinition.column_definition_expand.push({
            'data': 'date_state',
            'title': 'Data estado',
            'name': 'Data estado',
            'label': 'Data estado',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center',
            'width': '70px'
        });

        return hashColumDefinition;
    };

    /**
     * Build search result
     * @param {any} layerName
     * @param {any} columnDefArrayInput
     * @param {any} columDefArrayExpandInput
     * @param {any} columnValueArray
     * @param {any} gotoEntityDetailCallback
     */
    this._BuildSearhResultInDatatable = function (layerName, columnDefArrayInput, columDefArrayExpandInput, columnValueArray, gotoEntityDetailCallback) {
        var columnDefArray = columnDefArrayInput;
        var columnDefArrayExpand = columDefArrayExpandInput;
        var styleHighLight = null;
        var msgGoto = "";

        // set Info
        switch (layerName) {
            case "vw_occurrence_event":
                styleHighLight = myOccurrences._eventOccurrenceHighlighStyles;
                msgGoto = "Evento de ocorrência sem posição geográfica";
                break;
            case "vw_occurrence":
                styleHighLight = myOccurrences._eventOccurrenceHighlighStyles;
                msgGoto = "Ocorrência sem posição geográfica";
                break;
        };

        // Number of result
        $('#id-search-result-detail-info-number-result span')[0].innerHTML = columnValueArray.length;

        // Go to detail
        var objDef = {
            'name': 'button_goto_detail',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center btn-column',
            'defaultContent': '<a class="button-goto-detail-search-result" title="Ir para o detalhe do elemento"><i class="gpi gpi-info" style="color: #ff3d00"></i></a>',
            'width': '15px'
        };
        columnDefArray.unshift(objDef);
        columnDefArrayExpand.unshift(objDef);
        // Goto to location
        objDef = {
            'name': 'button_goto_location',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center btn-column',
            'defaultContent': '<a class="button-goto-location-search-result" title="Ir para a posição do elemento"><i class="zmdi zmdi-gps-dot" style="color: #ff3d00"></i></a>',
            'width': '15px'
        };
        columnDefArray.unshift(objDef);
        columnDefArrayExpand.unshift(objDef);

        // -- Table search result -----------------------------------------------------------------

        // Destroy if exists
        if (myOccurrences._datatableSearchResult != null) {

            // Destroy table
            myOccurrences._datatableSearchResult.destroy();

            // Empty table zone
            $('#offcanvas-search-result-table-zone').empty();

            // Recreate table node
            var tableSearch = $('<table id="offcanvas-search-result-table" cellspacing="0" width="100%"></table>');
            tableSearch.appendTo($('#offcanvas-search-result-table-zone'));
        }

        // -- Table definition --
        myOccurrences._datatableSearchResult = $('#offcanvas-search-result-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum elemento',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": true,
            "info": false,
            //"scrollY": $('#offcanvas-search-result-table-zone').height() - 80,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": true,
            "pageLength": 20,
            "ordering": false,
            "columns": columnDefArray,
            "data": columnValueArray,
            "select": false,
            "name": "search_result",
            "rowId": 'id_primary_key',
            "initComplete": function (settings, json) {
                
                // Event goto element detail
                $('#offcanvas-search-result-table').on('click','.button-goto-detail-search-result', function ()
                {
                    // Get id element
                    var id = $(this).parent().parent()[0].id;
                    var idFeature = layerName + "." + id;

                    // Find feature
                    var featureFind = null;
                    for (var i = 0; i < myOccurrences._arraySearchFeatureActive.length; i++) {
                        if (myOccurrences._arraySearchFeatureActive[i].getId() === idFeature) {
                            featureFind = myOccurrences._arraySearchFeatureActive[i];
                            break;
                        }
                    }

                    // Get feature info
                    var featureInfo = {
                        id: id,
                        layer_name: layerName,
                        feature: featureFind
                    };

                    // Set Detail occurrence
                    myOccurrences._DetailOccurrence(featureInfo);
                });

                // Event goto element search in map 
                $('#offcanvas-search-result-table').on('click', '.button-goto-location-search-result', function (){
                    // Get id element
                    var id = $(this).parent().parent()[0].id;
                    var idFeature = layerName + "." + id;

                    // Find feature
                    var arrayFeature = [];
                    for (var i = 0; i < myOccurrences._arraySearchFeatureActive.length; i++) {
                    if (myOccurrences._arraySearchFeatureActive[i].getId() === idFeature)
                        arrayFeature.push(myOccurrences._arraySearchFeatureActive[i]);
                    }

                    if ($('#id-search-result-detail-info-number-result').hasClass('hide-highlight'))
                        $('#id-search-result-detail-info-number-result').removeClass('hide-highlight');

                    // Go to feature
                    if (arrayFeature.length > 0) {
                        // Clean highlight layer
                        myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear(layerName);

                        // Define style
                        var mode = $('#id-offcanvas-search-result-goto').attr("mode");
                        var styleHighLight = null;
                        switch (mode) {
                            case "vw_occurrence_event":
                                styleHighLight = myOccurrences._eventOccurrenceHighlighStyles;
                                break;
                            case "vw_occurrence":
                                styleHighLight = myOccurrences._occurrenceHighlighStyles;
                                break;
                        };

                        // Highlight feature
                        myOccurrences._mapSgs.SetFeaturesHighlightByFeatureCol(arrayFeature, true, styleHighLight);

                        // Goto occurrence
                        myOccurrences._mapSgs.map.getView({
                            center: [arrayFeature[0].values_.geometry.flatCoordinates[0], arrayFeature[0].values_.geometry.flatCoordinates[1]]
                        });
                        myOccurrences._mapSgs.map.getView().setZoom(myOccurrences.ZoomSearch);
                    }   
                    else
                        toastr["warning"](msgGoto);
                });
            }
        });

        // -- Table search result expand ----------------------------------------------------------

        // Destroy if exists
        if (myOccurrences._datatableSearchResultExpand != null) {

            // Destroy table
            myOccurrences._datatableSearchResultExpand.destroy();

            // Empty table zone
            $('#offcanvas-map-list-search-result-table-zone').empty();

            // Recreate table node
            var tableSearch = $('<table id="offcanvas-map-list-search-result-table" cellspacing="0" width="100%"></table>');
            tableSearch.appendTo($('#offcanvas-map-list-search-result-table-zone'));
        }

        // -- Table definition --
        myOccurrences._datatableSearchResultExpand = $('#offcanvas-map-list-search-result-table').DataTable({
            "dom": '<"top"ifp>rt',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum elemento'
            },
            //"fixedHeader": false,
            "info": false,
            "scrollY": $('#offcanvas-map-list-search-result-table-zone').height() - 80,
            "scrollX": true,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": true,
            "ordering": false,
            "columns": columnDefArrayExpand,
            "data": columnValueArray,
            "select": false,
            "name": "search_result_expand",
            "rowId": 'id_primary_key',
            "initComplete": function (settings, json) {

                // Event goto element detail
                $('#offcanvas-map-list-search-result-table-zone').on('click', '.button-goto-detail-search-result', function ()
                {
                    // Get id element
                    var id = $(this).parent().parent()[0].id;
                    var idFeature = layerName + "." + id;

                    // Find feature
                    var featureFind = null;
                    for (var i = 0; i < myOccurrences._arraySearchFeatureActive.length; i++) {
                        if (myOccurrences._arraySearchFeatureActive[i].getId() === idFeature) {
                            featureFind = myOccurrences._arraySearchFeatureActive[i];
                            break;
                        }
                    }

                    // Get feature info
                    var featureInfo = {
                        id: id,
                        layer_name: layerName,
                        feature: featureFind
                    };

                    // Set Detail occurrence
                    myOccurrences._DetailOccurrence(featureInfo);
                });

                // Event goto element search in map 
                $('#offcanvas-map-list-search-result-table-zone').on('click', '.button-goto-location-search-result', function (){
                    // Get id element
                    var id = $(this).parent().parent()[0].id;
                    var idFeature = layerName + "." + id;

                    // Find feature
                    var arrayFeature = [];
                    for (var i = 0; i < myOccurrences._arraySearchFeatureActive.length; i++) {
                        if (myOccurrences._arraySearchFeatureActive[i].getId() === idFeature)
                            arrayFeature.push(myOccurrences._arraySearchFeatureActive[i]);
                    }

                    // Go to feature
                    if (arrayFeature.length > 0) {
                        // Clean highlight layer
                        myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear();

                        // Define style
                        var mode = $('#id-offcanvas-search-result-goto').attr("mode");
                        var styleHighLight = null;
                        switch (mode) {
                            case "vw_occurrence_event":
                                styleHighLight = myOccurrences._eventOccurrenceHighlighStyles;
                                break;
                            case "vw_occurrence":
                                styleHighLight = myOccurrences._occurrenceHighlighStyles;
                                break;
                        };

                        // Highlight feature
                        myOccurrences._mapSgs.SetFeaturesHighlightByFeatureCol(arrayFeature, true, styleHighLight);

                        // Goto occurrence
                        myOccurrences._mapSgs.map.getView({
                            center: [arrayFeature[0].values_.geometry.flatCoordinates[0], arrayFeature[0].values_.geometry.flatCoordinates[1]]
                        });
                        myOccurrences._mapSgs.map.getView().setZoom(myOccurrences.ZoomSearch)
                    }
                    else
                        toastr["warning"](msgGoto);
                });
            }
        });
    };

	/**
	 * Start creation occurrence 
	 */
    this._CreateOccurrence = function () {

        var _occurrenceCreationForm = $('#form-creation-occurrence').serializeJSON();

        $.ajax({
            type: 'POST',
            url: '/rest/app/Occurrence/CreateOccurrence',
            data: JSON.stringify(_occurrenceCreationForm),
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na criação de ocorrência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            toastr["success"]("Ocorrência criada");
                            myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-creation-occurrence-form'], false);

                            var IdLayerOccurrence = app.sgs.Map.layerTree.GetLayerInfoArrayByLayerSourceName('vw_occurrence');
                            var layerNameEventOccurrence;
                            for (let i = 0; i < IdLayerOccurrence.length; i++) {
                                if (IdLayerOccurrence[i].cqlFilter === "cod_state = 'ABERTA'")
                                    layerNameEventOccurrence = IdLayerOccurrence[i].layerNameKey;
                            }

                            var RefreshLayerOccurrence = myOccurrences._utility.GetLayerByName(app.sgs.Map.map, layerNameEventOccurrence);
                            RefreshLayerOccurrence.getSource().clear();

                            break;
                        case 'NOT_FOUND':
                            toastr["warning"]("Nenhum evento encontrado");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na criação de ocorrência");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
            }
        });
    };

    /**
	 * Start creation occurrence 
	 */
    this._CreateOccurrenceWithoutEvent = function () {

        var _occurrenceCreationForm = $('#form-creation-occurrence').serializeJSON();

        _occurrenceCreationForm.id_user_register = myOccurrences._mapSgs._settings.userInfo.userId;

        $.ajax({
            type: 'POST',
            url: '/rest/app/Occurrence/CreateOccurrencewithoutEvent',
            data: JSON.stringify(_occurrenceCreationForm),
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na criação de ocorrência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            toastr["success"]("Ocorrência criada");
                            myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-creation-occurrence-form'], false);

                            var IdLayerOccurrence = app.sgs.Map.layerTree.GetLayerInfoArrayByLayerSourceName('vw_occurrence');
                            var layerNameEventOccurrence;
                            for (let i = 0; i < IdLayerOccurrence.length; i++) {
                                if (IdLayerOccurrence[i].cqlFilter === "cod_state = 'ABERTA'")
                                    layerNameEventOccurrence = IdLayerOccurrence[i].layerNameKey;
                            }

                            var RefreshLayerOccurrence = myOccurrences._utility.GetLayerByName(app.sgs.Map.map, layerNameEventOccurrence);
                            RefreshLayerOccurrence.getSource().clear();

                            break;
                        case 'NOT_FOUND':
                            toastr["warning"]("Nenhum evento encontrado");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na criação de ocorrência");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
            }
        });
    };

    /**
     * Create occurrence from event occurrence
     */
    this._CreateOccurrenceFromOccurrenceEvent = function () {
        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-details', true);

        var occurrenceCreationForm = $('#occurrence-detail-info-form').serializeJSON();

        // Remove id from Object - not needed
        delete occurrenceCreationForm.id;

        $.ajax({
            type: 'POST',
            url: '/rest/app/Occurrence/CreateOccurrenceFromOccurrenceEvent',
            data: JSON.stringify(occurrenceCreationForm),
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na criação da ocorrência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Get info element element
                            var featureInfo = { id: data.result.occurrence.id, layer_name: "occurrence", from_event_occurrence: true };

                            // Set Detail occurrence
                            myOccurrences._DetailOccurrence(featureInfo);

                            // Set indication of the go back in creation mode
                            $('#id-offcanvas-detail-occurrence-go-back').attr('mode', "CREATION");

                            // Refresh layer occurrence
                            myOccurrences._RefreshOccurrenceLayer();

                            toastr["success"]("Ocorrência criada com sucesso");
                            break;
                        default:
                            toastr["error"]("Erro na criação da ocorrência");
                            // Stop wait
                            myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
                    }
                }

                // Stop wait - The stop wait is made in the _DetailOccurrence function
                // myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na criação da ocorrência");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
            }
        });
    };

    /**
     * Save occurrence info
     */
    this._SaveOccurrenceInfo = function () {
        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-details', true);

        var occurrenceCreationForm = $('#occurrence-detail-info-form').serializeJSON();

        // Remove id_occurence_event from Object - not needed
        delete occurrenceCreationForm.id_occurrence_event;

        $.ajax({
            type: 'POST',
            url: '/rest/app/Occurrence/SaveOccurrenceInfo',
            data: JSON.stringify(occurrenceCreationForm),
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na gravação da ocorrência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Set critical code
                            if (data.result.occurrence.cod_critical) {
                                $('#occurrence-detail-info-box-critical')[0].className = "occurrence-detail-info-box critical " + data.result.occurrence.cod_critical.toLowerCase();
                                $('#occurrence-detail-info-box-critical')[0].setAttribute('title', data.result.occurrence.critical_description);
                            }
                            else {
                                $('#occurrence-detail-info-box-critical')[0].className = "occurrence-detail-info-box critical";
                                $('#occurrence-detail-info-box-critical')[0].setAttribute('title', 'Sem informação de criticidade');
                            }

                            toastr["success"]("Ocorrência gravada com sucesso");
                            break;
                        default:
                            toastr["error"]("Erro na gravação da ocorrência");
                    }
                }

                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na gravação da ocorrência");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
            }
        });
    };

    /**
     * Clean occurrence detail
     */
    this._CleanOccurrenceDetail = function () {
        // Clean information header
        $('#occurrence-detail-info-box-duration-day')[0].innerHTML = "";
        $('#occurrence-detail-info-box-critical')[0].className = "occurrence-detail-info-box critical";
        $('#occurrence-detail-info-box-critical')[0].setAttribute('title', 'Sem informação');
        $('#occurrence-detail-info-box-state')[0].className = "occurrence-detail-info-box state";
        $('#occurrence-detail-info-box-state')[0].setAttribute('title', 'Sem informação');
        $('#occurrence-detail-info-box-department')[0].className = "occurrence-detail-info-box department not_approved";
        $('#occurrence-detail-info-box-department')[0].setAttribute('title', 'Por aprovar');

        // Clean occurrence detail info
        for (let key in Object.keys($('#occurrence-detail-info-form').serializeJSON())) {
            $('#occurrence-detail-info-form [name=' + key + ']').val('');
        }

        // Clean occurrence detail state
        for (let key in Object.keys($('#occurrence-detail-state-form').serializeJSON())) {
            $('#occurrence-detail-state-form [name=' + key + ']').val('');
        }
        myOccurrences._datatableDetailOccurrenceStateHist.clear().draw();

        // Clean department occurrence
        $('#occurrence-detail-department-list').empty();

        // Clean team occurrence
        myOccurrences._arrayTeamsSelected = [];
        $("#team-detail-fields").empty();
        $('#occurrence-detail-team').empty();

        // Clean occurrence event
        myOccurrences._datatableOccurrenceEventFromOccurrence.clear().draw();
    };

	/**
     * Detail off occurrence
     * @param {object} featureInfo, Feature info
     */
    this._DetailOccurrence = function (featureInfo) {
        var layerName = "";
        if (featureInfo.feature && featureInfo.feature.getProperties().layer_name)
            layerName = featureInfo.feature.getProperties().layer_name;
        else
            layerName = featureInfo.layer_name;

        switch (layerName) {
            case "vw_occurrence":
            case "occurrence":
                myOccurrences._DetailOccurrenceInfo(featureInfo);
                break;
            case "vw_occurrence_event":
            case "occurrence_event":
                if (myOccurrences._mapSgs._settings.getVisibleOperations().OccurrenceEvent)
                    myOccurrences._DetailOccurrenceEventInfoInSiteEventOccurrence(featureInfo); // In site event occurrence
                else
                    myOccurrences._DetailOccurrenceEventInfo(featureInfo); // In site occurrence manager
                break;
            default:
                toastr["warning"]("Sem informação de detalhe");
        }
    }

	/**
     * Detail off occurrence
     * @param {object} featureInfo, Feature info
     */
    this._DetailOccurrenceInfo = function (featureInfo) {

        //Clean Date
        $('#occurrence-detail-info-form [name=date_effective_end]').val("");
        $('#occurrence-detail-info-form [name=date_effective_start]').val("");
        $('#occurrence-detail-info-form [name=date_planned_start]').val("");
        $('#occurrence-detail-info-form [name=date_planned_end]').val("");

        // -- Open off canvas --
        myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-detail-occurrence'], true);

        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-details', true);

        // Set occurrence title
        $('#offcanvas-head-occurrence-title')[0].innerHTML = "Ocorrência Nº";

        // Set occurrence id number
        $('#offcanvas-head-id-occurrence')[0].innerHTML = featureInfo.id;

        // Go back if exists
        if (featureInfo.from_event_occurrence) {
            $('#id-offcanvas-detail-occurrence-go-back').removeClass('ol-hidden');
        }
        else {
            $('#id-offcanvas-detail-occurrence-go-back').addClass('ol-hidden');
        }

        // Layer info
        var layerName = "";
        if (featureInfo.idLayer) {
            var layerObj = myOccurrences._mapSgs.layerTree.layerInfo.dict_layer_info[featureInfo.idLayer];
            layerName = layerObj.layer_info.layerName;
        }
        else {
            layerName = featureInfo.layer_name;
        }

        // Set id
        $('#id_occurrence_detail').val(featureInfo.id);

        // Clean occurrence detail
        myOccurrences._CleanOccurrenceDetail();

        // Active scroll
        $('.dataTables_scrollBody').addClass('gp-overflow-datatable');

        // Show tab for occurrence detail
        $('.occurrence-detail-create-not-use').removeClass('ol-hidden');

        // Close detail info
        if ($('#occurrence-detail-info').is(':visible'))
            $('#occurrence-detail-info').toggle('ol-hidden');

        // Define button create Occurrence
        if ($('#occurrence-detail-save-button').length > 0) {
            $('#occurrence-detail-save-button').attr('mode', 'SAVE');
            $('#occurrence-detail-save-button').attr('title', 'Gravar ocorrência');
        }

        // Set id user
        $('#occurrence-detail-id-user').val(myOccurrences._mapSgs._settings.userInfo.userId);

        // Define operation according if user have or not department associate        
        var operation = "";
        if( myOccurrences._mapSgs._settings.userInfo.list_department.length > 0)
        {
            // User with department define
            operation = '/rest/app/Occurrence/GetOccurrenceByIdAndDepartments?id=' + featureInfo.id + '&departments=' + app.sgs.Map._settings.userInfo.list_department.map(a => a.cod_department).toString();
        }
        else
        {
            // User with no department define
            operation = '/rest/app/Occurrence/GetOccurrenceById?id=' + featureInfo.id;
        }

        $.ajax({
            type: 'GET',
            url: operation,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da ocorrência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':

                            // -- Fill occurrence info & state detail -- 
                            for (let key in data.result.occurrence) {
                                let value = data.result.occurrence[key];
                                if (value || value === 0) {
                                    switch (key) {
                                        case "cod_state":
                                            $('#occurrence-detail-state-form [name=' + key + ']').val(value);
                                            $('#occurrence-detail-state-form [name=' + key + ']').selectpicker("refresh");
                                            $('#occurrence-detail-info-box-state')[0].className = "occurrence-detail-info-box state " + value.toLowerCase();
                                            break;
                                        case "date_state":
                                            $('#occurrence-detail-state-form [name=' + key + ']').val(myOccurrences._utility.TransformDateServerInDateII(value));
                                            break;
                                        case "cod_type":
                                            $('#occurrence-detail-info-form [name=' + key + ']').val(value);
                                            $('#occurrence-detail-info-form [name=' + key + ']').selectpicker("refresh");
                                            var arraySubtype = myOccurrences._hashReference['occurrence_subtype'][value];
                                            myOccurrences._utility.FillSelect('occurrence-detail-subtype-select', arraySubtype, 'description', 'cod_subtype');
                                            break;
                                        case "cod_subtype":
                                            $('#occurrence-detail-info-form [name=' + key + ']').val(value);
                                            $('#occurrence-detail-info-form [name=' + key + ']').selectpicker("refresh");
                                            break;
                                        case "date_creation":
                                            $('#occurrence-detail-info-form [name=' + key + ']').val(myOccurrences._utility.TransformDateServerInDateII(value));
                                            break;
                                        case "duration_day":
                                            $('#occurrence-detail-info-box-duration-day')[0].innerHTML = value;
                                            break;
                                        case "state_description":
                                            $('#occurrence-detail-info-box-state')[0].setAttribute('title', value);
                                            break;
                                        case "cod_critical":
                                            $('#occurrence-detail-info-form [name=' + key + ']').val(value);
                                            $('#occurrence-detail-info-form [name=' + key + ']').selectpicker("refresh");
                                            $('#occurrence-detail-info-box-critical')[0].className = "occurrence-detail-info-box critical " + value.toLowerCase();
                                            break;
                                        case "critical_description":
                                            $('#occurrence-detail-info-box-critical')[0].setAttribute('title', value);
                                            break;
                                        case "user_name":
                                            $('#occurrence-detail-info-form [name=' + key + ']').html(value)
                                            break;
                                        case "date_planned_start":
                                            $('#occurrence-detail-info-form [name=' + key + ']').val(myOccurrences._utility.TransformDateServerInDateII(value));
                                            break;
                                        case "date_planned_end":
                                            $('#occurrence-detail-info-form [name=' + key + ']').val(myOccurrences._utility.TransformDateServerInDateII(value));
                                            break;
                                        default:
                                            $('#occurrence-detail-info-form [name=' + key + ']').val(value);
                                    }
                                }
                            }

                            // -- Fill state hist occurrence --
                            var countElement = data.result.list_hist_state.length;
                            for (let i = 0; i < countElement; i++) {
                                var objEvent = data.result.list_hist_state[i];
                                objEvent.date_state = myOccurrences._utility.TransformDateServerInDateII(objEvent.date_state);
                                myOccurrences._datatableDetailOccurrenceStateHist.row.add({
                                    id: objEvent.id,
                                    cod_state: objEvent.description_state,
                                    date_state: objEvent.date_state,
                                    description: objEvent.description
                                });
                            }
                            myOccurrences._datatableDetailOccurrenceStateHist.draw();

                            // -- Fill department occurrence --
                            for (let i = 0; i < data.result.list_department.length; i++) {
                                var departmentObj = data.result.list_department[i];
                                myOccurrences._AddDepartmentInOccurrenceDetail(featureInfo.id, departmentObj.cod_department, departmentObj.department_name, true, departmentObj.cod_approved);
                            }

                            // Update department indicator state appproved
                            myOccurrences._UpdateIndicatorStateApprovedDepartment();

                            // -- Fill team department occurrence --
                            for (let i = 0; i < data.result.list_department_team.length; i++) {
                                var departmentObj = data.result.list_department_team[i];
                                myOccurrences._SetDepartmentTeamInOccurrenceDetail(featureInfo.id, departmentObj.cod_department, departmentObj.department_name, true);
                            }

                            // -- Fill team occurrence --
                            for (let i = 0; i < data.result.list_team.length; i++) {
                                var teamOccurrenceObj = data.result.list_team[i];
                                myOccurrences._CloneDivTeamOccurrence(teamOccurrenceObj.id_occurrence, teamOccurrenceObj.id_team, teamOccurrenceObj.cod_department, teamOccurrenceObj, true);
                            }

                            // -- Fill occurrence event --
                            for (let i = 0; i < data.result.list_occurrence_event.length; i++) {
                                var objEvent = data.result.list_occurrence_event[i];
                                myOccurrences._datatableOccurrenceEventFromOccurrence.row.add({
                                    id: objEvent.id,
                                    workspace: myOccurrences._workspace,
                                    layer_name: myOccurrences._layerNameOccurrenceEvent,
                                    description: objEvent.description,
                                    state_description: objEvent.state_description,
                                    description_preview: objEvent.description
                                });
                            }
                            myOccurrences._datatableOccurrenceEventFromOccurrence.draw();

                            // -- Attachment --
                            if (myOccurrences._mapSgs._uploadAttachtment)
                                myOccurrences._mapSgs._uploadAttachtment.LoadAttachment(featureInfo.id, layerName, 'id-offcanvas-body-layer-detail-attachment-zone', 'id-offcanvas-body-layer-detail-attachment-form', 'id-offcanvas-body-layer-detail-attachment-add', 'offcanvas-body-layer-detail-attachment-info-td', 'id-offcanvas-body-layer-detail-attachment-spinner');

                            var cod_state_data = "";
                            for (let i = 0; i < data.result.list_hist_state.length; i++) {
                                if (data.result.list_hist_state[i].cod_state == 'EM_RESOLUCAO') {
                                    if (cod_state_data == "" || (cod_state_data.date_action > data.result.list_hist_state[i].date_action)) {
                                        $('#occurrence-detail-info-form [name=date_effective_start]').val(data.result.list_hist_state[i].date_state);
                                        cod_state_data = data.result.list_hist_state[i];
                                    }

                                }
                                else if (data.result.list_hist_state[i].cod_state == 'CONCLUIDA') {
                                    if (cod_state_data == "" || cod_state_data.date_action < data.result.list_hist_state[i].date_action) {
                                        $('#occurrence-detail-info-form [name=date_effective_end]').val(data.result.list_hist_state[i].date_state);
                                        cod_state_data = data.result.list_hist_state[i];
                                    }

                                }
                            }

                            if ($('#occurrence-detail-info-form [name=date_planned_start]').val() == "") {
                                $('#id-date-planned-occurrence-detail').addClass('ol-hidden');
                            }
                            else {
                                $('#id-date-planned-occurrence-detail').removeClass('ol-hidden');
                            }

                            //Get occurrence intervention zone
                            occurrenceinterventiozoneData = data.result.occurrence_interventio_zone;

                            //Hidde button create intervention zone
                            if (occurrenceinterventiozoneData != null) {
                                $('#occurrence-create-polygon-button').addClass('ol-hidden');
                                $('#occurrence-view-polygon-button').removeClass('ol-hidden');
                                $('#occurrence-delete-polygon-button').removeClass('ol-hidden');
                                $('#occurrence-confirm-polygon-button').addClass('ol-hidden');
                                $('#occurrence-cancel-polygon-button').addClass('ol-hidden');

                                if ($('#occurrence-view-polygon-button').hasClass('fa-eye-slash')) {
                                    $('#occurrence-view-polygon-button').removeClass('fa-eye-slash')
                                    $('#occurrence-view-polygon-button').addClass('fa-eye')
                                    $('#occurrence-confirm-polygon-button').addClass('ol-hidden');
                                    $('#occurrence-cancel-polygon-button').addClass('ol-hidden');
                                }

                            } else {
                                $('#occurrence-create-polygon-button').removeClass('ol-hidden');
                                $('#occurrence-view-polygon-button').addClass('ol-hidden');
                                $('#occurrence-delete-polygon-button').addClass('ol-hidden');
                                $('#occurrence-confirm-polygon-button').addClass('ol-hidden');
                                $('#occurrence-cancel-polygon-button').addClass('ol-hidden');
                            }



                            break;                            
                        default:
                    }
                }
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da ocorrência");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
            }
        });
    }

	/**
	 * Creation clone div to team occurrence
	 * @param {int} idOccurrence, occurence identifier
	 * @param {int} idTeam, team identifier
     * @param {string} codDepartment, departement code
	 * @param {object} teamOccurrenceObj, team occurrence information
     * @param {bool} getCommentFromServer, get comment from server
	 */
    this._CloneDivTeamOccurrence = function (idOccurrence, idTeam, codDepartment, teamOccurrenceObj, getCommentFromServer) {
        // Id form
        var idForm = 'form-team-detail-occurrence-' + idOccurrence + '-' + idTeam;

        // -- Clone Form --

        // get the last DIV which ID starts with ^= "klon"
        var $div = $('#form-team-detail-occurrence');

        // Clone it and assign the new ID
        var $klon = $div.clone().prop('id', idForm);
        $klon.attr('id-team', idTeam);

        // Finally insert $klon wherever you want
        $('.occurrence-detail-department-team-added-zone[cod-department="' + codDepartment + '"] .occurrence-detail-department-team-list-zone').append($klon);

        // Add select state team
        var departmentElementTeamStateZone = $('#' + idForm + ' .select-state')[0];
        if (departmentElementTeamStateZone) {
            var departmentElementTeamStateSelect = document.createElement('select');
            departmentElementTeamStateSelect.className = "data-team-detail-occurrence-state form-control";
            departmentElementTeamStateSelect.name = "cod_state";
            departmentElementTeamStateSelect.id = "id-data-team-detail-occurrence-state-" + idOccurrence + "-" + idTeam;
            departmentElementTeamStateZone.appendChild(departmentElementTeamStateSelect);
        }

        // Fill state
        myOccurrences._utility.FillSelect("id-data-team-detail-occurrence-state-" + idOccurrence + "-" + idTeam, myOccurrences._hashReference['occurrence_resolution_state'], 'description', 'cod_ref');

        // -- Button action team department --
        var departmentElementButtonActionTeam = $('#form-team-detail-occurrence-' + idOccurrence + '-' + idTeam + ' .occurrence-detail-row.button')[0]

        // Button save team
        if (myOccurrences._mapSgs.getSettings().getVisibleOperations().Occurrence.ManagerDepartmentInfoTeam) {
            var departmentElementTeamButtonSave = document.createElement('button');
            departmentElementTeamButtonSave.setAttribute('type', 'button');
            departmentElementTeamButtonSave.className = 'btn btn-sm btn-primary occurrence-detail-department-button occurrence-detail-department-team-save-button';
            departmentElementTeamButtonSave.setAttribute('title', 'Gravar informação de equipa');
            var departmentElementTeamButtonConfirmIcon = document.createElement('i');
            departmentElementTeamButtonConfirmIcon.className = 'fa fa-save';
            departmentElementTeamButtonSave.appendChild(departmentElementTeamButtonConfirmIcon);
            departmentElementButtonActionTeam.appendChild(departmentElementTeamButtonSave);
        }
        // Button delete team
        if (myOccurrences._mapSgs.getSettings().getVisibleOperations().Occurrence.ManagerDepartmentInfoTeam) {
            var departmentElementTeamButtonDelete = document.createElement('button');
            departmentElementTeamButtonDelete.setAttribute('type', 'button');
            departmentElementTeamButtonDelete.className = 'btn btn-sm btn-primary occurrence-detail-department-button occurrence-detail-department-team-delete-button';
            departmentElementTeamButtonDelete.setAttribute('title', 'Remover equipa');
            var departmentElementTeamButtonDeleteIcon = document.createElement('i');
            departmentElementTeamButtonDeleteIcon.className = 'fa fa-trash';
            departmentElementTeamButtonDelete.appendChild(departmentElementTeamButtonDeleteIcon);
            departmentElementButtonActionTeam.appendChild(departmentElementTeamButtonDelete);
        }
        // Button show comment team
        var departmentElementTeamButtonShowComment = document.createElement('button');
        departmentElementTeamButtonShowComment.setAttribute('type', 'button');
        departmentElementTeamButtonShowComment.className = 'btn btn-sm btn-primary occurrence-detail-department-button occurrence-detail-department-team-show-comment-button';
        departmentElementTeamButtonShowComment.setAttribute('title', 'Visualizar os comentários');
        var departmentElementTeamButtonShowCommentIcon = document.createElement('i');
        departmentElementTeamButtonShowCommentIcon.className = 'fa fa-eye';
        departmentElementTeamButtonShowComment.appendChild(departmentElementTeamButtonShowCommentIcon);
        departmentElementButtonActionTeam.appendChild(departmentElementTeamButtonShowComment);
        // Button add comment team
        var departmentElementButtonAddComment = document.createElement('button');
        departmentElementButtonAddComment.setAttribute('type', 'button');
        departmentElementButtonAddComment.className = 'btn btn-sm btn-primary occurrence-detail-department-button occurrence-detail-department-team-add-comment-button';
        departmentElementButtonAddComment.setAttribute('title', 'Visualizar os comentários');
        var departmentElementButtonAddCommentIcon = document.createElement('i');
        departmentElementButtonAddCommentIcon.className = 'fa fa-comment';
        departmentElementButtonAddComment.appendChild(departmentElementButtonAddCommentIcon);
        departmentElementButtonActionTeam.appendChild(departmentElementButtonAddComment);
        // Button notify team
        if (myOccurrences._mapSgs.getSettings().getVisibleOperations().Occurrence.ManagerDepartmentInfoTeam) {
            var departmentElementButtonNotify = document.createElement('button');
            departmentElementButtonNotify.setAttribute('type', 'button');
            departmentElementButtonNotify.className = 'btn btn-sm btn-primary occurrence-detail-department-button occurrence-detail-department-team-notify-button';
            departmentElementButtonNotify.setAttribute('title', 'Notificar chefe de equipa');
            departmentElementButtonNotify.id = idTeam;
            var departmentElementButtonNotifyIcon = document.createElement('i');
            departmentElementButtonNotifyIcon.className = 'fa fa-envelope-o';
            departmentElementButtonNotify.appendChild(departmentElementButtonNotifyIcon);
            departmentElementButtonActionTeam.appendChild(departmentElementButtonNotify);
        }
        // -- Comment --
        var departmentElementDivComment = document.createElement('div');
        departmentElementDivComment.className = 'form-group-team-detail occurrence-detail-department-team-list-comment';
        departmentElementDivComment.setAttribute('style', 'display: none;');
        departmentElementButtonActionTeam.appendChild(departmentElementDivComment);

		//save all teams selected
        myOccurrences._arrayTeamsSelected.push(teamOccurrenceObj);

        // -- Fill clone form --
        for (let key in teamOccurrenceObj) {
            $('.form-team-detail').css({ 'display': 'block' });
            var value = teamOccurrenceObj[key];
            switch (key) {
                case "date_end":
                case "date_begin":
                    $('#' + idForm + ' [name=' + key + ']').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });
                    $('#' + idForm + ' [name=' + key + ']').val(myOccurrences._utility.TransformDateServerInDateII(value));
                    break;
                case "cod_state":
                    $('#' + idForm + ' [name=' + key + ']').val(value);
                    $('#' + idForm + ' [name=' + key + ']').selectpicker("refresh");
                    break;
                default:
                    $('#' + idForm + ' [name=' + key + ']').val(value);
            }
        }

        // Add comment if load from server
        if (getCommentFromServer) {
            myOccurrences._GetAllCommentFromDepartmentOccurrenceTeam(idOccurrence, idTeam);
        }

        // -- Create event --

        // Save team department
        $('#' + idForm + ' .occurrence-detail-department-team-save-button').on('click', function () {
            var formTeamOccurrence = $(this).parent().parent().serializeJSON();
            myOccurrences._SaveTeamOccurrenceDetails(formTeamOccurrence);
        });

        // Remove team department
        $('#' + idForm + ' .occurrence-detail-department-team-delete-button').on('click', function () {
            var formTeamOccurrence = $(this).parent().parent().serializeJSON();

            // Get info
            var idOccurrence = formTeamOccurrence.id_occurrence;
            var idTeam = formTeamOccurrence.id_team;

            // Set modal info
            $('#modal-ok-cancel').attr('mode', 'REMOVE_TEAM_OCCURRENCE');
            $('#modal-ok-cancel').attr('id-occurrence', idOccurrence);
            $('#modal-ok-cancel').attr('id-team', idTeam);

            // hide offcanvas
            myOccurrences._utility.ShowOpenCanvas(false);
            // set vars and display modal CONFIRM DELETE
            $('#header-modal-ok-cancel').text('Tem a certeza?');
            $('#modal-ok-cancel').css({ 'display': 'block' });
        });

        // Event show comment
        $('#' + idForm + ' .occurrence-detail-department-team-show-comment-button').on('click', function () {
            var formTeamOccurrence = $(this).parent().parent().serializeJSON();
            var idOccurrence = formTeamOccurrence.id_occurrence;
            var idTeam = formTeamOccurrence.id_team;

            // Id form
            var idForm = 'form-team-detail-occurrence-' + idOccurrence + '-' + idTeam;

            // Check if exists any comment
            if ($('#' + idForm + ' .occurrence-detail-department-team-list-comment').children().length === 0 && !$('#' + idForm + ' .occurrence-detail-department-team-list-comment').is(':visible')) {
                toastr["warning"]("Não existem comentários para esta equipa");
                return;
            }

            // Change icon button
            $(this).find('i').toggleClass('fa-eye fa-eye-slash');

            // Show hide comment
            $('#' + idForm + ' .occurrence-detail-department-team-list-comment').toggle('ol-hidden')
        });

        // Event add comment
        $('#' + idForm + ' .occurrence-detail-department-team-add-comment-button').on('click', function () {
            var formTeamOccurrence = $(this).parent().parent().serializeJSON();

            // Clean comment textarea
            $('#modal-occurrence-comment-input').val('');

            // Get id occurrence
            var idOccurrence = formTeamOccurrence.id_occurrence;
            var idTeam = formTeamOccurrence.id_team;
            var key = idOccurrence + myOccurrences._keySeparator + idTeam;

            // Set parameter
            $('#modal-occurrence-comment').attr('target-context', 'occurrence-detail-department-team-add-comment');
            $('#modal-occurrence-comment').attr('key-context', key);

            // Show modal comment
            $('#modal-occurrence-comment').css({ 'display': 'block' });
        });

        // Event notify
        $('#' + idForm + ' .occurrence-detail-department-team-notify-button').on('click', function () {

            var formTeamOccurrence = $(this).parent().parent().serializeJSON();

            myOccurrences._GetTeamNotification(formTeamOccurrence);

        });
    };

    /**
     * Detail off occurrence
     * @param {string} cod_department, department code
     * @param {string} TypeExecutionTeam, type execution team
     */
    this._DetailModalOccurrenceTeam = function (cod_department, TypeExecutionTeam) {

        // Start wait
        myOccurrences._utility.ShowWait('spiner-modal-team', true);

        $.ajax({
            type: 'GET',
            url: '/rest/app/Occurrence/GetTeamByDepartment?cod_department=' + cod_department,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção das equipas");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            var countElement = data.result.list_team_name_occurrence.length;
                            myOccurrences._datatableDetailOccurrenceTeam.clear().draw();
                            if (TypeExecutionTeam !== 'ChangeDepartmentTeam')
                                myOccurrences._datatableDetailOccurrenceTeamCheck.clear().draw();
                            // Fill datatable
							for (var i = 0; i < countElement; i++) {
								var objEvent = data.result.list_team_name_occurrence[i];
								
                                for (var ii = 0; ii < myOccurrences._arrayTeamsSelected.length; ii++) {
                                    if (objEvent.id_team === myOccurrences._arrayTeamsSelected[ii].id_team && TypeExecutionTeam !== 'ChangeDepartmentTeam') {
										myOccurrences._datatableDetailOccurrenceTeamCheck.row.add({
											id: objEvent.id_team,
											name: objEvent.name,
											name_team_leader: objEvent.name_team_leader,
											cod_department: objEvent.name_department,
											description: objEvent.description
										});
									}
								}

                                myOccurrences._datatableDetailOccurrenceTeam.row.add({
                                    id: objEvent.id_team,
                                    name: objEvent.name,
                                    name_team_leader: objEvent.name_team_leader,
                                    cod_department: objEvent.name_department,
                                    description: objEvent.description
                                });
                            }
                            myOccurrences._datatableDetailOccurrenceTeam.draw();
                            myOccurrences._datatableDetailOccurrenceTeamCheck.draw();

                            //Close all open canvas/offcanvas and open modal team
                            myOccurrences._utility.ShowOpenCanvas(false);
                            $('.fixedHeader-floating').css({ 'visibility': 'hidden' });
                            $('#modal-team-Occurrence-detail').css({ 'display': 'block' });
                            break;
                        case 'NOT_FOUND':
                        case 'ERROR':
                            toastr["error"]("Erro na obtenção das equipas");
                            break;
                        default:
                    }
                }
                // Stop wait
                myOccurrences._utility.ShowWait('spiner-modal-team', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da ocorrência");
                // Stop wait
                myOccurrences._utility.ShowWait('spiner-modal-team', false);
            }
        });
    };

	/**
	 * Save changes off occurrence
	 * @param {any} state, code state
	 * @param {any} description, description
	 */
    this._SaveStateOccurrence = function (state, description) {

        //clean modal values
        $('#modal-description-detail-occurrence').val('');

        //Get id occurrence
        var id = $('#id_occurrence_detail').val();

        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-details', true);

		$.ajax({
			type: 'POST',
			url: '/rest/app/Occurrence/SaveStateOccurrence?id=' + id + '&cod_state=' + state + '&description=' + description,
            contentType: "application/json",
            async: true,
			success: function (data) {
				if (data.error) {
                    toastr["error"]("Erro de gravação");
				}
				else {
					switch (data.result.status) {
						case 'SUCCESS':
							// Clear datatable state hist
                            myOccurrences._datatableDetailOccurrenceStateHist.clear().draw();

                            var countElement = data.result.stateOccurrenceResult.length;
                            for (let i = 0; i < countElement; i++) {
                                var objEvent = data.result.stateOccurrenceResult[i];
                                objEvent.date_state = myOccurrences._utility.TransformDateServerInDateII(objEvent.date_state);
                                myOccurrences._datatableDetailOccurrenceStateHist.row.add({
                                    id: objEvent.id,
                                    cod_state: objEvent.description_state,
                                    date_state: objEvent.date_state,
                                    description: objEvent.description
                                });
                            }
                            myOccurrences._datatableDetailOccurrenceStateHist.draw();

                            // Update state information
                            if (data.result.occurrence && data.result.occurrence.cod_state) {
                                $('#occurrence-detail-info-box-state')[0].className = "occurrence-detail-info-box state " + data.result.occurrence.cod_state.toLowerCase();
                                $('#occurrence-detail-info-box-state')[0].setAttribute('title', data.result.occurrence.state_description);
                            }
                            else {
                                $('#occurrence-detail-info-box-state')[0].className = "occurrence-detail-info-box state";
                                $('#occurrence-detail-info-box-state')[0].setAttribute('title', "Sem estado definido");
                            }

                            data.result.stateOccurrenceResult[0].cod_state

                            // Update date effective
                            var cod_state_data = "";
                            for (let i = 0; i < data.result.stateOccurrenceResult.length; i++) {
                                if (data.result.stateOccurrenceResult[i].cod_state == 'EM_RESOLUCAO') {
                                    if (cod_state_data == "" || cod_state_data.date_action > data.result.stateOccurrenceResult[i].date_action)
                                        cod_state_data = data.result.stateOccurrenceResult[i];
                                    $('#occurrence-detail-info-form [name=date_effective_start]').val(cod_state_data.date_state);

                                }
                                else if (data.result.stateOccurrenceResult[i].cod_state == 'CONCLUIDA') {
                                    if (cod_state_data == "" || cod_state_data.date_action < data.result.stateOccurrenceResult[i].date_action)
                                        cod_state_data = data.result.stateOccurrenceResult[i];
                                    $('#occurrence-detail-info-form [name=date_effective_end]').val(cod_state_data.date_state);

                                }
                            }

                            // Refresh occurrence layer
                            myOccurrences._RefreshOccurrenceLayer();

                            toastr["success"]("Gravação efectuada com sucesso");
                            break;
                        case 'NOT_FOUND':
                        case 'ERROR':
                            toastr["error"]("Erro de gravação");
                            break;
                        default:
                    }
                }

                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de gravação");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
            }
        });
    };

    /**
     * Save state changes off occurrence
     * @param {string} state, code state
     * @param {string} description, description
     */
    this._SaveStateOccurrenceEvent = function (state, description) {

        //clean modal values
        $('#modal-description-detail-occurrence-event').val('');

        // Get id occurrence
        var id = $('#id_occurrence_event_detail').val();

        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-event-details', true);

        $.ajax({
            type: 'POST',
            url: '/rest/app/Occurrence/SaveStateOccurrenceEvent?id=' + id + '&cod_state=' + state + '&description=' + description,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro de gravação");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Clear datatable state hist
                            myOccurrences._datatableDetailOccurrenceEventStateHist.clear().draw();

                            // Set history list
                            var countElement = data.result.occurrence_event_current_state_hist.length;
                            for (let i = 0; i < countElement; i++) {
                                var objEvent = data.result.occurrence_event_current_state_hist[i];
                                objEvent.date_state = myOccurrences._utility.TransformDateServerInDateII(objEvent.date_state);
                                myOccurrences._datatableDetailOccurrenceEventStateHist.row.add({
                                    id: objEvent.id,
                                    cod_state: objEvent.description_state,
                                    date_state: objEvent.date_state,
                                    description: objEvent.description
                                });
                            }
                            myOccurrences._datatableDetailOccurrenceEventStateHist.draw();

                            // Set Date
                            $('#occurrence-event-detail-date-state').val(myOccurrences._utility.TransformDateServerInDateII(data.result.occurrence_event_current_state.date_state));

                            //  Refresh layer occurrence event
                            myOccurrences._RefreshOccurrenceEventLayer();

                            toastr["success"]("Gravação efectuada com sucesso");
                            break;
                        case 'NOT_FOUND':
                        case 'ERROR':
                            toastr["error"]("Erro de gravação");
                            break;
                        default:
                    }
                }

                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de gravação");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            }
        });

    };

	/**
	 * Add team to occurrence
	 * @param {int} idTeamAdd, team identifier
	 * @param {int} IdOccurrence, occurrence identifier
     * @param {string} codDepartment, department code
	 */
    this._AddTeamToOccurence = function (idTeamAdd, IdOccurrence, codDepartment) {

        // Build array of teams
        var arrayTeamOccurrence = [];
        for (i = 0; i < idTeamAdd.length; i++) {
            arrayTeamOccurrence.push({
                id_occurrence: parseInt(IdOccurrence),
                cod_department: codDepartment,
                id_team: idTeamAdd[i],
                id_user: myOccurrences._mapSgs._settings.userInfo.userId
            });
        }

		// Start wait
		myOccurrences._utility.ShowWait('spinner-occurrence-details', true);

        $.ajax({
            type: 'POST',
            url: '/rest/app/Occurrence/AddTeamToOccurrence',
            data: JSON.stringify(arrayTeamOccurrence),
            dataType: 'json',
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na adição de equipas");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Build team structure element
							for (let i = 0; i < data.result.list_new_resoltion.length; i++) {
								var teamOccurrenceObj = data.result.list_new_resoltion[i];
                                myOccurrences._CloneDivTeamOccurrence(teamOccurrenceObj.id_occurrence, teamOccurrenceObj.id_team, teamOccurrenceObj.cod_department, teamOccurrenceObj, false);
                            }
                            toastr["success"]("Equipa(s) adicionada(s) com sucesso");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na adição de equipas");
                            break;
                        default:
                    }
                }

                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
            },
			error: function (request, status, error) {
                toastr["error"]("Erro na adição de equipas");
				// Stop wait
				myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
            }
        });
    };

    /**
     * Add a comment department team to a occurrence
     * @param {string} idOccurrence, occurrence id
     * @param {string} idTeam, team id
     * @param {string} comment, comment
     */
    this._AddCommentToDepartmentTeamOccurrence = function (idOccurrence, idTeam, comment) {

        $.ajax({
            type: 'POST',
            url: '/rest/app/Occurrence/AddCommentToDepartmentTeamOccurrence?idOccurrence=' + idOccurrence + '&idTeam=' + idTeam + '&idUser=' + myOccurrences._mapSgs._settings.userInfo.userId + '&comment=' + comment,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na adição do comentário");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Id form
                            var idForm = 'form-team-detail-occurrence-' + idOccurrence + '-' + idTeam;

                            // Get element list comment
                            var commentListElement = $('#' + idForm + ' .occurrence-detail-department-team-list-comment')[0];

                            var dateFormated = myOccurrences._utility.TransformDateServerInDateTime(data.result.info_comment.date_comment)
                            myOccurrences._AddCommentToElement(commentListElement, data.result.info_comment.id_comment, 'team', data.result.info_comment.user_name, data.result.info_comment.user_name, dateFormated, comment, true);
                            toastr["success"]("Comentário adicionado com sucesso");

                            // Close modal
                            $('#modal-occurrence-comment').toggle('ol-hidden');
                            break;
                        default:
                            toastr["error"]("Erro na adição do comentário");
                    }
                }

                // Stop wait
                myOccurrences._utility.ShowWait('spiner-modal-comment', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na adição do comentário");
                // Stop wait
                myOccurrences._utility.ShowWait('spiner-modal-comment', false);
            }
        });
    };

    /**
     * Get all comment from department occurrence team
     * @param {int} idOccurrence, occurrence id
     * @param {int} idTeam, department code
     */
    this._GetAllCommentFromDepartmentOccurrenceTeam = function (idOccurrence, idTeam) {

        $.ajax({
            type: 'GET',
            url: '/rest/app/Occurrence/GetAllCommentFromDepartmentTeamOccurrence?idOccurrence=' + idOccurrence + '&idTeam=' + idTeam,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção dos comentários da equipa");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Id form
                            var idForm = 'form-team-detail-occurrence-' + idOccurrence + '-' + idTeam;

                            // Get element list comment
                            var commentListElement = $('#' + idForm + ' .occurrence-detail-department-team-list-comment')[0];

                            // Add all comment from department
                            for (var i = 0; i < data.result.list_comment.length; i++) {
                                var commentObj = data.result.list_comment[i];
                                var dateFormated = myOccurrences._utility.TransformDateServerInDateTime(commentObj.date)
                                myOccurrences._AddCommentToElement(commentListElement, commentObj.id, 'team', commentObj.cod_department, commentObj.username, dateFormated, commentObj.comment, false);
                            }
                            break;
                        case "NOT_FOUND":
                            break;
                        default:
                            toastr["error"]("Erro na obtenção dos comentários da equipa");
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção dos comentários da equipa");
            }
        });
    };

    /**
     * Get description of occurrence to modal
     * @param {any} id, id occurrence
     */
    this._GetDescriptionDetail = function (id) {
        var data = myOccurrences._datatableDetailOccurrenceStateHist.data();
        var i;
        for (i = 0; i < myOccurrences._datatableDetailOccurrenceStateHist.data().length; i++) {
            if (data[i].id === id) {
                if (data[i].description !== null) {
                    $('#modal-description-detail-review').val(data[i].description);
                    myOccurrences._utility.ShowOpenCanvas(false);
                    $('#modal-description-occurrence-detail').css({ 'display': 'block' });
                } else
                    toastr["warning"]("Não existe descrição");
            }
        }
    };

    /**
     * Get description of occurrence event to modal
     * @param {any} id, id occurrence
     */
    this._GetDescriptionEventStateDetail = function (id) {
        var data = myOccurrences._datatableDetailOccurrenceEventStateHist.data();
        var i;
        for (i = 0; i < myOccurrences._datatableDetailOccurrenceEventStateHist.data().length; i++) {
            if (data[i].id === id) {
                if (data[i].description !== null) {
                    $('#modal-description-detail-review').val(data[i].description);
                    myOccurrences._utility.ShowOpenCanvas(false);
                    $('#modal-description-occurrence-detail').css({ 'display': 'block' });
                } else
                    toastr["warning"]("Não existe descrição");
            }
        }
    };

	/**
	 * Remove team off occurrence on click
     * @param {int} idOccurrence, occurrence identifier
     * @param {int} idTeam, team identifier
	 */
    this._RemoveTeamOccurrence = function (idOccurrence, idTeam) {

        // Parse to int de id team
        var idTeamInt = parseInt(idTeam);

        // Remove team from array of teams
        for (let i = 0; i < myOccurrences._arrayTeamsSelected.length; i++) {
            if (idTeamInt === myOccurrences._arrayTeamsSelected[i].id_team)
                myOccurrences._arrayTeamsSelected.splice(i, 1);
        }

        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-details', true);

		$.ajax({
			type: 'DELETE',
			url: '/rest/app/Occurrence/RemoveTeamOccurrence?id_team=' + idTeam + '&id_occurrence=' + idOccurrence,
            contentType: "application/json",
            async: true,
			success: function (data) {
				if (data.error) {
                    toastr["error"]("Erro na remoção da equipa");
				}
				else {
					switch (data.result.status) {
                        case 'SUCCESS':
                            var idForm = 'form-team-detail-occurrence-' + idOccurrence + '-' + idTeam;
                            // Remove team from 
                            $('#' + idForm).remove();

                            // Close form question
                            myOccurrences._utility.ShowOpenCanvas(true);
                            $('#modal-ok-cancel').css({ 'display': 'none' });

							toastr["success"]("Equipa removida com sucesso");
							break;
						case 'NOT_FOUND':
						case 'ERROR':
							toastr["error"]("Erro na remoção da equipa");
							break;
                        default:
                            toastr["error"]("Erro na remoção da equipa");
					}
                }
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
			},
            error: function (request, status, error) {
                toastr["error"]("Erro na remoção da equipa");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
			}
		});
	};

	/**
	 * Save Team Occurrence Details
	 * @param {object} formTeamOccurrenceSaveObj, form object team occurrence
	 */
    this._SaveTeamOccurrenceDetails = function (formTeamOccurrenceSaveObj) {
        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-details', true);

		$.ajax({
			type: 'POST',
			url: '/rest/app/Occurrence/SaveDetailsTeamOccurrence',
            data: JSON.stringify(formTeamOccurrenceSaveObj),
			dataType: 'json',
            contentType: "application/json",
            async: true,
			success: function (data) {
				if (data.error) {
                    toastr["error"]("Erro na actualização da informação da equipa");
				}
				else {
					switch (data.result.status) {
                        case 'SUCCESS':
                            var idForm = 'form-team-detail-occurrence-' + formTeamOccurrenceSaveObj.id_occurrence + '-' + formTeamOccurrenceSaveObj.id_team;

                            // Data begin
                            if (data.result.date_begin) {
                                $('#' + idForm + ' [name=date_begin]').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });
                                $('#' + idForm + ' [name=date_begin]').val(myOccurrences._utility.TransformDateServerInDateII(data.result.date_begin));
                            }

                            // Data end
                            if (data.result.date_end) {
                                $('#' + idForm + ' [name=date_end]').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });
                                $('#' + idForm + ' [name=date_end]').val(myOccurrences._utility.TransformDateServerInDateII(data.result.date_end));
                            }

							toastr["success"]("Informação da equipa actualizada com sucesso");
							break;
                        default:
                            toastr["error"]("Erro na actualização da informação da equipa");
					}
                }
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
			},
            error: function (request, status, error) {
                toastr["error"]("Erro na actualização da informação da equipa");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
			}
		});
    };

    /**
     * Get all comment from department occurrence
     * @param {any} idOccurrence, occurrence id
     * @param {any} codDepartment, department code
     */
    this._GetAllCommentFromDepartmentOccurrence = function (idOccurrence, codDepartment) {

        $.ajax({
            type: 'GET',
            url: '/rest/app/Occurrence/GetAllCommentFromDepartmentOccurrence?idOccurrence=' + idOccurrence + '&codDepartment=' + codDepartment,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção dos comentários");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Get element list comment
                            var commentListElement = $('.occurrence-detail-department-added-zone[cod-department="' + codDepartment + '"] .occurrence-detail-department-list-comment')[0];

                            // Add all comment from department
                            for (var i = 0; i < data.result.list_comment.length; i++) {
                                var commentObj = data.result.list_comment[i];
                                var dateFormated = myOccurrences._utility.TransformDateServerInDateTime(commentObj.date)
                                myOccurrences._AddCommentToElement(commentListElement, commentObj.id, 'department', commentObj.cod_department, commentObj.username, dateFormated, commentObj.comment, false);
                            }
                            break;
                        case "NOT_FOUND":
                            break;
                        default:
                            toastr["error"]("Erro na obtenção dos comentários");
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção dos comentários");
            }
        });
    };

    /**
     * Add new department in occurrence detail
     * @param {string} idOccurrence, occurrence id
     * @param {string} codDepartment, code department
     * @param {string} departmentDescription, department description
     * @param {boolean} getCommentFromServer, get comment from server
     * @param {string} codApproved, approved department code
     */
    this._AddDepartmentInOccurrenceDetail = function (idOccurrence, codDepartment, departmentDescription, getCommentFromServer, codApproved) {
        // Get element list department
        var listDepartmentElement = $('#occurrence-detail-department-list')[0];

        // Define id
        var id = 'occurrence-detail-department-' + idOccurrence + '-' + codDepartment;

        // -- Add new department ------------------------------------------------------------------
        var departementElement = document.createElement('div');
        departementElement.className = 'occurrence-detail-department-added-zone';
        departementElement.setAttribute('cod-department', codDepartment);
        departementElement.id = id;
        var departmentElementDivParent = document.createElement('div');
        departementElement.appendChild(departmentElementDivParent);
        listDepartmentElement.appendChild(departementElement);
        // -- Label --
        var departmentElementDivLabel = document.createElement('div');
        departmentElementDivLabel.className = 'row occurrence-detail-row occurrence-detail-department-label-div';
        departmentElementDivParent.appendChild(departmentElementDivLabel);
        var departmentElementLabel = document.createElement('label');
        departmentElementLabel.innerHTML = departmentDescription;
        departmentElementDivLabel.appendChild(departmentElementLabel);
        var departmentElementIcon = document.createElement('i');
        var iconCodApproved = "fa-circle";
        var titleCodApproved = "Departamento não aprovado";
        switch (codApproved) {
            case "APPROVED":
                iconCodApproved = "fa-check-circle";
                titleCodApproved = "Departamento aprovado";
                break;
            case "REJECTED":
                iconCodApproved = "fa-times-circle";
                titleCodApproved = "Departamento rejeitado";
                break;
        }
        departmentElementIcon.className = "fa " + iconCodApproved + " occurrence-detail-department-icon " + codApproved.toLowerCase();
        departmentElementIcon.setAttribute('title', titleCodApproved);
        departmentElementDivLabel.appendChild(departmentElementIcon);
        // -- Button --
        var departmentElementDivButton = document.createElement('div');
        departmentElementDivButton.className = 'row occurrence-detail-row';
        departmentElementDivButton.setAttribute('id-occurrence', idOccurrence);
        departmentElementDivButton.setAttribute('cod-department', codDepartment);
        departmentElementDivButton.setAttribute('cod-approved', codApproved);
        departmentElementDivParent.appendChild(departmentElementDivButton);
        // Button confirm department
        if (myOccurrences._mapSgs.getSettings().getVisibleOperations().Occurrence.ApprovedDepartmentOccurrence) {
            var departmentElementButtonConfirm = document.createElement('button');
            departmentElementButtonConfirm.id = idOccurrence + '-' + codDepartment + '-' + "approved";
            departmentElementButtonConfirm.setAttribute('type', 'button');
            departmentElementButtonConfirm.className = 'btn btn-xs btn-primary occurrence-detail-department-button approval-button occurrence-detail-department-confirm-button';
            departmentElementButtonConfirm.setAttribute('title', 'Confirmar departamento');
            departmentElementButtonConfirm.setAttribute('cod-approved', 'APPROVED');
            var departmentElementButtonConfirmIcon = document.createElement('i');
            departmentElementButtonConfirmIcon.className = 'fa fa-check';
            departmentElementButtonConfirm.appendChild(departmentElementButtonConfirmIcon);
            departmentElementDivButton.appendChild(departmentElementButtonConfirm);
        }
        // Button reject department
        if (myOccurrences._mapSgs.getSettings().getVisibleOperations().Occurrence.ApprovedDepartmentOccurrence) {
            var departmentElementButtonReject = document.createElement('button');
            departmentElementButtonReject.id = idOccurrence + '-' + codDepartment + '-' + "rejected";
            departmentElementButtonReject.setAttribute('type', 'button');
            departmentElementButtonReject.className = 'btn btn-xs btn-primary occurrence-detail-department-button approval-button occurrence-detail-department-reject-button';
            departmentElementButtonReject.setAttribute('title', 'Rejeitar departamento');
            departmentElementButtonReject.setAttribute('cod-approved', 'REJECTED');
            var departmentElementButtonRejectIcon = document.createElement('i');
            departmentElementButtonRejectIcon.className = 'fa fa-times';
            departmentElementButtonReject.appendChild(departmentElementButtonRejectIcon);
            departmentElementDivButton.appendChild(departmentElementButtonReject);
        }
        // Button not approved department
        if (myOccurrences._mapSgs.getSettings().getVisibleOperations().Occurrence.ApprovedDepartmentOccurrence) {
            var departmentElementButtonNotApproved = document.createElement('button');
            departmentElementButtonNotApproved.id = idOccurrence + '-' + codDepartment + '-' + "not_approved";
            departmentElementButtonNotApproved.setAttribute('type', 'button');
            departmentElementButtonNotApproved.className = 'btn btn-xs btn-primary occurrence-detail-department-button approval-button occurrence-detail-department-reject-button';
            departmentElementButtonNotApproved.setAttribute('title', 'Não aprovar departamento');
            departmentElementButtonNotApproved.setAttribute('cod-approved', 'NOT_APPROVED');
            var departmentElementButtonNotApprovedIcon = document.createElement('i');
            departmentElementButtonNotApprovedIcon.className = 'fa fa-circle-thin';
            departmentElementButtonNotApproved.appendChild(departmentElementButtonNotApprovedIcon);
            departmentElementDivButton.appendChild(departmentElementButtonNotApproved);
        }
        // Button delete department
        if (myOccurrences._mapSgs.getSettings().getVisibleOperations().Occurrence.ManagerDepartmentOccurrence) {
            var departmentElementButtonDelete = document.createElement('button');
            departmentElementButtonDelete.setAttribute('type', 'button');
            departmentElementButtonDelete.className = 'btn btn-xs btn-primary occurrence-detail-department-button occurrence-detail-department-delete-button';
            departmentElementButtonDelete.setAttribute('title', 'Remover departamento');
            var departmentElementButtonDeleteIcon = document.createElement('i');
            departmentElementButtonDeleteIcon.className = 'fa fa-trash';
            departmentElementButtonDelete.appendChild(departmentElementButtonDeleteIcon);
            departmentElementDivButton.appendChild(departmentElementButtonDelete);
        }
        // Button show comment department
        var departmentElementButtonShowComment = document.createElement('button');
        departmentElementButtonShowComment.setAttribute('type', 'button');
        departmentElementButtonShowComment.className = 'btn btn-xs btn-primary occurrence-detail-department-button occurrence-detail-department-show-comment-button';
        departmentElementButtonShowComment.setAttribute('title', 'Visualizar os comentários');
        var departmentElementButtonShowCommentIcon = document.createElement('i');
        departmentElementButtonShowCommentIcon.className = 'fa fa-eye';
        departmentElementButtonShowComment.appendChild(departmentElementButtonShowCommentIcon);
        departmentElementDivButton.appendChild(departmentElementButtonShowComment);
        // Event show comment
        departmentElementButtonShowComment.addEventListener('click', function () {
            var codDepartment = $(this).parent().parent().parent()[0].getAttribute('cod-department');

            // Check if exists any comment
            if ($('.occurrence-detail-department-added-zone[cod-department="' + codDepartment + '"] .occurrence-detail-department-list-comment').children().length === 0) {
                toastr["warning"]("Não existem comentários para este departmento");
                return;
            }

            // Change icon button
            $(this).find('i').toggleClass('fa-eye fa-eye-slash');

            // Show hide comment
            $('.occurrence-detail-department-added-zone[cod-department="' + codDepartment + '"] .occurrence-detail-department-list-comment').toggle('ol-hidden')
        });
        // Button add comment department
        var departmentElementButtonAddComment = document.createElement('button');
        departmentElementButtonAddComment.setAttribute('type', 'button');
        departmentElementButtonAddComment.className = 'btn btn-xs btn-primary occurrence-detail-department-button occurrence-detail-department-add-comment-button';
        departmentElementButtonAddComment.setAttribute('title', 'Adicionar comentário');
        var departmentElementButtonAddCommentIcon = document.createElement('i');
        departmentElementButtonAddCommentIcon.className = 'fa fa-comment';
        departmentElementButtonAddComment.appendChild(departmentElementButtonAddCommentIcon);
        departmentElementDivButton.appendChild(departmentElementButtonAddComment);
        // Event add comment
        departmentElementButtonAddComment.addEventListener('click', function () {
            // Clean comment textarea
            $('#modal-occurrence-comment-input').val('');

            // Get id occurrence
            var idOccurrence = $(this).parent().attr('id-occurrence');
            var codDepartment = $(this).parent().attr('cod-department');
            var key = idOccurrence + myOccurrences._keySeparator + codDepartment;

            // Set parameter
            $('#modal-occurrence-comment').attr('target-context', 'occurrence-detail-department-add-comment');
            $('#modal-occurrence-comment').attr('key-context', key);

            // Show modal comment
            $('#modal-occurrence-comment').css({ 'display': 'block' });
        });
        // Button send notification to department
        var departmentElementButtonSendNotif = document.createElement('button');
        departmentElementButtonSendNotif.setAttribute('type', 'button');
        departmentElementButtonSendNotif.className = 'btn btn-xs btn-primary occurrence-detail-department-button occurrence-detail-department-send-notif-button';
        departmentElementButtonSendNotif.setAttribute('title', 'Enviar notificação');
        departmentElementButtonSendNotif.id = codDepartment;
        var departmentElementButtonSendNotifIcon = document.createElement('i');
        departmentElementButtonSendNotifIcon.className = 'fa fa-envelope-o';
        departmentElementButtonSendNotif.appendChild(departmentElementButtonSendNotifIcon);
        departmentElementDivButton.appendChild(departmentElementButtonSendNotif);
        // Event add comment
        departmentElementButtonSendNotif.addEventListener('click', function () {
            myOccurrences._GetDepartmentNotification(this);
        });
        // -- Comment --
        var departmentElementDivComment = document.createElement('div');
        departmentElementDivComment.className = 'form-group-team-detail occurrence-detail-department-list-comment';
        departmentElementDivComment.setAttribute('style', 'display: none;');
        departementElement.appendChild(departmentElementDivComment);

        // Add comment if load from server
        if (getCommentFromServer) {
            myOccurrences._GetAllCommentFromDepartmentOccurrence(idOccurrence, codDepartment);
        }

        // Event approval department in occurrence
        $('#' + id + ' .occurrence-detail-department-button.approval-button').on('click', function () {
            // Clean comment textarea
            $('#modal-occurrence-comment-input').val('');

            // Get id occurrence
            var idOccurrence = $(this).parent().attr('id-occurrence');
            var codDepartment = $(this).parent().attr('cod-department');
            var key = idOccurrence + myOccurrences._keySeparator + codDepartment;

            // Current approved code
            var currentCodApproved = $(this).parent().attr('cod-approved');
            // New approved code 
            var newCodApproved = $(this).attr('cod-approved');
            // Id target Node
            var idTargetNode = this.id;

            // Set parameter
            $('#modal-occurrence-comment').attr('target-context', 'occurrence-detail-department-update-approval');
            $('#modal-occurrence-comment').attr('id-target-context', idTargetNode);
            $('#modal-occurrence-comment').attr('key-context', key);
            $('#modal-occurrence-comment').attr('current-cod-approved', currentCodApproved);
            $('#modal-occurrence-comment').attr('new-cod-approved', newCodApproved);

            // Show modal comment
            $('#modal-occurrence-comment').css({ 'display': 'block' });
        });

        // Remove department from occurrence
        $('#' + id + ' .occurrence-detail-department-delete-button').on('click', function () {
            // Get info
            var idOccurrence = $(this).parent().attr('id-occurrence');
            var codDepartment = $(this).parent().attr('cod-department');
            var cod_approved = $(this).parent().attr('cod-approved');

            // If department is not rejected then it cannot be erase
            if (cod_approved != 'REJECTED') {
                toastr["warning"]("Para desassociar o departamento tem de rejeita-lo primeiro!");
                return;
            }

            // Set modal info
            $('#modal-ok-cancel').attr('mode', 'REMOVE_DEPARTMENT_OCCURRENCE');
            $('#modal-ok-cancel').attr('id-occurrence', idOccurrence);
            $('#modal-ok-cancel').attr('cod-department', codDepartment);

            // hide offcanvas
            myOccurrences._utility.ShowOpenCanvas(false);
            // set vars and display modal CONFIRM DELETE
            $('#header-modal-ok-cancel').text('Tem a certeza?');
            $('#modal-ok-cancel').css({ 'display': 'block' });
        });
    };

    /**
     * Update approval state department
     */
    this._UpdateStateApprovedDepartment = function (idElement) {
        var idOccurrence = $('#' + idElement).parent().attr('id-occurrence');
        var codDepartment = $('#' + idElement).parent().attr('cod-department');
        var codApproved = $('#' + idElement).parent().attr('cod-approved');
        var newCodApproved = $('#' + idElement).attr('cod-approved');
        var myThis = $('#' + idElement)[0];

        // Check if the cod approved is the same
        if (codApproved === newCodApproved) {
            toastr["warning"]("Opção já seleccionada");
            return;
        }

        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-details', true);

        // Msg
        var msgTitle = "";
        var msgError = "";
        var msgSuccess = "";
        var iconCodApproved = "";
        switch (newCodApproved) {
            case "NOT_APPROVED":
                msgTitle = "Departamento não aprovado";
                msgError = "Erro na não aprovação do departamento";
                msgSuccess = "Departamento não aprovado com sucesso";
                iconCodApproved = "fa-circle";
                break;
            case "APPROVED":
                msgTitle = "Departamento aprovado";
                msgError = "Erro na aprovação do departamento";
                msgSuccess = "Departamento aprovado com sucesso";
                iconCodApproved = "fa-check-circle";
                break;
            case "REJECTED":
                msgTitle = "Departamento rejeitado";
                msgError = "Erro na rejeição do departamento";
                msgSuccess = "Departamento rejeitado com sucesso";
                iconCodApproved = "fa-times-circle";
                break;
        }

        $.ajax({
            type: 'PUT',
            url: '/rest/app/Occurrence/UpdateApprovedDepartmentOccurrence?idOccurrence=' + idOccurrence + '&codDepartment=' + codDepartment + '&codApproved=' + newCodApproved,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"](msgError);
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Alter department icon approval state
                            $(myThis).parent().parent().find('.occurrence-detail-department-icon').removeClass('not_approved');
                            $(myThis).parent().parent().find('.occurrence-detail-department-icon').removeClass('approved');
                            $(myThis).parent().parent().find('.occurrence-detail-department-icon').removeClass('rejected');
                            $(myThis).parent().parent().find('.occurrence-detail-department-icon')[0].className = "fa " + iconCodApproved + " occurrence-detail-department-icon " + newCodApproved.toLowerCase();
                            $(myThis).parent().parent().find('.occurrence-detail-department-icon').attr('title', msgTitle);

                            // Set state approval
                            $(myThis).parent().attr('cod-approved', newCodApproved);

                            // Update department indicator state appproved
                            myOccurrences._UpdateIndicatorStateApprovedDepartment();

                            // Update department team list
                            if (newCodApproved === "APPROVED") {
                                // Add department in team zone
                                if (data.result.department_team != null) {
                                    // -- Fill team department occurrence --
                                    myOccurrences._SetDepartmentTeamInOccurrenceDetail(data.result.department_team.id_occurrence, data.result.department_team.cod_department, data.result.department_team.department_name, true);

                                    // -- Fill team occurrence --
                                    for (let i = 0; i < data.result.list_team.length; i++) {
                                        var teamOccurrenceObj = data.result.list_team[i];
                                        myOccurrences._CloneDivTeamOccurrence(teamOccurrenceObj.id_occurrence, teamOccurrenceObj.id_team, teamOccurrenceObj.cod_department, teamOccurrenceObj, true);
                                    }
                                }
                            }
                            else {
                                // Remove department from team zone
                                $('#occurrence-detail-department-team-' + idOccurrence + '-' + codDepartment).remove();
                            }

                            toastr["success"](msgSuccess);
                            break;
                        default:
                            toastr["error"](msgError);
                    }
                }

                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
            },
            error: function (request, status, error) {
                toastr["error"](msgError);
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
            }
        });
    }

    /**
     * Update indicator department stateapproved
     */
    this._UpdateIndicatorStateApprovedDepartment = function () {
        // Clean indicator
        $('#occurrence-detail-info-box-department').removeClass('not_approved');
        $('#occurrence-detail-info-box-department').removeClass('approved');
        $('#occurrence-detail-info-box-department').removeClass('rejected');

        var countDepartment = $('.occurrence-detail-department-added-zone').length;
        var countApproved = 0;
        var countNotApproved = 0;
        for (var i = 0; i < $('.occurrence-detail-department-added-zone').length; i++) {
            var codApproved = $($('.occurrence-detail-department-added-zone')[i]).find('.occurrence-detail-row[cod-approved]').attr('cod-approved');
            switch (codApproved) {
                case "REJECTED":
                    $('#occurrence-detail-info-box-department').addClass('rejected');
                    $('#occurrence-detail-info-box-department').attr('title', 'Existe pelo menos um departamento que foi rejeitado para esta ocorrência');
                    return;
                    break;
                case "APPROVED":
                    countApproved++;
                    break;
                case "NOT_APPROVED":
                    countNotApproved++;
                    break;
                default:
                    // do nothing
            }
        }

        // Set indicator
        if (countDepartment === countApproved) {
            $('#occurrence-detail-info-box-department').addClass('approved');
            $('#occurrence-detail-info-box-department').attr('title', 'Ocorrência com todos os departamentos aprovados');
        }
        else {
            $('#occurrence-detail-info-box-department').addClass('not_approved');
            $('#occurrence-detail-info-box-department').attr('title', 'Existe pelo menos uma departamento que ainda não foi aprovado');
        }
    }

    /**
     * Add comment to element
     * @param {domElement} commentListElement, element to put comment
     * @param {string} idComment, comment id
     * @param {string} codDepartment, department code
     * @param {string} context, context of the comment
     * @param {string} userName, user name
     * @param {string} dateComment, comment date creation
     * @param {string} comment, comment
     * @param {boolean} addOnTop, add comment on top of all element comment
     */
    this._AddCommentToElement = function (commentListElement, idComment, context, codDepartment, userName, dateComment, comment, addOnTop) {

        // Div comment element
        var commentElementDiv = document.createElement('div');
        commentElementDiv.id = idComment + '-' + context + '-occurrence-detail-comment'; 
        commentElementDiv.className = 'row occurrence-detail-row';
        commentElementDiv.setAttribute('id-comment', idComment);
        commentElementDiv.setAttribute('context', context);
        if (addOnTop && commentListElement.childNodes[0])
            commentListElement.insertBefore(commentElementDiv, commentListElement.childNodes[0]);
        else
            commentListElement.appendChild(commentElementDiv);
        // Button comment bar
        var commentElementButtonDiv = document.createElement('div');
        commentElementDiv.appendChild(commentElementButtonDiv);
        var commentElementButtonExpandBarDiv = document.createElement('div');
        commentElementButtonExpandBarDiv.className = 'zone-comment-expand-button-bar';
        commentElementButtonDiv.appendChild(commentElementButtonExpandBarDiv);
        var idButtonExpandBar = idComment + '-' + context + '-zone-comment-expand-button-bar';
        var commentElementButtonExpandBarA = document.createElement('a');
        commentElementButtonExpandBarA.id = idButtonExpandBar;
        commentElementButtonExpandBarA.setAttribute('title', 'Funcionalidades do comentário');
        commentElementButtonExpandBarDiv.appendChild(commentElementButtonExpandBarA);
        var commentElementButtonExpandBarIcon = document.createElement('i');
        commentElementButtonExpandBarIcon.className = 'fa fa-reorder';
        commentElementButtonExpandBarA.appendChild(commentElementButtonExpandBarIcon);
        var commentElementButtonBarDiv = document.createElement('div');
        var idButtonBar = idComment + '-' + context + '-zone-comment-button-bar';
        commentElementButtonBarDiv.id = idButtonBar;
        commentElementButtonBarDiv.className = 'zone-comment-button-bar';
        commentElementButtonBarDiv.setAttribute('style', 'display: none;');
        commentElementButtonDiv.appendChild(commentElementButtonBarDiv);
        // Button delete
        var commentElemenButtonDeleteA = document.createElement('a');
        commentElemenButtonDeleteA.className = 'zone-comment-button-delete';
        commentElementButtonBarDiv.appendChild(commentElemenButtonDeleteA);
        var commentElementButtonDeleteIcon = document.createElement('i');
        commentElementButtonDeleteIcon.className = 'fa fa-trash';
        commentElemenButtonDeleteA.appendChild(commentElementButtonDeleteIcon);
        // Button edit
        var commentElemenButtonEditA = document.createElement('a');
        commentElemenButtonEditA.className = 'zone-comment-button-edit';
        commentElementButtonBarDiv.appendChild(commentElemenButtonEditA);
        var commentElementButtonEditI = document.createElement('i');
        commentElementButtonEditI.className = 'fa fa-edit';
        commentElemenButtonEditA.appendChild(commentElementButtonEditI);
        // Title comment
        var commentElementTitleDiv = document.createElement('div');
        commentElementTitleDiv.id = idComment + '-' + context + '-zone-comment-user-title';
        commentElementTitleDiv.className = 'zone-comment-user-title';
        commentElementDiv.appendChild(commentElementTitleDiv);
        var commentElementTitleSpanUserName = document.createElement('span');
        commentElementTitleSpanUserName.className = 'name';
        commentElementTitleSpanUserName.innerHTML = userName;
        commentElementTitleDiv.appendChild(commentElementTitleSpanUserName);
        var commentElementTitleSpanDate = document.createElement('span');
        commentElementTitleSpanDate.className = 'date';
        commentElementTitleSpanDate.innerHTML = dateComment;
        commentElementTitleDiv.appendChild(commentElementTitleSpanDate);
        // Body comment
        var commentElementBodyDiv = document.createElement('div');
        commentElementBodyDiv.id = idComment + '-' + context + '-zone-comment-body';
        commentElementBodyDiv.className = 'zone-comment-body';
        commentElementBodyDiv.innerHTML = comment;
        commentElementDiv.appendChild(commentElementBodyDiv);

        // Event on expand button bar
        $('#' + idButtonExpandBar).on('click', function () {
            var idComment = $(this).parent().parent().parent().attr('id-comment');
            var context = $(this).parent().parent().parent().attr('context');
            var idButtonBar = idComment + '-' + context + '-zone-comment-button-bar';
            $('#' + idButtonBar).animate({ width: 'toggle' }, 100);
        });

        // Event click button edit
        $('#' + idButtonBar + ' .zone-comment-button-edit').on('click', function () {
            // Clean comment textarea in modal
            $('#modal-occurrence-comment-input').val('');

            // Get comment info
            var idComment = $(this).parent().parent().parent().attr('id-comment');
            var context = $(this).parent().parent().parent().attr('context');

            // get comment
            var comment = $('#' + idComment + '-' + context + '-zone-comment-body')[0].innerHTML;

            // Set comment in modal
            $('#modal-occurrence-comment-input').val(comment);

            // Set parameter
            $('#modal-occurrence-comment').attr('target-context', 'occurrence-detail-department-update-comment');
            $('#modal-occurrence-comment').attr('key-context', idComment + myOccurrences._keySeparator + context);

            // Close edit button
            var idButtonBar = idComment + '-' + context + '-zone-comment-button-bar';
            $('#' + idButtonBar).animate({ width: 'toggle' }, 100);

            // Show modal comment
            $('#modal-occurrence-comment').css({ 'display': 'block' });
        });

        // Event click button delete
        $('#' + idButtonBar + ' .zone-comment-button-delete').on('click', function () {
            // Get comment info
            var idComment = $(this).parent().parent().parent().attr('id-comment');
            var context = $(this).parent().parent().parent().attr('context');

            // Delete occurrence
            myOccurrences._DeleteCommentDepartmentOccurrence(idComment, context);
        });
    };

    /**
     * Add a department to a occurrence
     * @param {string} idOccurrence, occurrence id
     * @param {string} codDepartment, department code
     * @param {string} departmentDescription, department description
     */
    this._AddDepartmentOccurrence = function (idOccurrence, codDepartment, departmentDescription) {

        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-details', true);

        $.ajax({
            type: 'POST',
            url: '/rest/app/Occurrence/AddDepartmentToOccurrence?idOccurrence=' + idOccurrence + '&codDepartment=' + codDepartment,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na adição do departamento");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Add new department to list
                            myOccurrences._AddDepartmentInOccurrenceDetail(idOccurrence, codDepartment, departmentDescription, false, 'NOT_APPROVED');

                            toastr["success"]("Departamento adicionado com sucesso");
                            break;
                        default:
                            toastr["error"]("Erro na adição do departamento");
                    }
                }

                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na adição do departamento");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
            }
        });
    };

    /**
     * Add a department to a occurrence
     * @param {string} idOccurrence, occurrence id
     * @param {string} codDepartment, department code
     * @param {string} comment, comment
     */
    this._AddCommentToDepartmentOccurrence = function (idOccurrence, codDepartment, comment) {

        $.ajax({
            type: 'POST',
            url: '/rest/app/Occurrence/AddCommentToDepartmentOccurrence?idOccurrence=' + idOccurrence + '&codDepartment=' + codDepartment + '&idUser=' + myOccurrences._mapSgs._settings.userInfo.userId + '&comment=' + comment,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na adição do comentário");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Get element list comment
                            var commentListElement = $('.occurrence-detail-department-added-zone[cod-department="' + codDepartment + '"] .occurrence-detail-department-list-comment')[0];

                            var dateFormated = myOccurrences._utility.TransformDateServerInDateTime(data.result.info_comment.date_comment)
                            myOccurrences._AddCommentToElement(commentListElement, data.result.info_comment.id_comment, 'department', codDepartment, data.result.info_comment.user_name, dateFormated, comment, true);
                            toastr["success"]("Comentário adicionado com sucesso");
                            // Close modal
                            $('#modal-occurrence-comment').toggle('ol-hidden');
                            break;
                        default:
                            toastr["error"]("Erro na adição do comentário");
                    }
                }

                // Stop wait
                myOccurrences._utility.ShowWait('spiner-modal-comment', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na adição do comentário");
                // Stop wait
                myOccurrences._utility.ShowWait('spiner-modal-comment', false);
            }
        });
    };

    /**
     * Update comment in department occurrence
     * @param {int} idComment, comment id
     * @param {string} context, context of the comment
     * @param {string} comment, comment
     */
    this._UpdateCommentDepartmentOccurrence = function (idComment, context, comment) {

        $.ajax({
            type: 'PUT',
            url: '/rest/app/Occurrence/UpdateCommentDepartmentOccurrence?idComment=' + idComment + '&context=' + context +  '&comment=' + comment,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na alteração do comentário");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            var dateFormated = myOccurrences._utility.TransformDateServerInDateTime(data.result.date_comment)

                            // Update comment in comment department
                            $('#' + idComment + '-' + context + '-zone-comment-body')[0].innerHTML = comment;
                            // Update date
                            $('#' + idComment + '-' + context + '-zone-comment-user-title span.date')[0].innerHTML = dateFormated;

                            toastr["success"]("Comentário alterado com sucesso");

                            // Close modal
                            $('#modal-occurrence-comment').toggle('ol-hidden');
                            break;
                        default:
                            toastr["error"]("Erro na alteração do comentário");
                    }
                }

                // Stop wait
                myOccurrences._utility.ShowWait('spiner-modal-comment', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na alteração do comentário");
                // Stop wait
                myOccurrences._utility.ShowWait('spiner-modal-comment', false);
            }
        });
    };

    /**
     * Delete comment from department occurrence
     * @param {int} idComment, comment id
     * @param {string} context, contexto of the comment
     */
    this._DeleteCommentDepartmentOccurrence = function (idComment, context) {
        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-event-details', true);

        $.ajax({
            type: 'DELETE',
            url: '/rest/app/Occurrence/DeleteCommentDepartmentOccurrence?idComment=' + idComment + '&context=' + context,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na remoção do comentário");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Clean node
                            $('#' + idComment + '-' + context + '-occurrence-detail-comment').remove();

                            toastr["success"]("Comentário removido com sucesso");
                            break;
                        default:
                            toastr["error"]("Erro na remoção do comentário");
                    }
                }

                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na remoção do comentário");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            }
        });
    };

    /**
     * Set department for team in occurrence detail
     * @param {string} idOccurrence, occurrence id
     * @param {string} codDepartment, code department
     * @param {string} departmentDescription, department description
     * @param {boolean} getCommentFromServer, get comment from server
     */
    this._SetDepartmentTeamInOccurrenceDetail = function (idOccurrence, codDepartment, departmentDescription, getCommentFromServer) {
        // Get element list department
        var departmentTeamMainElement = $('#occurrence-detail-team')[0];

        // Define id
        var id = 'occurrence-detail-department-team-' + idOccurrence + '-' + codDepartment;

        // -- Department --------------------------------------------------------------------------
        var departementElement = document.createElement('div');
        departementElement.className = 'occurrence-detail-department-team-added-zone';
        departementElement.setAttribute('cod-department', codDepartment);
        departementElement.id = id;
        var departmentElementDivParent = document.createElement('div');
        departementElement.appendChild(departmentElementDivParent);
        departmentTeamMainElement.appendChild(departementElement);
        // -- Div Label Department --
        var departmentElementDivLabel = document.createElement('div');
        departmentElementDivLabel.className = 'row occurrence-detail-row occurrence-detail-department-label-div';
        departmentElementDivParent.appendChild(departmentElementDivLabel);
        // -- Div Label row --
        var departmentElementDivLabelRow = document.createElement('div');
        departmentElementDivLabelRow.className = "row";
        departmentElementDivLabelRow.setAttribute("style", "margin-left: 0px;text-align: center;margin-bottom: 0px;");
        departmentElementDivLabel.appendChild(departmentElementDivLabelRow);
        // -- Label Department --
        var departmentElementLabel = document.createElement('label');
        departmentElementLabel.innerHTML = departmentDescription;
        departmentElementDivLabelRow.appendChild(departmentElementLabel);
        // -- Div Button row --
        var departmentElementDivButtonRow = document.createElement('div');
        departmentElementDivButtonRow.className = "row";
        departmentElementDivLabel.appendChild(departmentElementDivButtonRow);
        // -- Button add team --
        if (myOccurrences._mapSgs.getSettings().getVisibleOperations().Occurrence.AddTeamToDepartmentOccurrence) {
            var departmentElementButtonAddTeam = document.createElement('button');
            departmentElementButtonAddTeam.setAttribute('type', 'button');
            departmentElementButtonAddTeam.className = 'btn btn-xs btn-primary occurrence-detail-department-team-button occurrence-detail-department-team-add-button';
            departmentElementButtonAddTeam.setAttribute('title', 'Adicionar equipa');
            var departmentElementButtonAddTeamIcon = document.createElement('i');
            departmentElementButtonAddTeamIcon.className = 'fa fa-plus';
            departmentElementButtonAddTeam.appendChild(departmentElementButtonAddTeamIcon);
            departmentElementDivButtonRow.appendChild(departmentElementButtonAddTeam);
        }
        // -- Button show team --
        var departmentElementButtonShowTeam = document.createElement('button');
        departmentElementButtonShowTeam.setAttribute('type', 'button');
        departmentElementButtonShowTeam.className = 'btn btn-xs btn-primary occurrence-detail-department-team-button occurrence-detail-department-team-show-button';
        departmentElementButtonShowTeam.setAttribute('title', 'Esconder/mostar equipas');
        var departmentElementButtonShowTeamIcon = document.createElement('i');
        departmentElementButtonShowTeamIcon.className = 'fa fa-eye';
        departmentElementButtonShowTeam.appendChild(departmentElementButtonShowTeamIcon);
        departmentElementDivButtonRow.appendChild(departmentElementButtonShowTeam);
        // -- list team department
        var departementListTeamElement = document.createElement('div');
        departementListTeamElement.className = 'occurrence-detail-department-team-list-zone';
        departmentElementDivParent.appendChild(departementListTeamElement);

        // Event on click to add team occurrence detail
        $('#' + id + ' .occurrence-detail-department-team-add-button').on('click', function () {
            // Get cod department
            var codDepartment = $(this).parent().parent().parent().parent()[0].getAttribute('cod-department');
            // Set dropdown Type
            $('#name-select-occurrence-team').val(codDepartment).change();
            $('#name-select-occurrence-team').selectpicker("refresh");
            myOccurrences._DetailModalOccurrenceTeam($('#name-select-occurrence-team').val(), 'saveTeamToOccurrence');
        });

        // Event on click to show team occurrence detail
        $('#' + id + ' .occurrence-detail-department-team-show-button').on('click', function () {
            $(this).parent().parent().parent().find('.occurrence-detail-department-team-list-zone').toggle('ol-hidden')
            $(this).find('i').toggleClass('fa-eye fa-eye-slash');
        });
    };

    /**
     * Event occurrence
     * Action in occurrence event btn info
     * @param {domElement} element, element occurrence event btn info
     */
    this._ActionOccurrenceEventBtnInfo = function (element) {
        if ($(element).hasClass('view-event-highligh')) {
            $(element).removeClass('view-event-highligh');
            // Remove highlight
            myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear();
        }
        else {
            var codState = element.getAttribute('cod_state');
            // Desactive other btn of other space
            myOccurrences._DesactiveBtnEventOccurrenceSearchActive(codState);

            $(element).addClass('view-event-highligh');
            // Highlight occurrence event
            myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear();
            var arrayIdEventOccurrenceToHighlight = myOccurrences._arrayIdEventOccurrence.filter(c => c.cod_state === codState).map(function (item) { return item.id });
            myOccurrences._mapSgs.SetFeaturesHighlightByArray(myOccurrences._workspace, 'vw_occurrence_event', false, arrayIdEventOccurrenceToHighlight, myOccurrences._eventOccurrenceHighlighStyles);
        }
    }

    /**
     * Event occurrence
     * Desactive btn highlight state event
     * @param {any} codState
     */
    this._DesactiveBtnEventOccurrenceSearchActive = function (codStateNotDesactivate) {
        for (var i = 0; i < myOccurrences._hashReference.occurrence_event_state.length; i++) {
            var objEventState = myOccurrences._hashReference.occurrence_event_state[i];
            if (objEventState.cod_ref !== codStateNotDesactivate) {
                var id = 'id-occurrence-event-detail-btn-info-' + objEventState.cod_ref.replace('_', '-').toLowerCase();
                if ($('#' + id).hasClass('view-event-highligh')) {
                    $('#' + id).removeClass('view-event-highligh');
                    // Remove highlight
                    myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear();
                }
            }
        }
    }

    /**
     * Event occurrence
     * Clean occurrence detail
     */
    this._CleanOccurrenceEventDetail = function () {
        // Clean information header
        $('#occurrence-event-detail-info-box-duration-day')[0].innerHTML = "";
        $('#occurrence-event-detail-info-box-state')[0].className = "occurrence-event-detail-info-box state";
        $('#occurrence-event-detail-info-box-state')[0].setAttribute('title', 'Sem informação');

        // Clean occurrence event detail info
        for (let key in Object.keys($('#occurrence-event-detail-info-form').serializeJSON())) {
            $('#occurrence-event-detail-info-form [name=' + key + ']').val('');
        }

        // Clean occurrence event detail state
        for (let key in Object.keys($('#occurrence-event-detail-state-form').serializeJSON())) {
            $('#occurrence-event-detail-state-form [name=' + key + ']').val('');
        }
        myOccurrences._datatableDetailOccurrenceEventStateHist.clear().draw();
        myOccurrences._datatableDetailOccurrenceRelationEvent.clear().draw();
        myOccurrences._datatableDetailNeighborOccurrenceToEvent.clear().draw();
    };

    /**
     * Event occurrence
     * Detail of event occurrence
     * @param {object} featureInfo, Feature info
     */
    this._DetailOccurrenceEventInfo = function (featureInfo) {
        // -- Open off canvas --
        myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-detail-occurrence-event'], true);

        var idOccurrenceEvent = featureInfo.id;
        myOccurrences._occurrenceEventFeatureSelected = featureInfo.feature;

        // Go back if exists
        if (featureInfo.from_occurrence) {
            $('#id-offcanvas-detail-occurrence-event-go-back').removeClass('ol-hidden');
        }
        else {
            $('#id-offcanvas-detail-occurrence-event-go-back').addClass('ol-hidden');
        }

        // Set occurrence title
        $('#offcanvas-head-occurrence-event-title')[0].innerHTML = "Evento Ocorrência Nº";

        // Set occurrence id number
        $('#offcanvas-head-id-occurrence-event')[0].innerHTML = idOccurrenceEvent;

        // Layer info
        var layerName = "";
        if (featureInfo.idLayer) {
            var layerObj = myOccurrences._mapSgs.layerTree.layerInfo.dict_layer_info[featureInfo.idLayer];
            layerName = layerObj.layer_info.layerName;
        }
        else {
            layerName = featureInfo.layer_name;
        }

        // Hide button add attachment
        $('#id-creation-event-occurrence-attachment-add').addClass('ol-hidden');

        // Set id
        $('#id_occurrence_event_detail').val(idOccurrenceEvent);

        // Clean occurrence detail
        myOccurrences._CleanOccurrenceEventDetail();

        // Active scroll
        $('.dataTables_scrollBody').addClass('gp-overflow-datatable');

        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-event-details', true);

        // Id User
        var idUser = myOccurrences._mapSgs._settings.userInfo.userId;

        $.ajax({
            type: 'GET',
            url: '/rest/app/Occurrence/GetOccurrenceEventById?id=' + idOccurrenceEvent + "&idUser=" + idUser,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção do evento de ocorrência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // -- Fill occurrence info & state detail -- 
                            for (let key in data.result.occurrence_event) {
                                let value = data.result.occurrence_event[key];
                                if (value) {
                                    switch (key) {
                                        case "cod_state":
                                            $('#occurrence-event-detail-state-form [name=' + key + ']').val(value);
                                            $('#occurrence-event-detail-state-form [name=' + key + ']').selectpicker("refresh");
                                            $('#occurrence-event-detail-info-box-state')[0].className = "occurrence-event-detail-info-box state " + value.toLowerCase();
                                            break;
                                        case "date_state":
                                            $('#occurrence-event-detail-state-form [name=' + key + ']').val(myOccurrences._utility.TransformDateServerInDateII(value));
                                            break;
                                        case "cod_type":
                                            $('#occurrence-event-detail-info-form [name=' + key + ']').val(value);
                                            $('#occurrence-event-detail-info-form [name=' + key + ']').selectpicker("refresh");
                                            var arraySubtype = myOccurrences._hashReference['occurrence_subtype'][value];
                                            myOccurrences._utility.FillSelect('occurrence-event-detail-subtype-select', arraySubtype, 'description', 'cod_subtype');
                                            break;
                                        case "cod_subtype":
                                            $('#occurrence-event-detail-info-form [name=' + key + ']').val(value);
                                            $('#occurrence-event-detail-info-form [name=' + key + ']').selectpicker("refresh");
                                            break;
                                        case "date_creation":
                                            $('#occurrence-event-detail-info-form [name=' + key + ']').val(myOccurrences._utility.TransformDateServerInDateII(value));
                                            break;
                                        case "duration_day":
                                            $('#occurrence-event-detail-info-box-duration-day')[0].innerHTML = value;
                                            break;
                                        case "state_description":
                                            $('#occurrence-event-detail-info-box-state')[0].setAttribute('title', value);
                                            break;
                                        case "user_name":
                                            $('#occurrence-event-detail-info-form [name= user_name]').html(value);
                                            break;
                                        default:
                                            $('#occurrence-event-detail-info-form [name=' + key + ']').val(value);
                                    }
                                }
                            }

                            // -- Fill state hist occurrence --
                            var countElement = data.result.list_hist_state.length;
                            for (let i = 0; i < countElement; i++) {
                                var objEvent = data.result.list_hist_state[i];
                                objEvent.date_state = myOccurrences._utility.TransformDateServerInDateII(objEvent.date_state);
                                myOccurrences._datatableDetailOccurrenceEventStateHist.row.add({
                                    id: objEvent.id,
                                    cod_state: objEvent.description_state,
                                    date_state: objEvent.date_state,
                                    description: objEvent.description
                                });
                            }
                            myOccurrences._datatableDetailOccurrenceEventStateHist.draw();

                            // -- Occurrence relation --

                            if (data.result.occurrence.occurrence_relation) {
                                $('#id-occurrence-event-detail-create-occurrence-zone').addClass('ol-hidden');
                                $('#id-occurrence-event-detail-relation-occurrence-zone-msg').addClass('ol-hidden');
                                $('#id-occurrence-event-detail-relation-occurrence-table-zone').removeClass('ol-hidden');

                                // Fill datatable with occurrence
                                var objOccurrence = data.result.occurrence.occurrence_relation;
                                myOccurrences._datatableDetailOccurrenceRelationEvent.row.add({
                                    id: objOccurrence.id,
                                    workspace: objOccurrence.workspace,
                                    layer_name: objOccurrence.layer_name,
                                    description: objOccurrence.description,
                                    description_preview: objOccurrence.description,
                                    state_description: objOccurrence.state_description
                                });
                                myOccurrences._datatableDetailOccurrenceRelationEvent.draw();
                            }
                            else {
                                $('#id-occurrence-event-detail-create-occurrence-zone').removeClass('ol-hidden');
                                $('#id-occurrence-event-detail-relation-occurrence-zone-msg').removeClass('ol-hidden');
                                $('#id-occurrence-event-detail-relation-occurrence-table-zone').addClass('ol-hidden');
                            }

                            // -- Occurrence Neignbor --

                            // Set buffer
                            var eventOccurrenceCoordinate = featureInfo.feature.getGeometry().getCoordinates();
                            myOccurrences._SetBufferOccurrenceNeighbor(eventOccurrenceCoordinate, 100);

                            if (data.result.occurrence.list_occurrence_neighbor) {
                                $('#id-occurrence-event-detail-relation-occurrence-neighbor-zone').removeClass('ol-hidden');

                                // Fill datatable whit occurrence neighbor
                                for (let i = 0; i < data.result.occurrence.list_occurrence_neighbor.length; i++) {
                                    var objOccurrence = data.result.occurrence.list_occurrence_neighbor[i];
                                    myOccurrences._datatableDetailNeighborOccurrenceToEvent.row.add({
                                        id: objOccurrence.id,
                                        workspace: objOccurrence.workspace,
                                        layer_name: objOccurrence.layer_name,
                                        description: objOccurrence.description,
                                        description_preview: objOccurrence.description,
                                        state_description: objOccurrence.state_description
                                    });
                                }
                                myOccurrences._datatableDetailNeighborOccurrenceToEvent.draw();
                            }
                            else {
                                $('#id-occurrence-event-detail-relation-occurrence-neighbor-zone').addClass('ol-hidden');
                            }

                            // -- Attachment --
                            if (myOccurrences._mapSgs._uploadAttachtment)
                                myOccurrences._mapSgs._uploadAttachtment.LoadAttachment(featureInfo.id, layerName, 'id-offcanvas-body-layer-detail-event-attachment-zone', 'id-offcanvas-body-layer-detail-event-attachment-form', 'id-creation-event-occurrence-attachment-add', 'offcanvas-body-layer-detail-event-attachment-info-td', 'id-offcanvas-creation-event-attachment-spinner');

                            // -- Get string state --
                            myOccurrences._occurrenceEventFormState = JSON.stringify($('#occurrence-event-detail-state-form').serializeJSON());
                            break;
                        case "ERROR":
                            toastr["error"]("Erro na obtenção do evento de ocorrência");
                            break;
                        default:
                    }
                }
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção do evento de ocorrência");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            }
        });
    }

    /**
     * Event occurrence
     * Detail of event occurrence in site event occurrence
     * @param {object} featureInfo, Feature info
     */
    this._DetailOccurrenceEventInfoInSiteEventOccurrence = function (featureInfo) {
        // Get id event occurrence
        var idOccurrenceEvent = featureInfo.id;

        // Layer info
        var layerObj = myOccurrences._mapSgs.layerTree.layerInfo.dict_layer_info[featureInfo.idLayer];
        var layerName = layerObj.layer_info.layerName;

        // Hidde button
        $('#id-creation-event-occurrence-attachment-add').addClass('ol-hidden');
        $('#id-creation-event-occurrence-submit').addClass('ol-hidden');

        // Start wait
        myOccurrences._utility.ShowWait('offcanvas-creation-event-spinner', true);

        // Set occurrence title
        $('#offcanvas-head-occurrence-event-title')[0].innerHTML = "Ocorrência Nº";

        // Set occurrence id number
        $('#offcanvas-head-id-occurrence-event')[0].innerHTML = idOccurrenceEvent;

        // Clean Number of file
        $('.offcanvas-body-layer-detail-attachment-info-td span')[0].innerHTML = "-";

        // Id User
        var idUser = myOccurrences._mapSgs._settings.userInfo.userId;

        $.ajax({
            type: 'GET',
            url: '/rest/app/Occurrence/GetOccurrenceEventById?id=' + idOccurrenceEvent + "&idUser=" + idUser,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da informação da ocorrência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            var objDatatable = data.result.occurrence_event;
                            // Fill detail event occurrence
                            $('#Event-occurrence-description').val(objDatatable.description).change();
                            $('#Event-occurrence-creation-type').val(objDatatable.cod_type).change();
                            $('#Event-occurrence-creation-subtype').val(objDatatable.cod_subtype).change();
                            // Fill state event occurrence
                            $('.occurrence-detail-info-state-box-col').removeClass('current-state');
                            $('#id-occurrence-event-detail-info-state-' + objDatatable.cod_state.replace('_', '-').toLowerCase()).parent().addClass('current-state');
                            $('#id-occurrence-event-detail-info-state').removeClass('ol-hidden');
                            if (myOccurrences._utility.mobilecheck()) {
                                $('.occurrence-detail-info-state-box').addClass('mobile');
                            }
                            else {
                                $('.occurrence-detail-info-state-box').removeClass('mobile');
                            }

                            // Init Upload for entity
                            if (myOccurrences._mapSgs._uploadAttachtment)
                                myOccurrences._mapSgs._uploadAttachtment.LoadAttachment(featureInfo.id, layerName, 'id-offcanvas-body-layer-detail-attachment-zone', 'id-offcanvas-body-layer-detail-attachment-form', 'id-creation-event-occurrence-attachment-add', 'offcanvas-body-layer-detail-attachment-info-td', 'id-offcanvas-creation-event-attachment-spinner');

                            // Show canvas event occurrence detail
                            myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-creation-event-occurrence'], true);
                            $('#buttonEventMapSearch').removeClass('active');
                            break;
                        case "ERROR":
                            toastr["error"]("Erro na obtenção da informação da ocorrência");
                            break;
                        default:
                    }
                }
                // Stop wait
                myOccurrences._utility.ShowWait('offcanvas-creation-event-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da informação da ocorrência");
                // Stop wait
                myOccurrences._utility.ShowWait('offcanvas-creation-event-spinner', false);
            }
        });
    }

    /**
     * Event occurrence
	 * Start creation Event occurrence 
	 */
    this._CreateEventOccurrence = function (e) {

        // Show spiner on create
        myOccurrences._utility.ShowWait('offcanvas-creation-event-spinner', true);

        var _eventOccurrenceCreationForm = $('#form-creation-occurrence-event').serializeJSON();
        _eventOccurrenceCreationForm.id_user = myOccurrences._mapSgs._settings.userInfo.userId;

        $.ajax({
            type: 'POST',
            url: '/rest/app/Occurrence/CreateOccurrenceEvent',
            data: JSON.stringify(_eventOccurrenceCreationForm),
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na criação de ocorrência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':

                            var IdLayerEventOccurrence = app.sgs.Map.layerTree.GetLayerInfoArrayByLayerSourceName('vw_occurrence_event');
                            var layerNameEventOccurrence;
                            for (let i = 0; i < IdLayerEventOccurrence.length; i++) {
                                if (IdLayerEventOccurrence[i].cqlFilter === "cod_state='EM_ANALISE'")
                                    layerNameEventOccurrence = IdLayerEventOccurrence[i].layerNameKey;
                            }

                            var RefreshLayerOccurrence = myOccurrences._utility.GetLayerByName(app.sgs.Map.map, layerNameEventOccurrence);
                            RefreshLayerOccurrence.getSource().clear();
                            myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-creation-event-occurrence'], false);
                            $('#id-occurrence-event-detail-info-state').addClass('ol-hidden');
                            if (myOccurrences._utility.mobilecheck())
                                $('.occurrence-detail-info-state-box').addClass('mobile');
                            else
                                $('.occurrence-detail-info-state-box').removeClass('mobile');
                            // Close creation interface
                            myOccurrences._mapSgs.map.on('singleclick', async (e) => { await myOccurrences._mapSgs.tooltips.BuildInfoTooltips(e); });
                            myOccurrences._mapSgs.map.un('click', myOccurrences._CreationEventOccurrenceMakeClickEvent);
                            $('#ButtonStartCreationEvent').html('Criar Ocorrência');
                            $('#pinCreateEventOccurrence, #pinOnMove').css({ 'display': 'none' });
                            myOccurrences._mapSgs.StartCreationEvent = true;
                            $('#buttonsMap a[href="#offcanvas-theme"').removeClass('active');
                            if (!myOccurrences._mapSgs._utility.mobilecheck()) {
                                document.body.style.cursor = 'default';
                            }

                            // Save file queue
                            myOccurrences._mapSgs._uploadAttachtment.newIdEntity = data.result.new_id_occurrence_event;
                            myOccurrences._mapSgs._uploadAttachtment.dropzoneUpload.processQueue();

                            toastr["success"]("Ocorrência criada");
                            break;
                        case 'NOT_FOUND':
                            toastr["warning"]("Nenhum evento encontrado");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na criação de ocorrência");
                            break;
                        default:
                    }
                }

                // Hide spiner on create
                myOccurrences._utility.ShowWait('offcanvas-creation-event-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na criação de ocorrência");
                // Hide spiner on create
                myOccurrences._utility.ShowWait('offcanvas-creation-event-spinner', false);
            }
        });
    };

    /**
     * Event occurrence
     * Search Event occurrence
     */
    this._SearchOccurrenceEvent = function () {

        // Clean count state information
        $('#id-occurrence-event-detail-btn-info-em-resolucao span')[0].innerHTML = "0";
        $('#id-occurrence-event-detail-btn-info-em-analise span')[0].innerHTML = "0";
        $('#id-occurrence-event-detail-btn-info-fechado span')[0].innerHTML = "0";
        $('#id-occurrence-event-detail-btn-info-cancelado span')[0].innerHTML = "0";

        // Ajust info state element
        if (myOccurrences._utility.mobilecheck())
            $('#offcanvas-detail-event-occurrence .occurrence-detail-info-box').addClass('mobile');
        else
            $('#offcanvas-detail-event-occurrence .occurrence-detail-info-box').removeClass('mobile');

        // Show spiner on search
        myOccurrences._utility.ShowWait('offcanvas-creation-event-spiner-body', true);

        // Hide detail event Occurrence
        $('.EventOccurrenceStyle').css({ 'display': 'none' });
        $('#event-occurrence-detail-hist-table').append($('#EventOccurrenceTextArea'));

        $('#search-occurrence-event-subtype, #search-occurrence-event-state, #event-occurrence-search-input-keyword, #Event-occurrence-search-date-begin, #Event-occurrence-search-date-end, #Event-occurrence-search-select-type').bind('change.bs.select');

        // Split date begin to convert to int
        var searchDateBeginInt = $('#Event-occurrence-search-date-begin').val().split('-').join('');
        var searchDateEndInt = $('#Event-occurrence-search-date-end').val().split('-').join('');
        var _occurrenceEventSearchForm = $('#form-search-event-occurrence').serializeJSON();

        // Convert date to int
        _occurrenceEventSearchForm.date_creation_begin = parseInt(searchDateBeginInt);
        _occurrenceEventSearchForm.date_creation_end = parseInt(searchDateEndInt);

        // Add user info
        _occurrenceEventSearchForm.id_user = myOccurrences._mapSgs._settings.userInfo.userId;

        //Button to remove filter on search event
        var formsearch = _occurrenceEventSearchForm;
        if (formsearch.cod_state != "" || formsearch.cod_subtype != "" || formsearch.cod_type != "" || !isNaN(formsearch.date_creation_begin) || !isNaN(formsearch.date_creation_end))
            $('.button-remove-filter-event-occurrence').css({ 'display': 'initial' })
        else
            $('.button-remove-filter-event-occurrence').css({ 'display': 'none' })

        $.ajax({
            type: 'POST',
            url: '/rest/app/Occurrence/SearchOccurrenceEvent',
            data: JSON.stringify(_occurrenceEventSearchForm),
            dataType: 'json',
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na pesquisa de elementos");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Fill list event occurrence
                            myOccurrences._eventsOccurrenceDetail = data.result.list_occurrence_event;
                            myOccurrences._arrayIdEventOccurrence = [];
                            myOccurrences._tableDetailEventOccurrence.clear().draw();
                            var countElement = data.result.list_occurrence_event.length;
                            for (let i = 0; i < countElement; i++) {
                                var objEvent = data.result.list_occurrence_event[i];
                                myOccurrences._arrayIdEventOccurrence.push({ id: objEvent.id, cod_state: objEvent.cod_state });
                                myOccurrences._tableDetailEventOccurrence.row.add({
                                    id: objEvent.id,
                                    cod_state: objEvent.cod_state,
                                    state_description: objEvent.state_description,
                                    description_event: objEvent.description,
                                    description: objEvent.description
                                });
                            };
                            myOccurrences._tableDetailEventOccurrence.draw();
                            // Fill count state
                            for (let i = 0; i < data.result.list_occurrence_event_statistic_state.length; i++) {
                                var stateInfoObj = data.result.list_occurrence_event_statistic_state[i];
                                $('#id-occurrence-event-detail-btn-info-' + stateInfoObj.cod_state.replace('_', '-').toLowerCase() + ' span')[0].innerHTML = stateInfoObj.count;
                            };
                            // Fill description state
                            for (let i = 0; i < myOccurrences._hashReference.occurrence_event_state.length; i++) {
                                var stateRefInfoObj = myOccurrences._hashReference.occurrence_event_state[i];
                                $('#offcanvas-detail-event-occurrence .occurrence-detail-info-box-title.' + stateRefInfoObj.cod_ref.replace('_', '-').toLowerCase())[0].innerHTML = stateRefInfoObj.description;
                                $('#id-occurrence-event-detail-btn-info-' + stateRefInfoObj.cod_ref.replace('_', '-').toLowerCase())[0].setAttribute('title', stateRefInfoObj.description);
                                $('#id-occurrence-event-detail-btn-info-' + stateRefInfoObj.cod_ref.replace('_', '-').toLowerCase())[0].setAttribute('cod_state', stateRefInfoObj.cod_ref)
                            };

                            $('#id-search-result-detail-info-number-result').removeClass('hide-highlight');

                            break;
                        case 'NOT_FOUND':
                            toastr["warning"]("Nenhuma ocorrência encontrada com esse filtro");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na pesquisa de elementos");
                            break;
                        default:
                    }
                    myOccurrences._utility.ShowWait('offcanvas-creation-event-spiner-body', false);
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na pesquisa de elementos");
                myOccurrences._utility.ShowWait('offcanvas-creation-event-spiner-body', false);
            }

        });
    };

    /**
     * Create location to event occurrence
     * @param {event} e, event
     */
    this._CreationEventOccurrenceMakeClickEvent = function (e) {
        if (myOccurrences._mapSgs.StartCreationEvent === false && !myOccurrences._utility.mobilecheck()) {
            var viewResolution = (e.map.getView().getResolution());
            var epsg = myOccurrences._mapSgs._settings.projection.getCode();
            var layerFreguesia = myOccurrences._utility.GetLayerByName(myOccurrences._mapSgs.map, myOccurrences._mapSgs.layerTree.FindLayerNameKey("freguesia_cont"));
            var clickCoordinate = e.map.focus_;
            var pixel = e.pixel;

            $('#creation-occurrence-X').val(clickCoordinate[0]);
            $('#creation-occurrence-Y').val(clickCoordinate[1]);

            if (layerFreguesia) {
                // Geoserver url
                var url = layerFreguesia.getSource().getGetFeatureInfoUrl(
                    e.map.focus_,
                    viewResolution,
                    epsg,
                    { 'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 10 }
                );

                if (url) {
                    var request = $.ajax(
                        {
                            method: "GET",
                            async: false,
                            url: url
                        });
                    request.done(function (data, textStatus, jqXHR) {
                        if (data.features && data.features.length > 0) {
                            // Create overlay in that possition
                            myOccurrences._mapSgs._CreateOverlayPinOccurrence($('#pinCreateEventOccurrence')[0], clickCoordinate, pixel);

                            //add overlay to map
                            myOccurrences._mapSgs.map.addOverlay(myOccurrences._mapSgs._overlayPinOccurrence);

                            //remove last div created for Pin
                            $('.ol-overlay-container')[1].remove();

                            $('#pinCreateEventOccurrence').css({ 'display': 'initial' })
                        }
                        else {
                            toastr["warning"]("Localização fora dos limites do concelho");
                            $('#pinCreateEventOccurrence, #pinOnMove').css({ 'display': 'none' });
                        }
                    });
                }
            }
        }
    };

    /**
     * Refresh layer occurrence event
     */
    this._RefreshOccurrenceEventLayer = function () {

        for (var i = 0; i < myOccurrences._layerInfoEventOccurrenceArray.length; i++) {

            var layerInfoEventOccurrence = myOccurrences._layerInfoEventOccurrenceArray[i];
            myOccurrences._utility.GetLayerByName(myOccurrences._mapSgs.map, layerInfoEventOccurrence.layerNameKey).getSource().clear();
        }
    };

    /**
     * Refresh layer occurrence event
     */
    this._RefreshOccurrenceLayer = function () {

        for (var i = 0; i < myOccurrences._layerInfoOccurrenceArray.length; i++) {

            var layerInfoOccurrence = myOccurrences._layerInfoOccurrenceArray[i];
            myOccurrences._utility.GetLayerByName(myOccurrences._mapSgs.map, layerInfoOccurrence.layerNameKey).getSource().clear();
        }
    };

    /**
     * Event open notify department modal
     */
    this._GetDepartmentNotification = function (idDepartment) {

        $('#id-modal-email-body-msg-definition-to').val('');

        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-event-details', true);

        // Id occurrence event
        var idOccurrence = $('#id_occurrence_detail').val();

        // Id User
        var idUser = myOccurrences._mapSgs._settings.userInfo.userId;

        // Clean user notification info
        myOccurrences._occurrenceEventEmailNotificationInfo = null;

        // Clean email form
        myOccurrences._email.CleanEmailForm();

        $('#id-modal-email-IdEntity').val(idOccurrence);

        $('#id-modal-email-NameEntity').val('Occurrence');

        $('#id-modal-email-cod_notification_action').val('NOTIFICATION_TEAM');

        $.ajax({
            type: 'GET',
            url: '/rest/app/Occurrence/GetEmailNotificationInfoForDepartment?id=' + idOccurrence + "&idUser=" + idUser + "&cod_department=" + idDepartment.id,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da informação da notificação por email");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':

                            //Get Id User Created
                            $('#id-modal-email-IdUserCreated').val(data.result.owner_occurrence.id_user)

                            // set user notification info
                            myOccurrences._occurrenceEventEmailNotificationInfo = data.result.email_notification_info;

                            // Set to
                            if (myOccurrences._occurrenceEventEmailNotificationInfo.email) {
                                $('#id-modal-email-body-msg-definition-to').val(myOccurrences._occurrenceEventEmailNotificationInfo.email + ';');
                            }

                            // Set subject
                            var msg = "Ocorrência nº" + idOccurrence;
                            
                            $('#id-modal-email-body-msg-definition-subject').val(msg);

                            if (data.result.list_email_send)
                                myOccurrences._DrawNotificationDatatable(data.result.list_email_send);

                            // Show modal
                            myOccurrences._utility.ShowOpenCanvas(true);
                            $('#id-modal-email').css({ 'display': 'block' });

                            break;
                        case "ERROR":
                            toastr["error"]("Erro na obtenção da informação da notificação por email");
                            break;
                        default:
                    }
                }
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da informação da notificação por email");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            }
        });

    };

    /**
     * Event click notify occurrence detail
     */
    this._GetTeamNotification = function (formTeamOccurrence) {

        $('#id-modal-email-body-msg-definition-to').val('');

        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-event-details', true);

        // Id occurrence event
        var idOccurrence = formTeamOccurrence.id_occurrence;

        // Id User
        var idUser = myOccurrences._mapSgs._settings.userInfo.userId;

        // Clean user notification info
        myOccurrences._occurrenceEventEmailNotificationInfo = null;

        // Clean email form
        myOccurrences._email.CleanEmailForm();

        $('#id-modal-email-IdEntity').val(idOccurrence);

        $('#id-modal-email-NameEntity').val('Occurrence');

        $('#id-modal-email-cod_notification_action').val('NOTIFICATION_TEAM');

        $.ajax({
            type: 'GET',
            url: '/rest/app/Occurrence/GetEmailNotificationInfoForTeam?id=' + idOccurrence + "&idUser=" + idUser + "&id_team=" + formTeamOccurrence.id_team,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da informação da notificação por email");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':

                            //Get Id User Created
                            $('#id-modal-email-IdUserCreated').val(data.result.owner_occurrence.id_user)

                            // set user notification info
                            myOccurrences._occurrenceEventEmailNotificationInfo = data.result.email_notification_info;

                            if (myOccurrences._occurrenceEventEmailNotificationInfo.emailAddress) {
                                $('#id-modal-email-body-msg-definition-to').val(myOccurrences._occurrenceEventEmailNotificationInfo.emailAddress + ';');
                            }

                            // Set subject
                            var msg = "Ocorrência nº" + idOccurrence;

                            $('#id-modal-email-body-msg-definition-subject').val(msg);

                            if (data.result.list_email_send)
                                myOccurrences._DrawNotificationDatatable(data.result.list_email_send);

                            // Show modal
                            myOccurrences._utility.ShowOpenCanvas(true);
                            $('#id-modal-email').css({ 'display': 'block' });

                            break;
                        case "ERROR":
                            toastr["error"]("Erro na obtenção da informação da notificação por email");
                            break;
                        default:
                    }
                }
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da informação da notificação por email");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            }
        });

    };

    /**
     * Event click notify occurrence detail
     */
    this._DrawNotificationDatatable = function (list_email_send) {

        myOccurrences._emailsArraytooltip = list_email_send;

        myOccurrences._email._datatableNotificationInfo.clear().draw();

        for (var i = 0; i < list_email_send.length; i++) {

            myOccurrences._email._datatableNotificationInfo.row.add({
                id_email_msg: list_email_send[i].id_email_msg,
                id_entity: list_email_send[i].id_entity,
                name_entity: list_email_send[i].name_entity,
                id_user_send: list_email_send[i].id_user_send,
                state_description: list_email_send[i].state_description,
                to_email: list_email_send[i].to_email,
                cc_email: list_email_send[i].cc_email,
                bcc_email: list_email_send[i].bcc_email,
                subject: list_email_send[i].subject,
                msg_body: list_email_send[i].msg_body,
                cod_state: list_email_send[i].cod_state
            });
        }

        myOccurrences._email._datatableNotificationInfo.draw();

        //// Event on click to remove data from datatable
        //myOccurrences._email._datatableNotificationInfo.on('draw', function () {

        //    // Event goto element detail
        //    $('#id-modal-email-body-msg-state-table').on('click', '.dt-to-email', function () {
        //        var id = this.parentElement.id
        //        var a = 1;
        //    });

        //});

    }

    /**
     * Draw Pin Create Occurrence
     */
    this._DrawPintoCreateOccurrenceWithoutEvent = function (e) {
        
        // Mode Create
        if (!$('#CreateOccurrenceButton').hasClass('activeButton')) {
            myOccurrences._mapSgs.map.un('singleclick', myOccurrences._mapSgs.tooltips.BuildInfoTooltips);
            myOccurrences._mapSgs._utility.ShowOpenCanvas(false);
            $('#CreateOccurrenceButton').addClass('activeButton')
            myOccurrences._mapSgs.StartCreationEvent = false;
            if (myOccurrences._mapSgs._utility.mobilecheck()) {
                $('#pinCreateEventOccurrence, #pinOnMove').css({ 'display': 'initial' })
                $('.pinArrow').addClass('mobile');
            }
            else {
                $('.pinArrow').removeClass('mobile');
                // Cursor fontawesome
                $('body').awesomeCursor('map-marker', {
                    color: '#204d74',
                    hotspot: [8, 20]
                })
            }
            // Event to occurrence Map on click
            myOccurrences._mapSgs.map.on('click', myOccurrences._CreationEventOccurrenceMakeClickEvent);

        } else { // Mode remove create
            myOccurrences._mapSgs.map.on('singleclick', async (e) => { await myOccurrences._mapSgs.tooltips.BuildInfoTooltips(e); });
            myOccurrences._mapSgs.map.un('click', myOccurrences._CreationEventOccurrenceMakeClickEvent);
            $('#CreateOccurrenceButton').removeClass('activeButton')

            $('#pinCreateEventOccurrence, #pinOnMove').css({ 'display': 'none' });

            $('#pinCreateEventOccurrence, #pinOnMove').css({ 'display': 'none' });
            myOccurrences._mapSgs.StartCreationEvent = true;
            if (!myOccurrences._mapSgs._utility.mobilecheck()) {
                document.body.style.cursor = 'default';
            }
        }

    }

    this._sendemailifstateoccurrececlose = function () {

        $('#id-modal-email-body-msg-definition-to').val('');

        // Occurrence event state
        var cod_state = $('#occurrence-detail-state-select').val();

        // Id occurrence event
        var idOccurrence = $('#id_occurrence_detail').val();

        // Id User
        var idUser = myOccurrences._mapSgs._settings.userInfo.userId;

        $.ajax({
            type: 'GET',
            url: '/rest/app/Occurrence/GetEmailNotificationInfoForOccurrence?id=' + idOccurrence + "&idUser=" + idUser,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da informação da notificação por email");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':

                            var EmailData = $('').serializeJSON();

                            var emailtosend = "";

                            for (var i = 0; i < data.result.list_department_resolution.length; i++) {

                                if (data.result.list_department_resolution[i].emailAddress)
                                    emailtosend = emailtosend + data.result.list_department_resolution[i].emailAddress + ';';

                            }

                            for (var i = 0; i < data.result.email_notification_info.length; i++) {

                                if (data.result.email_notification_info[i].emailAddress)
                                    emailtosend = emailtosend + data.result.email_notification_info[i].emailAddress + ';';
                            }

                            for (var i = 0; i < data.result.list_email_send.length; i++) {

                                if (data.result.list_email_send[i].emailAddress)
                                    emailtosend = emailtosend + data.result.list_email_send[i].emailAddress + ';';

                            }

                            var teamName = "";

                            for (var i = 0; i < data.result.list_department_resolution.length; i++) {
                                teamName = teamName + data.result.list_department_resolution[i].name+ ', ';
                            }

                            teamName = teamName.slice(0, -2);

                            EmailData.IdEntity = idOccurrence;
                            EmailData.NameEntity = 'Occurrence';
                            EmailData.cod_notification_action = "NOTIFICATION_TEAM";
                            EmailData.IdUserSend = myOccurrences._mapSgs._settings._mapSettings.user_info.id_user;
                            EmailData.IdUserCreated = idUser;
                            EmailData.EmailInfo = $('').serializeJSON()
                            EmailData.EmailInfo.EmailBcc = emailtosend;
                            EmailData.EmailInfo.Subject = 'Ocorrência nº' + idOccurrence + ' foi fechada.';
                            EmailData.EmailInfo.Message = 'Ocorrência nº' + idOccurrence + ' foi fechada no dia ' + myOccurrences._getdateToday() + '<br/> Equipas: ' + teamName
                                
                            myOccurrences._mapSgs._utility.SendEmail(EmailData);
                            
                            break;
                        case "ERROR":
                            toastr["error"]("Erro na obtenção da informação da notificação por email");
                            break;
                        default:
                    }
                }
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da informação da notificação por email");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            }
        });

    }

    /**
     *  Get date time
     */
    this._getdateToday = function () {

        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;

        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        return today = dd + '/' + mm + '/' + yyyy;

    }

    // -- end private method ----------------------------------------------------------------------

    // -- Begin event -----------------------------------------------------------------------------

    // Event submit event creation from map
    $('#id-submit-btn-create-occurrence-map .submit-occurrence-map').on('click', function () {

        var _objectserialize = $('#form-creation-occurrence').serializeJSON();

        var _objectKeys = Object.keys(_objectserialize);

        for (var i = 0; i < _objectKeys.length; i++) {
            if (_objectKeys[i] != "X" && _objectKeys[i] != "Y")
                $('#form-creation-occurrence [name=' + _objectKeys[i] + ']').val('').selectpicker("refresh");
        }

        myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-creation-occurrence-form'], true);
        myOccurrences._mapSgs.map.un('click', myOccurrences._CreationEventOccurrenceMakeClickEvent);
        document.body.style.cursor = 'default';

        

        $('#menubar, #id-button-favorites, #id-button-cancel-create-occurrence, #creation-occurrence-submite').on('click', function () {
            if ($('#CreateOccurrenceButton').hasClass('activeButton')) {
                myOccurrences._DrawPintoCreateOccurrenceWithoutEvent();
                $('#menubar').prop("click", null).off("click");
                $('#id-button-favorites').prop("click", null).off("click");
            }
        });

    });

    

	/**
	 * Evento click button to execute record occurrence
	 */
    $('#offcanvas-record-occurrence-submite').on('click', function () {
        if (!$('#offcanvas-record-occurrence').hasClass('active'))
            $('[href="#offcanvas-record-occurrence"]').trigger('click');
    });

	/**
     * Event click button execute search event occurrence
     */
    $('#occurrence-search-btn, #open-offcanvas-map-list').on('click', function () {

        // Execute SearchOccurrence
        myOccurrences.SearchOccurrence();

    });

    /**
     * Event click button execute search event occurrence [EVENT]
     */
    $('#id-occurrence-event-search-btn').on('click', function () {

        // Execute SearchOccurrence
        myOccurrences.SearchOccurrenceEvent();
    });

	/**
	 * Event click button execute search event occurrence
	 */
    $('#creation-occurrence-submite').on('click', function () {
        myOccurrences._CreateOccurrenceWithoutEvent();
    });

	/**
	 * Event on change select type occurrence search
	 */
    $('#occurrence-search-select-type').on('change.bs.select', function () {
        var codType = $('#occurrence-search-select-type').val();
        var arraySubtype = myOccurrences._hashReference['occurrence_subtype'][codType];
        myOccurrences._utility.FillSelect('occurrence-search-select-subtype', arraySubtype, 'description', 'cod_subtype');
    });

    /**
	 * Event on change select type occurrence creation
	 */
    $('#creation-occurrence-type-select').on('change.bs.select', function () {
        var codType = $('#creation-occurrence-type-select').val();
        var arraySubtype = myOccurrences._hashReference['occurrence_subtype'][codType];
        myOccurrences._utility.FillSelect('creation-occurrence-subtype-select', arraySubtype, 'description', 'cod_subtype');
    });

    //Event to change all SubType when user select one type [EVENT]
    $('#id-event-occurrence-search-select-type').on('change.bs.select', function () {
        var codType = $('#id-event-occurrence-search-select-type').val();
        var arraySubtype = myOccurrences._hashReference['occurrence_subtype'][codType];
        myOccurrences._utility.FillSelect('id-event-occurrence-event-subtype', arraySubtype, 'description', 'cod_subtype');
    });

    /**
     * Event on change select type occurrence detail
     */
    $('#occurrence-detail-type-select').on('change.bs.select', function () {
        var codType = $('#occurrence-detail-type-select').val();
        var arraySubtype = myOccurrences._hashReference['occurrence_subtype'][codType];
        myOccurrences._utility.FillSelect('occurrence-detail-subtype-select', arraySubtype, 'description', 'cod_subtype');
    });

    /**
     * Event on change select type occurrence detail
     */
    $('#occurrence-event-detail-type-select').on('change.bs.select', function () {
        var codType = $('#occurrence-event-detail-type-select').val();
        var arraySubtype = myOccurrences._hashReference['occurrence_subtype'][codType];
        myOccurrences._utility.FillSelect('occurrence-event-detail-subtype-select', arraySubtype, 'description', 'cod_subtype');
    });

    /**
     * Event on change select department team
     */
    $('#name-select-occurrence-team').on('change.bs.select', function () {
        myOccurrences._DetailModalOccurrenceTeam($('#name-select-occurrence-team').val(), 'ChangeDepartmentTeam');
    });

	/**
	 * Goto button click
	 */
    $('#goto-occurrence-go-btn').on('click', function () {
        // Execute
        app.execGotoRailroad();
    });

   /**
	* Event click save state occurrence detail
	*/
    $('#occurrence-detail-state-save-button').on('click', function () {
        myOccurrences._utility.ShowOpenCanvas(false);
        $('#modal-Save-Occurrence').css({ 'display': 'block' });
    });

    /**
     * Event click notify occurrence detail
     */
    $('#occurrence-detail-notify-button').on('click', function () {

        $('#id-modal-email-body-msg-definition-to').val('');

        // Occurrence event state
        var cod_state = $('#occurrence-detail-state-select').val();

        // Only notify if cod_state == 'FECHADA''
        if (cod_state !== 'FECHADA') {
            toastr["warning"]("Só é possível notificar se o estado for igual a Fechada");
            return;
        }

        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-event-details', true);

        // Id occurrence event
        var idOccurrence = $('#id_occurrence_detail').val();

        // Id User
        var idUser = myOccurrences._mapSgs._settings.userInfo.userId;

        // Clean user notification info
        myOccurrences._occurrenceEventEmailNotificationInfo = null;

        // Clean email form
        myOccurrences._email.CleanEmailForm();

        $('#id-modal-email-IdEntity').val(idOccurrence);

        $('#id-modal-email-NameEntity').val('Occurrence');

        $('#id-modal-email-cod_notification_action').val('NOTIFICATION_EXTERNAL_USER');

        $.ajax({
            type: 'GET',
            url: '/rest/app/Occurrence/GetEmailNotificationInfoForOccurrence?id=' + idOccurrence + "&idUser=" + idUser,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da informação da notificação por email");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':

                            //Get Id User Created
                            $('#id-modal-email-IdUserCreated').val(data.result.owner_occurrence.id_user)

                            // set user notification info
                            myOccurrences._occurrenceEventEmailNotificationInfo = data.result.email_notification_info;

                            // Only notify if cod_state == 'FECHADO' OR 'CANCELADO'
                            var cod_state = data.result.owner_occurrence.cod_state;
                            if (cod_state !== 'FECHADA') {
                                toastr["warning"]("Só é possível notificar se o estado for igual a Fechado ou Cancelado");

                                // Stop wait
                                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);

                                return;
                            }

                            for (i = 0; i < myOccurrences._occurrenceEventEmailNotificationInfo.length; i++) {
                                // Set to
                                if (myOccurrences._occurrenceEventEmailNotificationInfo[i].emailAddress) {
                                    $('#id-modal-email-body-msg-definition-bcc').val($('#id-modal-email-body-msg-definition-bcc').val() + myOccurrences._occurrenceEventEmailNotificationInfo[i].emailAddress + ';' );
                                }
                            }


                            for (i = 0; i < data.result.list_department_resolution.length; i++) {
                                // Set to
                                if (data.result.list_department_resolution[i].email) {
                                    $('#id-modal-email-body-msg-definition-bcc').val($('#id-modal-email-body-msg-definition-bcc').val() + data.result.list_department_resolution[i].email + ';');
                                }
                            }

                            // Set subject
                            var msg = "";
                            if (cod_state === 'FECHADA') {
                                msg = "Ocorrência nº" + idOccurrence + " foi fechada";
                            }
                            $('#id-modal-email-body-msg-definition-subject').val(msg);

                            if (data.result.list_email_send)
                                myOccurrences._DrawNotificationDatatable(data.result.list_email_send);

                            // Show modal
                            myOccurrences._utility.ShowOpenCanvas(true);
                            $('#id-modal-email').css({ 'display': 'block' });

                            break;
                        case "ERROR":
                            toastr["error"]("Erro na obtenção da informação da notificação por email");
                            break;
                        default:
                    }
                }
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da informação da notificação por email");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            }
        });

    });

   /**
    * Event click save state occurrence event detail
    */
    $('#occurrence-event-detail-state-save-button').on('click', function () {
        myOccurrences._utility.ShowOpenCanvas(false);
        $('#modal-save-occurrence-event-state').css({ 'display': 'block' });
    });

    /**
     * Event open notify occurrence event modal
     */
    $('#occurrence-event-detail-notify-button').on('click', function () {
        // Start wait
        myOccurrences._utility.ShowWait('spinner-occurrence-event-details', true);

        // Id occurrence event
        var idOccurrenceEvent = parseInt($('#id_occurrence_event_detail').val());

        // Id User
        var idUser = myOccurrences._mapSgs._settings.userInfo.userId;

        // Clean user notification info
        myOccurrences._occurrenceEventEmailNotificationInfo = null;

        // Clean email form
        myOccurrences._email.CleanEmailForm();

        $('#id-modal-email-IdEntity').val(idOccurrenceEvent)

        $('#id-modal-email-NameEntity').val('OccurrenceEvent')

        $('#id-modal-email-cod_notification_action').val('NOTIFICATION_EXTERNAL_USER');

        $.ajax({
            type: 'GET',
            url: '/rest/app/Occurrence/GetEmailNotificationInfoForOccurrenceEvent?id=' + idOccurrenceEvent + "&idUser=" + idUser,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da informação da notificação por email");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':

                            //Get Id User Created
                            $('#id-modal-email-IdUserCreated').val(data.result.email_notification_info.user_owner.id)

                            // set user notification info
                            myOccurrences._occurrenceEventEmailNotificationInfo = data.result.email_notification_info;

                            // Only notify if cod_state == 'FECHADO' OR 'CANCELADO'
                            var cod_state = myOccurrences._occurrenceEventEmailNotificationInfo.cod_state;
                            if (cod_state !== 'FECHADO' && cod_state !== 'CANCELADO') {
                                toastr["warning"]("Só é possível notificar se o estado for igual a Fechado ou Cancelado");

                                // Stop wait
                                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);

                                return;
                            }

                            // Set to
                            if (myOccurrences._occurrenceEventEmailNotificationInfo.user_owner.email) {
                                $('#id-modal-email-body-msg-definition-to').val(myOccurrences._occurrenceEventEmailNotificationInfo.user_owner.email);
                            }

                            // Set subject
                            var msg = "";
                            if (cod_state === 'FECHADO') {
                                msg = "Ocorrência nº" + idOccurrenceEvent + " foi fechada";
                            }
                            if (cod_state === 'CANCELADO') {
                                msg = "Ocorrência nº" + idOccurrenceEvent + " foi cancelada";
                            }
                            $('#id-modal-email-body-msg-definition-subject').val(msg);

                            if (data.result.list_email_send)
                                myOccurrences._DrawNotificationDatatable(data.result.list_email_send);

                            // Show modal
                            myOccurrences._utility.ShowOpenCanvas(true);
                            $('#id-modal-email').css({ 'display': 'block' });
                            break;
                        case "ERROR":
                            toastr["error"]("Erro na obtenção da informação da notificação por email");
                            break;
                        default:
                    }
                }
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da informação da notificação por email");
                // Stop wait
                myOccurrences._utility.ShowWait('spinner-occurrence-event-details', false);
            }
        });
    });

    /**
     * Event close notify occurrence event modal
     */
    $('#id-modal-email-cancel').on('click', function () {
        $('#id-modal-email').toggle('ol-hidden');
    });

	/**
	 * Event click save modal description
	 */
    $('#modal-Save-Occurrence-Button').on('click', function () {
        myOccurrences._utility.ShowOpenCanvas(true);
        $('#modal-Save-Occurrence').css({ 'display': 'none' });
        var state = $("#occurrence-detail-state-select").val();
        var description = $('#modal-description-detail-occurrence').val();
        myOccurrences._SaveStateOccurrence(state, description);

        if (state == 'FECHADA')
            myOccurrences._sendemailifstateoccurrececlose();

    });

    /**
     * Event click save modal description for occurrence event state
     */
    $('#modal-save-occurrence-event-button').on('click', function () {
        myOccurrences._utility.ShowOpenCanvas(true);
        $('#modal-save-occurrence-event-state').css({ 'display': 'none' });
        var state = $("#occurrence-event-detail-state-select").val();
        var description = $('#modal-description-detail-occurrence-event').val();
        myOccurrences._SaveStateOccurrenceEvent(state, description);
    });

	/**
	 * Event on click cancel modal
	 */
    $('#modal-cancel-button').on('click', function () {
        myOccurrences._utility.ShowOpenCanvas(true);
        $('#modal-Save-Occurrence').css({ 'display': 'none' });
    });

    /**
     * Event on click cancel modal occurrence event state description
     */
    $('#modal-cancel-event-state-description-button').on('click', function () {
        myOccurrences._utility.ShowOpenCanvas(true);
        $('#modal-save-occurrence-event-state').css({ 'display': 'none' });
    });

    /**
     * Event checkbox change view search occurrence in map
     */
    $('#offcanvas-search-event-layer-visible').on('change', function () {
        if (myOccurrences._arraySearchFeatureActive && myOccurrences._arraySearchFeatureActive.length > 0) {
            if (myOccurrences._searchCheckbox.state() === 'checked') {
                myOccurrences._mapSgs.SetFeaturesHighlightByFeatureCol(myOccurrences._arraySearchFeatureActive, true);

                //myOccurrences._mapSgs.map.getView({
                //    center: [myOccurrences._mapSgs.layerHighlightOverlay.getSource().getExtent()[0], myOccurrences._mapSgs.layerHighlightOverlay.getSource().getExtent()[1]],
                //    zoom: 10
                //});
                //myOccurrences._mapSgs.map.getView().setZoom(myOccurrences.ZoomSearch)

                myOccurrences._mapSgs.map.getView().setResolution("2.8");
            }
            else {
                myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear();
            }
        }
    });

    /**
     * Event goto occurrence search in map 
     */
    $('#offcanvas-search-event-layer-goto').on('click', function () {
        myOccurrences._mapSgs.map.getView().fit(myOccurrences._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myOccurrences._mapSgs.map.getSize() });
    });

    /**
     * Event on click to confirm description
     */
    $('#modal-confirm-description').on('click', function () {
        myOccurrences._utility.ShowOpenCanvas(true);
        $('#modal-description-occurrence-detail').css({ 'display': 'none' });
    });

	/**
	 * Event on click to open team occurrence detail
	 */
    $('#button-add-team-occurrence').on('click', function () {
        //Clean dropdown Type
        $('#name-select-occurrence-team').val('').change();
        myOccurrences._DetailModalOccurrenceTeam($('#name-select-occurrence-team').val(), 'saveTeamToOccurrence');
    });

    /**
	 * Event on click to close team occurrence detail
	 */
    $('#modal-cancel-team-button').on('click', function () {
        myOccurrences._utility.ShowOpenCanvas(true);
        $('#modal-team-Occurrence-detail').css({ 'display': 'none' });
    });

	/**
	 * Event on click to add team to occurrence
	 */
    $('#modal-team-occurrence-add-button').on('click', function () {

        if ($('#offcanvas-detail-team-check-table tr .remove-team-datatable-id').length > 0) {
            var IdTeamOccurrence = [];
            var idOccurrence = $('#id_occurrence_detail').val();
            var codDepartment = $('#name-select-occurrence-team').val();
            for (var i = 0; i < myOccurrences._datatableDetailOccurrenceTeamCheck.data().length; i++) {
                IdTeamOccurrence[i] = myOccurrences._datatableDetailOccurrenceTeamCheck.data()[i].id;
            }
            myOccurrences._AddTeamToOccurence(IdTeamOccurrence, idOccurrence, codDepartment);
            myOccurrences._utility.ShowOpenCanvas(true);
            $('#modal-team-Occurrence-detail').css({ 'display': 'none' });
        }
        else {
            toastr["warning"]("Seleccione primeiro um equipa");
        }
    });

    /**
     * Event on click open modal atchment
     */
    $('#creation-occurrence-attachment').on('click', function () {
        $('#modal-attachment').addClass('ol-show');
    });

    /**
     * Collapse/open info in occurrence detail
     */
    $('.occurrence-detail-collapse').on('click', function () {
        var idNodeToCollapse = this.getAttribute('target-id');
        $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
        // Close all other info

        // Open/close element
        $('#' + idNodeToCollapse).toggle('ol-hidden', function () {
            // Ajust column table
            $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
        });

    });

    /**
     * Event add comment team occurrence on click
     */
    $('.occurrence-detail-team-add-comment').on('click', function () {
        $('#modal-occurrence-detail-team-comment').css({ 'display': 'block' });
    });

    /**
     * Event save comment team occurrence on click
     */
    $('#modal-occurrence-detailt-team-save-comment').on('click', function () {
        $('#modal-occurrence-detail-team-comment').css({ 'display': 'none' });
    });

    /**
     * Event add new department to occurrence
     */
    $('#occurrence-detail-department-add-button').on('click', function () {
        // if Any departement selected then leave
        if (!$('#occurrence-detail-department-select').val()) {
            toastr["warning"]("Seleccione primeiro um departamento");
            return;
        }

        // Get id occurrence
        var idOccurrence = $('#id_occurrence_detail').val();

        // Get department selected
        var codDepartment = $('#occurrence-detail-department-select').val();
        var departmentDescription = $('#occurrence-detail-department-select').find("option:selected").text();

        // If department already selected then leave
        if ($('#occurrence-detail-department-list div[cod-department="' + codDepartment + '"]').length > 0) {
            toastr["warning"]("Departamento já adicionado");
            return;
        }

        // Add new department
        myOccurrences._AddDepartmentOccurrence(idOccurrence, codDepartment, departmentDescription);
    });

    /**
     * Event close modal occurrence
     */
    $('#modal-occurrence-cancel-comment').on('click', function () {
        $('#modal-occurrence-comment').toggle('ol-hidden');
    });

    /**
     * Event save modal occurrence
     */
    $('#modal-occurrence-save-comment').on('click', function () {
        var targetContext = $('#modal-occurrence-comment').attr('target-context');
        var keyContext = $('#modal-occurrence-comment').attr('key-context');
        var comment = $('#modal-occurrence-comment-input').val();

        // Start wait
        myOccurrences._utility.ShowWait('spiner-modal-comment', true);

        switch (targetContext) {
            case "occurrence-detail-department-add-comment":
                var idOccurrence = keyContext.split(myOccurrences._keySeparator)[0];
                var codDepartment = keyContext.split(myOccurrences._keySeparator)[1];
                myOccurrences._AddCommentToDepartmentOccurrence(idOccurrence, codDepartment, comment);
                break;
            case "occurrence-detail-department-update-comment":
                var idComment = keyContext.split(myOccurrences._keySeparator)[0];
                var context = keyContext.split(myOccurrences._keySeparator)[1];
                myOccurrences._UpdateCommentDepartmentOccurrence(idComment, context, comment);
                break;
            case "occurrence-detail-department-team-add-comment":
                var idOccurrence = keyContext.split(myOccurrences._keySeparator)[0];
                var idTeam = keyContext.split(myOccurrences._keySeparator)[1];
                myOccurrences._AddCommentToDepartmentTeamOccurrence(idOccurrence, idTeam, comment);
                break;
            case "occurrence-detail-department-team-update-comment":
                var idComment = keyContext;
                myOccurrences._UpdateCommentDepartmentTeamOccurrence(idComment, comment);
                break;
            case "occurrence-detail-department-update-approval":
                var idOccurrence = keyContext.split(myOccurrences._keySeparator)[0];
                var codDepartment = keyContext.split(myOccurrences._keySeparator)[1];
                var idTargetContext = $('#modal-occurrence-comment').attr('id-target-context');
                // Add comment
                myOccurrences._AddCommentToDepartmentOccurrence(idOccurrence, codDepartment, comment);
                // Update state approval
                myOccurrences._UpdateStateApprovedDepartment(idTargetContext);
                break;
            default:
                toastr["error"]("Erro na adição do commentário");
                // Stop wait
                myOccurrences._utility.ShowWait('spiner-modal-comment', false);
                break;
        }
    });

    /**
     * Event occurrence
     * Highlight btn info state
     */
    $('.occurrence-detail-info-box').on('click', function () {
        myOccurrences._ActionOccurrenceEventBtnInfo(this);
    });

    /**
     * Event create or cancel creation of a occurrence event
     */
    $('#ButtonStartCreationEvent').on('click', function () {
        // Mode Create
        if ($('#ButtonStartCreationEvent').html() !== 'Cancelar Ocorrência') {
            myOccurrences._mapSgs.map.un('singleclick', myOccurrences._mapSgs.tooltips.BuildInfoTooltips);
            myOccurrences._mapSgs._utility.ShowOpenCanvas(false);
            $('#ButtonStartCreationEvent').html('Cancelar Ocorrência');
            myOccurrences._mapSgs.StartCreationEvent = false;
            if (myOccurrences._mapSgs._utility.mobilecheck()) {
                $('#pinCreateEventOccurrence, #pinOnMove').css({ 'display': 'initial' })
                $('.pinArrow').addClass('mobile');
            }
            else {
                $('.pinArrow').removeClass('mobile');
                // Cursor fontawesome
                $('body').awesomeCursor('map-marker', {
                    color: '#204d74',
                    hotspot: [8, 20]
                })
            }
            // Event to occurrence Map on click
            myOccurrences._mapSgs.map.on('click', myOccurrences._CreationEventOccurrenceMakeClickEvent);

        } else { // Mode remove create
            myOccurrences._mapSgs.map.on('singleclick', async (e) => { await myOccurrences._mapSgs.tooltips.BuildInfoTooltips(e); });
            myOccurrences._mapSgs.map.un('click', myOccurrences._CreationEventOccurrenceMakeClickEvent);
            $('#ButtonStartCreationEvent').html('Criar Ocorrência');
            $('#pinCreateEventOccurrence, #pinOnMove').css({ 'display': 'none' });
            myOccurrences._mapSgs.StartCreationEvent = true;
            if (!myOccurrences._mapSgs._utility.mobilecheck()) {
                document.body.style.cursor = 'default';
            }
        }
    });

    /**
     * Call readURL function when a photo its add
     */
    $('#creation-occurrence-event-get-picture').change(function () {
        readURL(this);
    });

    /**
     * Function to draw img on html occurrence event
     */
    function readURL(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                $('#id-imgOccurrenceEvent').attr('src', e.target.result);
                $('#id-imgOccurrenceEvent').css({'display':'initial'})
            }

            reader.readAsDataURL(input.files[0]);
        }
    }

    /**
     * Go back on detail occurrence
     */
    $('#id-offcanvas-detail-occurrence-go-back').on('click', function () {
        if (myOccurrences._occurrenceEventFeatureSelected) {
            if ($('#id-offcanvas-detail-occurrence-go-back').attr('mode') === "CREATION") {

                // Set Detail occurrence event
                var featureInfo = { id: myOccurrences._occurrenceEventFeatureSelected.getProperties().id, feature: myOccurrences._occurrenceEventFeatureSelected, layer_name: "occurrence_event" };
                myOccurrences._DetailOccurrence(featureInfo);

                // Remove mode
                $('#id-offcanvas-detail-occurrence-go-back').attr('mode', '');
            }
            else {
                // -- Open off canvas --
                myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-detail-occurrence-event'], true);
            }
        }
    });

    /**
     * Go back on detail occurrence event
     */
    $('#id-offcanvas-detail-occurrence-event-go-back').on('click', function () {
        // -- Open off canvas --
        myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-detail-occurrence'], true);
    });

    /**
     * Go to occurrence in map
     */
    $('#id-offcanvas-detail-occurrence-goto-map').on('click', function ()
    {
        var idOccurrence = $('#id_occurrence_detail').val();
        //var idFeature = "occurrence." + idOccurrence;
        var idFeature = idOccurrence;

        // Remove highlight
        myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear();

        // Get layer search occurrence information
        var workspaceOccurrenceConfig = myOccurrences._utility.GetPropertyInfoInConfigArray(myOccurrences._mapSgs.getSettings().configurationInfo.propertyInfo, "OCCURRENCE", "SEARCH_OCCURRENCE", "WORKSPACE");
        var workspaceOccurrence = (workspaceOccurrenceConfig === undefined)?myOccurrences._workspace:workspaceOccurrenceConfig.value;

        //Go to occurrence
        myOccurrences._mapSgs.SetFeaturesHighlightByArray(workspaceOccurrence, myOccurrences._layerSourceNameOccurrence, false, [idFeature], myOccurrences._occurrenceHighlighStyles);
    });

    /**
     * Go to occurrence event in map
     */
    $('#id-offcanvas-detail-occurrence-event-goto-map').on('click', function () {
        var idOccurrenceEvent = $('#id_occurrence_event_detail').val();
        var idFeature = myOccurrences._layerSourceNameOccurrenceEvent + "." + idOccurrenceEvent;

        // Remove highlight
        myOccurrences._mapSgs.layerHighlightOverlay.getSource().clear();

        // Get layer search occurrence event information
        var workspaceOccurrenceEventConfig = myOccurrences._utility.GetPropertyInfoInConfigArray(myOccurrences._mapSgs.getSettings().configurationInfo.propertyInfo, "OCCURRENCE", "SEARCH_OCCURRENCE_EVENT", "WORKSPACE");
        var workspaceOccurrenceEvent = (workspaceOccurrenceEventConfig === undefined)?myOccurrences._workspace:workspaceOccurrenceEventConfig.value;

        //Go to event occurrence
        myOccurrences._mapSgs.SetFeaturesHighlightByArray(workspaceOccurrenceEvent, myOccurrences._layerSourceNameOccurrenceEvent, false, [idFeature], myOccurrences._eventOccurrenceHighlighStyles);
    });

    /**
     * Button create occurrence from occurrence event
     */
    $('#id-occurrence-event-detail-create-occurrence-button').on('click', function () {
        // Clean occurrence detail
        myOccurrences._CleanOccurrenceDetail();

        // Set id user
        $('#occurrence-detail-id-user').val(myOccurrences._mapSgs._settings.userInfo.userId);

        // Set id occurrence event
        $('#occurrence-detail-id-occurrence-event').val($('#id_occurrence_event_detail').val());

        // Set occurrence title
        $('#offcanvas-head-occurrence-title')[0].innerHTML = "Nova Ocorrência";

        // Set occurrence wihtout id number
        $('#offcanvas-head-id-occurrence')[0].innerHTML = "";

        // -- Open occurrence canvas --
        myOccurrences._utility.ShowOpenCanvas(false, ['offcanvas-detail-occurrence'], true);

        // Go back to event
        $('#id-offcanvas-detail-occurrence-go-back').removeClass('ol-hidden');

        // Hide tab not used
        $('.occurrence-detail-create-not-use').addClass('ol-hidden');

        // Open detail info
        if( !$('#occurrence-detail-info').is(':visible') )
            $('#occurrence-detail-info').toggle('ol-hidden');

        // Copy type from occurrence event
        var codType = $('#occurrence-event-detail-type-select').val();

        if (codType) {
            $('#occurrence-detail-info-form [name=cod_type]').val(codType);
            $('#occurrence-detail-info-form [name=cod_type]').selectpicker("refresh");
            var arraySubtype = myOccurrences._hashReference['occurrence_subtype'][codType];
            myOccurrences._utility.FillSelect('occurrence-detail-subtype-select', arraySubtype, 'description', 'cod_subtype');
        }

        // Copy subtype from occurrence event
        var codSubType = $('#occurrence-event-detail-subtype-select').val();
        if (codType && codSubType) {
            $('#occurrence-detail-info-form [name=cod_subtype]').val(codSubType);
            $('#occurrence-detail-info-form [name=cod_subtype]').selectpicker("refresh");
        }

        // Define button create Occurrence
        $('#occurrence-detail-save-button').attr('mode', 'CREATE');
        $('#occurrence-detail-save-button').attr('title', 'Criar ocorrência');
    });

    /**
     * Create or save occurrence
     */
    $('#occurrence-detail-save-button').on('click', function () {
        var mode = $(this).attr('mode');

        switch (mode) {
            case "CREATE":
                myOccurrences._CreateOccurrenceFromOccurrenceEvent();
                break;
            case "SAVE":
                myOccurrences._SaveOccurrenceInfo();
                break;
            default:
                // Do nothing
        }
    });

    /**
     * Modal cancel/ok - Confirm event click
     */
    $('#modal-confirm-ok-cancel').on('click', function () {
        switch ($('#modal-ok-cancel').attr('mode')) {
            case "REMOVE_TEAM_OCCURRENCE":
                // Get id occurrence
                var idOccurrence = $('#modal-ok-cancel').attr('id-occurrence');
                var idTeam = $('#modal-ok-cancel').attr('id-team');

                myOccurrences._RemoveTeamOccurrence(idOccurrence, idTeam);
                break;
            case "REMOVE_DEPARTMENT_OCCURRENCE":
                // Show occurrence detail
                myOccurrences._utility.ShowOpenCanvas(true);
                $('#modal-ok-cancel').css({ 'display': 'none' });

                // Start wait
                myOccurrences._utility.ShowWait('spinner-occurrence-details', true);

                // Get id occurrence
                var idOccurrence = $('#modal-ok-cancel').attr('id-occurrence');
                var codDepartment = $('#modal-ok-cancel').attr('cod-department');

                $.ajax({
                    type: 'DELETE',
                    url: '/rest/app/Occurrence/DeleteDepartmentOccurrence?idOccurrence=' + idOccurrence + '&codDepartment=' + codDepartment,
                    contentType: "application/json",
                    async: true,
                    success: function (data) {
                        if (data.error) {
                            toastr["error"]("Erro na remoção do departamento");
                        }
                        else {
                            switch (data.result.status) {
                                case 'SUCCESS':
                                    // Remove Department from list department
                                    var idOccurrenceDepartment = "occurrence-detail-department-" + idOccurrence + "-" + codDepartment;
                                    $('#' + idOccurrenceDepartment).remove();

                                    // Remove Department from list team
                                    var idOccurrenceDepartmentTeam = "occurrence-detail-department-team-" + idOccurrence + "-" + codDepartment;
                                    $('#' + idOccurrenceDepartmentTeam).remove();

                                    toastr["success"]("Departamento removido com sucesso");
                                    break;
                                default:
                                    toastr["error"]("Erro na remoção do departamento");
                            }
                        }

                        // Stop wait
                        myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
                    },
                    error: function (request, status, error) {
                        toastr["error"]("Erro na remoção do departamento");
                        // Stop wait
                        myOccurrences._utility.ShowWait('spinner-occurrence-details', false);
                    }
                });
                break;
            default:
                // do nothing
        }
    });

    /**
     * Modal cancel/ok - Cancel event click
     */
    $('#modal-cancel-ok-cancel').on('click', function () {
        myOccurrences._utility.ShowOpenCanvas(true);
        $('#modal-ok-cancel').css({ 'display': 'none' });
    });

    /**
     * Ajust table on show tab
     */
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
    });

    /**
     * Button show Street View from occurrence 
     */
    $('#id-offcanvas-body-layer-detail-streetview-open').on('click', function () {
        var panorama;
        var occurrence_lat = parseFloat($('#occurrence-detail-lat').val());
        var occurrence_lng = parseFloat($('#occurrence-detail-lng').val());

        panorama = new google.maps.StreetViewPanorama(
            document.getElementById('id-modal-body-streetview'),
            {
                position: { lat: occurrence_lat, lng: occurrence_lng },
                pov: { heading: 165, pitch: 0 },
                zoom: 1
            });
        $('#id-modal-streetview').css({ 'display': 'block' });
    });

    /**
     * Event cancel street view
     */
    $('#id-modal-streetview-cancel').on('click', function () {
        $('#id-modal-streetview').toggle('ol-hidden');
    });

    /**
     * Event search occurrence event - list last event
     */
    $('#id-event-occurrence-search-last-event').on('change', function () {
        $('#id-form-search-occurrence-event-all').toggle('ol-hidden');
    });

    /**
     * Event search occurrence - list last event
     */
    $('#id-occurrence-search-last-event').on('change', function () {
        $('#id-form-search-occurrence-all').toggle('ol-hidden');
    });

    /**
     * Event report occurrence
     */
    $('#occurrence-detail-report-button').on('click', function () {

        if (myOccurrences._mapSgs.getSettings().getVisibleOperations().Occurrence != null && myOccurrences._mapSgs.getSettings().getVisibleOperations().Occurrence.createOccurrenceWithoutEvent) {
            OccurrenceFuncionality = true;
        }

        var Client = myOccurrences._mapSgs._settings._mapSettings.search_toponymy.workspaceSearchToponymy;

        var OccurrenceFuncionality = false;

        var url = '/ReportOccurrence?mode=occurrence&id=' + $('#occurrence-detail-id-occurrence').val() + "&OccurrenceFuncionality=" + OccurrenceFuncionality + "&Client=" + Client;
        window.open(url, '_blank');
    });

    /**
     * Event report occurrence global
     */
    $('#id-occurrence-report-global-btn').on('click', function () {
        var dateBegin = $('#occurrence-report-date-begin').val();
        var dateEnd = $('#occurrence-report-date-end').val();
        var OccurrenceFuncionality = false;
        var Client = myOccurrences._mapSgs._settings._mapSettings.search_toponymy.workspaceSearchToponymy;

        if (myOccurrences._mapSgs.getSettings().getVisibleOperations().Occurrence != null && myOccurrences._mapSgs.getSettings().getVisibleOperations().Occurrence.createOccurrenceWithoutEvent) {
            OccurrenceFuncionality = true;
        }

        

        if(dateBegin === "") {
            toastr["warning"]("Define uma data de início");
            return;
        }

        if(dateEnd === "") {
            toastr["warning"]("Define uma data de Fim");
            return;
        }

        var dateBeginObj = new Date(dateBegin);
        var dateEndObj = new Date(dateEnd);

        if( dateBeginObj > dateEndObj) {
            toastr["warning"]("A data de início não pode ser maior do que a data de fim");
            return;
        }

        var url = '/ReportOccurrence?mode=global&dateBegin=' + dateBegin + "&dateEnd=" + dateEnd + "&OccurrenceFuncionality=" + OccurrenceFuncionality + "&Client=" + Client;
        window.open(url, '_blank');
    });

    $('#occurrence-create-polygon-button').on('click', function () {
        app.layerDrawLine.getSource().clear();
        app.layerDrawPoint.getSource().clear();
        app.layerDraw.getSource().clear();
        app.Draw.setActive(true);
        myOccurrences._mapSgs.map.un('singleclick', myOccurrences._mapSgs.tooltips.BuildInfoTooltips);
        $('#occurrence-confirm-polygon-button').removeClass('ol-hidden');
        $('#occurrence-cancel-polygon-button').removeClass('ol-hidden');
        $('#occurrence-create-polygon-button').addClass('ol-hidden');
    });

    $('#occurrence-confirm-polygon-button').on('click', function () {

        // Stop wait
        myOccurrences._utility.ShowWait('id-offcanvas-body-detail-task-spinner', true);

        //var _occurrenceSearchForm = $('#form-search-occurrence').serializeJSON();

        var occurrenceIntervention = $('').serializeJSON();

        // Get geom
        var geom = app.layerDraw.getSource().getFeatures()[0];
        if (geom === undefined) {
            toastr["warning"]("Desenhe primeiro no mapa um polígono");
            // Stop wait
            //myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);

            return;
        }

        var srid = myOccurrences._mapSgs._settings.projection.getCode().replace('EPSG:', '');
        var geom_wkt = new WKT().writeGeometry(geom.getGeometry());

        occurrenceIntervention.srid = srid
        occurrenceIntervention.geom = geom_wkt;
        occurrenceIntervention.id_occurrence = $('#id_occurrence_detail').val();

        $.ajax({
            type: 'POST',
            url: '/rest/app/Occurrence/CreateOccurrenceInterventionZone',
            data: JSON.stringify(occurrenceIntervention),
            dataType: 'json',
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na remoção do departamento");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            toastr["success"]("Zona de intervenção criada com sucesso");

                            //Get occurrence intervention zone
                            occurrenceinterventiozoneData = data.result.occurrenceinterventiozone;

                            $('#occurrence-create-polygon-button').addClass('ol-hidden');
                            $('#occurrence-confirm-polygon-button').addClass('ol-hidden');
                            $('#occurrence-cancel-polygon-button').addClass('ol-hidden');
                            $('#occurrence-view-polygon-button').removeClass('ol-hidden');
                            $('#occurrence-delete-polygon-button').removeClass('ol-hidden');
                            myOccurrences._mapSgs.map.on('singleclick', async (e) => { await myOccurrences._mapSgs.tooltips.BuildInfoTooltips(e); });
                            // Stop wait
                            myOccurrences._utility.ShowWait('id-offcanvas-body-detail-task-spinner', false);
                    }
                }

                // Stop wait
                myOccurrences._utility.ShowWait('id-offcanvas-body-detail-task-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na remoção do departamento");

                myOccurrences._mapSgs.map.on('singleclick', async (e) => { await myOccurrences._mapSgs.tooltips.BuildInfoTooltips(e); });
                // Stop wait
                myOccurrences._utility.ShowWait('id-offcanvas-body-detail-task-spinner', false);
            }
        });

        app.layerDraw.getSource().clear();
        app.Draw.setActive(false);

    });

    $('#occurrence-cancel-polygon-button').on('click', function () {
        app.layerDraw.getSource().clear();
        app.Draw.setActive(false);
        myOccurrences._mapSgs.map.on('singleclick', async (e) => { await myOccurrences._mapSgs.tooltips.BuildInfoTooltips(e) });
        $('#occurrence-confirm-polygon-button').addClass('ol-hidden');
        $('#occurrence-cancel-polygon-button').addClass('ol-hidden');
        $('#occurrence-create-polygon-button').removeClass('ol-hidden');
    });

    $('#cancel-event-occurrence-map').on('click', function () {
        app.layerDraw.getSource().clear();
        app.Draw.setActive(false);
        myOccurrences._mapSgs.map.on('singleclick', async (e) => { await myOccurrences._mapSgs.tooltips.BuildInfoTooltips(e); });
        myOccurrences._DrawPintoCreateOccurrenceWithoutEvent();
        $('#occurrence-confirm-polygon-button').addClass('ol-hidden');
        $('#occurrence-cancel-polygon-button').addClass('ol-hidden');
        $('#occurrence-create-polygon-button').removeClass('ol-hidden');
    });

    $('#occurrence-view-polygon-button').on('click', function () {

        if ($('#occurrence-view-polygon-button').hasClass('fa-eye')) {

            if (Layeinterventionzone != "")
                myOccurrences._mapSgs.map.removeLayer(Layeinterventionzone);

            var Polygon = new WKT();

            var feature = Polygon.readFeature(occurrenceinterventiozoneData.geom_wkt, {
            });

            Layeinterventionzone = new VectorLayer({
                source: new VectorSource({
                    features: [feature]
                })
            });

            $('#occurrence-view-polygon-button').removeClass('fa-eye')
            $('#occurrence-view-polygon-button').addClass('fa-eye-slash')

            myOccurrences._mapSgs.map.addLayer(Layeinterventionzone);

            //$('#id-offcanvas-detail-occurrence-goto-map').trigger('click');

        } else {

            myOccurrences._mapSgs.map.removeLayer(Layeinterventionzone);
            $('#occurrence-view-polygon-button').addClass('fa-eye')
            $('#occurrence-view-polygon-button').removeClass('fa-eye-slash')

        }

    });

    $('#occurrence-delete-polygon-button').on('click', function () {

        var idOccurrence = $('#id_occurrence_detail').val();

        $.ajax({
            type: 'DELETE',
            url: '/rest/app/Occurrence/DeleteInterventionZone?idOccurrence=' + idOccurrence,
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na remoção da Zona de intervenção");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            toastr["success"]("Zona de intervenção eliminada com sucesso");

                            $('#occurrence-create-polygon-button').removeClass('ol-hidden');
                            $('#occurrence-confirm-polygon-button').removeClass('ol-hidden');
                            $('#occurrence-cancel-polygon-button').removeClass('ol-hidden');
                            $('#occurrence-view-polygon-button').addClass('ol-hidden');
                            $('#occurrence-delete-polygon-button').addClass('ol-hidden');

                            // Stop wait
                            myOccurrences._utility.ShowWait('id-offcanvas-body-detail-task-spinner', false);
                    }
                }

                // Stop wait
                myOccurrences._utility.ShowWait('id-offcanvas-body-detail-task-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na remoção da Zona de intervenção");

                // Stop wait
                myOccurrences._utility.ShowWait('id-offcanvas-body-detail-task-spinner', false);
            }
        });
         
    });

    $('#creation-occurrence-type-select').on('change', function () {

        if ($('#creation-occurrence-type-select').val() == 'INTERVENCOES_PLANEADAS')
            $('#id-date-creation-planned-occurrence').toggle('ol-hidden');
        else if ($('#id-date-creation-planned-occurrence').is(':visible'))
            $('#id-date-creation-planned-occurrence').toggle('ol-hidden');

    });

    $('.cancel-without-event-occurrence-map').on('click', function () {

        myOccurrences._DrawPintoCreateOccurrenceWithoutEvent();
    });

	// -- end event -------------------------------------------------------------------------------
};